{
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "add": "Add",
    "search": "Search",
    "loading": "Loading...",
    "error": "Error",
    "success": "Success",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "close": "Close",
    "appName": "{brand}",
    "searchPlaceholder": "Search...",
    "connectionReconnecting": "Reconnecting...",
    "connectionLostClickRetry": "Connection lost. Click to retry.",
    "connectionOffline": "Offline",
    "searchExpandedPlaceholder": "Search features or docs...",
    "searchPromptEmpty": "Type to search features or related documents",
    "searchSectionApplication": "Application",
    "searchSectionDocumentation": "Documentation",
    "searchNoFeatureResults": "No features match this query",
    "searchNoDocResults": "No documentation match this query",
    "description": "Description",
    "preview": "Preview",
    "addTag": "Add tag...",
    "searchProjects": "Search projects...",
    "searchModels": "Search models...",
    "all": "All",
    "favorites": "Favorites",
    "searchResource": "Search {{resource}}...",
    "selectAll": "Select all",
    "clearAll": "Clear all",
    "resetToDefault": "Reset to default",
    "noOptionsAvailable": "No options available",
    "noMoreItems": "No more items",
    "clearSearch": "Clear search",
    "apply": "Apply",
    "clear": "Clear",
    "yes": "Yes",
    "no": "No",
    "notResource": "Not {{resource}}",
    "afterDate": "After {{date}}",
    "beforeDate": "Before {{date}}",
    "removeFilter": "Remove {{label}} filter",
    "removeFilterWithColon": "Remove filter: {{label}}",
    "showResource": "Show {{resource}}",
    "hideResource": "Hide {{resource}}",
    "saveChanges": "Save Changes",
    "processing": "Processing...",
    "copy": "Copy",
    "copied": "Copied",
    "or": "or",
    "filters": "Filters",
    "searchItem": "Search {{item}}...",
    "searchItemAria": "Search {{item}}",
    "searchPrompts": "Search prompts...",
    "showItem": "Show {{item}}",
    "hideItem": "Hide {{item}}"
  },
  "productDocs": {
    "title": "Product documentation",
    "lead": "Guides for getting started, models, tools, Agent Studio, observability, and administration — served from the same site as the platform.",
    "openNewTab": "Open in new tab",
    "openSameWindow": "Open in this window",
    "hint": "Docs are not shown inside the app shell because some login or edge responses set X-Frame-Options: DENY on pages that are not meant to be embedded. Opening in a new tab or full window keeps clickjacking protection intact and is the recommended way to read documentation."
  },
  "login": {
    "docsLink": "Docs"
  },
  "agentStore": {
    "title": "Agent Store",
    "subtitle": "Discover and deploy enterprise AI agents",
    "search": "Search agents by name...",
    "manage": "Manage",
    "manageTooltip": "Manage Agent Store",
    "loading": "Loading agents...",
    "all": "All",
    "allAgents": "All Agents",
    "allAgentsCount": "All Agents ({{count}})",
    "resultsFound_one": "{{count}} Agent Found",
    "resultsFound_other": "{{count}} Agents Found",
    "view": "View",
    "open": "Open",
    "openApp": "Open App",
    "pending": "Pending",
    "subscribe": "Subscribe",
    "unnamedAgent": "Agent",
    "categoryOther": "Other",
    "noDescription": "No description available",
    "noAgents": "No agents found",
    "noAgentsInCategory": "No agents found in {{category}}",
    "tryAdjusting": "Try adjusting your search or filter criteria"
  },
  "catalogFilters": {
    "filters": "Filters",
    "filtersApplied": "Filters ({{count}} applied)",
    "clearAll": "Clear all",
    "creator": "Creator",
    "allCreators": "All Creators",
    "searchCreators": "Search creators...",
    "rating": "Rating",
    "allRatings": "All Ratings",
    "rating5": "5 stars",
    "rating4Up": "4 stars & up",
    "rating3Up": "3 stars & up",
    "allOf": "All {{label}}",
    "agentType": "Agent Type",
    "allAgentTypes": "All Types",
    "agentTypeNative": "Native",
    "agentTypeExternal": "External"
  },
  "nav": {
    "home": "Home",
    "overview": "Overview",
    "ideate": "Decision Intelligence Platform",
    "solutions": "Solutions",
    "agentStore": "Agent Store",
    "workflowStore": "Workflow Store",
    "projects": "Projects",
    "data": "Data",
    "agentStudio": "Agent Studio",
    "agentWorkflows": "Agent Workflows",
    "registry": "Registry",
    "registryUnified": "Registry",
    "aiTransparency": "AI Transparency",
    "workflowRegistry": "Workflow Registry",
    "agentDeployments": "Agent Deployments",
    "workflowDeployments": "Workflow Deployments",
    "workflowStoreBrowse": "Browse Workflows",
    "workflowStoreManage": "Manage Workflow Store",
    "workflowStoreAbout": "Workflow Details",
    "simulations": "Simulations",
    "evalsSimulations": "Evaluations",
    "benchmarks": "Benchmarks",
    "monitoring": "Monitoring",
    "cache": "Cache",
    "agentEvals": "Agent Evals",
    "evalTemplates": "Eval Templates",
    "environments": "Environments",
    "evaluations": "Evaluations",
    "agents": "Agents",
    "models": "Models",
    "tools": "Tools",
    "prompts": "Prompts",
    "skills": "Skills",
    "knowledge": "Knowledge",
    "connections": "Connections",
    "docs": "Docs",
    "admin": "Admin",
    "platformAdmin": "Platform Admin",
    "settings": "Settings",
    "chat": "Chat",
    "goToHome": "Go to Home",
    "userMenu": "User menu",
    "account": "Account",
    "switchRole": "Switch Role",
    "tenant": "Tenant",
    "logout": "Logout",
    "help": "Help",
    "helpDocumentation": "Help & Documentation",
    "themeDarkModeTitle": "Dark mode",
    "themeLightModeTitle": "Light mode",
    "themeSwitchToDarkAria": "Switch to dark mode",
    "themeSwitchToLightAria": "Switch to light mode",
    "sections": {
      "agentDevelop": "Agent Develop",
      "observability": "Observability",
      "agentOps": "Agent Ops",
      "resources": "Resources",
      "admin": "Admin",
      "aiBlueprints": "Blueprints",
      "enterpriseOntology": "Enterprise Ontology"
    },
    "blueprints": "Blueprints",
    "autopilot": "Ideate",
    "brandMilkyway": "{brand}",
    "brandPlatform": "{brand} Platform",
    "switchToMilkyway": "{brand}",
    "switchToPlatform": "{brand} Platform",
    "ontologyCanvas": "Ontology Canvas",
    "ontoEval": "Onto Eval",
    "buildWithAi": "Ontology Builder",
    "dataModels": "Data Models",
    "kpiLibrary": "KPI Library",
    "semanticHub": "Semantic Hub",
    "migrationsStudio": "Migrations Studio",
    "dataPipelines": "Data Studio",
    "pipelineDesigner": "ML Studio",
    "dataExplorer": "Data Explorer",
    "dataObservability": "Data Observability",
    "switchToDataflow": "{brand} Ontology Studio"
  },
  "appSuites": {
    "launcher": {
      "greeting": "Welcome back, {{name}}",
      "suggested": "Suggested for you",
      "locked": "Ask your administrator for access",
      "empty": "No apps are available for your account yet."
    },
    "switcher": {
      "label": "Switch app",
      "allApps": "All apps"
    },
    "userMenu": {
      "classic": "Classic view",
      "tryApps": "Try the new Aqua apps"
    },
    "admin": {
      "name": "Admin",
      "tagline": "Tenant and platform settings"
    },
    "default": {
      "context": {
        "name": "Context Studio",
        "tagline": "Model your enterprise so agents can reason over it",
        "sections": {
          "ontology": "Ontology",
          "sources": "Data and sources",
          "migrate": "Migrate"
        }
      },
      "ideate": {
        "name": "Ideate",
        "tagline": "Turn ideas into blueprints and working prototypes",
        "sections": {
          "ideate": "Ideate"
        }
      },
      "studio": {
        "name": "Agent Studio",
        "tagline": "Build and orchestrate agents and workflows",
        "sections": {
          "build": "Build",
          "assets": "Assets",
          "connect": "Connect"
        }
      },
      "observability": {
        "name": "Agent Observability",
        "tagline": "Evaluate, optimize and monitor agents in production",
        "sections": {
          "overview": "Overview",
          "quality": "Quality",
          "operate": "Operate"
        }
      }
    }
  },
  "settings": {
    "title": "Settings",
    "description": "Manage your account settings and preferences",
    "profile": "User Profile",
    "appearance": "Appearance",
    "language": "Language",
    "languageDescription": "Choose your preferred language",
    "theme": "Theme",
    "light": "Light",
    "dark": "Dark",
    "appearanceHeading": "Appearance",
    "appearanceSubtitle": "Customize the look and feel of your workspace",
    "colorTheme": "Color Theme",
    "colorThemeDescription": "Choose a color palette for the application",
    "displayModeSection": "Display Mode",
    "displayModeDescription": "Choose between light and dark mode",
    "themeDefaultBadge": "Default",
    "loadingAppearance": "Loading appearance settings...",
    "brandingTitle": "Theme & Language",
    "brandingPlatformSubtitle": "Set the default look and language for all tenants and users on this platform.",
    "brandingTenantSubtitle": "Set the default look and language for users in your organization.",
    "brandingAllowUserOverride": "Allow users to override",
    "brandingAllowUserOverrideHint": "When off, users must use the theme and language you set here.",
    "brandingAllowTenantOverride": "Allow tenant admins to override",
    "brandingAllowTenantOverrideHint": "When off, tenant admins cannot change branding for their organization.",
    "brandingTenantLockedByPlatform": "Platform admin has locked tenant branding. You cannot change theme or language for your organization.",
    "brandingLockedByAdmin": "Your administrator has set the theme and language for your account. Contact them to request changes.",
    "brandingLoadError": "Failed to load branding settings",
    "brandingSaveSuccess": "Branding settings saved",
    "brandingSaveError": "Failed to save branding settings",
    "brandingReset": "Reset to defaults",
    "brandingResetSuccess": "Branding settings reset",
    "notifications": {
      "title": "Notifications",
      "subtitle": "Choose how you receive platform notifications",
      "loading": "Loading notification settings...",
      "loadError": "Failed to load notification settings",
      "saveError": "Failed to save notification settings",
      "inAppTitle": "In-app notifications",
      "inAppDescription": "Show notifications in the bell, inbox, and as toasts when events occur.",
      "soundTitle": "Notification sound",
      "soundDescription": "Play a sound when a new in-app notification arrives.",
      "emailTitle": "Email notifications",
      "emailDescription": "When off, no email notifications are sent. When on, choose which events send email.",
      "emailWorkflowRun": "Workflow run",
      "emailWorkflowRunDescription": "Email when a workflow run completes.",
      "emailWorkflowBuilderRun": "Workflow Builder run",
      "emailWorkflowBuilderRunDescription": "Email when a Workflow Builder session completes.",
      "emailAgentBuilder": "Agent Builder",
      "emailAgentBuilderDescription": "Email when an Agent Builder session completes.",
      "emailAgentResponse": "Agent response",
      "emailAgentResponseDescription": "Email when an agent finishes a chat reply.",
      "emailAccessDecision": "Access decision",
      "emailAccessDecisionDescription": "Email when an access request is approved or rejected.",
      "emailNewUserRegistration": "New user registration",
      "emailNewUserRegistrationDescription": "Email when a new user registers and is pending approval.",
      "emailBenchmarkAssignment": "Benchmark task assignment",
      "emailBenchmarkAssignmentDescription": "Email when a benchmark curation task is assigned to you.",
      "emailKnowledgeConfig": "Knowledge configuration",
      "emailKnowledgeConfigDescription": "Email when a knowledge table needs Vector Search Settings (column mappings) completed.",
      "emailCustomerAnalyticsDigest": "Customer analytics digest",
      "emailCustomerAnalyticsDigestDescription": "Weekly email of champions, product-qualified leads, and accounts that need a check-in.",
      "emailCustomerAnalyticsAlert": "Customer analytics alerts",
      "emailCustomerAnalyticsAlertDescription": "Daily email when a champion fades, a new product-qualified lead appears, or an account becomes at risk."
    },
    "integrations": {
      "title": "Integrations"
    }
  },
  "models": {
    "title": "Models",
    "addModel": "Add Model",
    "editModel": "Edit Model",
    "modelName": "Model Name",
    "provider": "Provider",
    "baseUrl": "Base URL",
    "chat": "Chat",
    "deleteConfirm": "Are you sure you want to delete this model?",
    "noModels": "No models found in the associated project",
    "filterProvider": "Provider",
    "filterStatus": "Status",
    "filterCreator": "Creator",
    "statusActive": "Active",
    "statusDeprecated": "Deprecated",
    "columnModelName": "Model Name",
    "columnModelId": "Model ID",
    "columnProvider": "Provider",
    "columnStatus": "Status",
    "columnAccess": "Access",
    "columnCreatedBy": "Created by",
    "columnCreatedAt": "Created at",
    "columnUpdatedAt": "Updated at",
    "columnActions": "Actions",
    "actionChat": "Chat",
    "actionTestConnection": "Test Connection",
    "actionSetDefault": "Set as Default",
    "actionRemoveDefault": "Remove as Default",
    "actionManageAccess": "Manage Access",
    "actionExport": "Export",
    "actionEdit": "Edit",
    "actionDelete": "Delete",
    "bulkExportSelected": "Export Selected",
    "bulkDeleteSelected": "Delete Selected",
    "modelArena": "Model Arena",
    "modelArenaTitle": "Compare 2 models in Model Arena",
    "pricingCatalog": "Pricing catalog",
    "pricingCatalogTitle": "View and edit USD-per-1M pricing intervals",
    "deleteModalTitle": "Delete Model",
    "deleteModalMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
    "bulkDeleteModalTitle": "Delete Selected Models",
    "bulkDeleteModalMessage": "Are you sure you want to delete {{count}} model{{s}}? This action cannot be undone.",
    "bulkDeleteModalConfirm": "Delete {{count}} Model{{s}}",
    "loadingModels": "Loading models...",
    "favorites": "Favorites",
    "filterBarTitle": "Filters",
    "searchPlaceholder": "Search models...",
    "group": {
      "viewToggle": "Model view",
      "listView": "List view",
      "groupedView": "Grouped view",
      "columnModels": "Models",
      "projectCount": "{{count}} project",
      "projectCount_plural": "{{count}} projects",
      "moreProjects": "+{{count}} more",
      "activeCount": "{{count}} active",
      "activeCount_plural": "{{count}} active",
      "inactiveCount": "{{count}} inactive",
      "inactiveCount_plural": "{{count}} inactive",
      "memberCount": "{{count}} model",
      "memberCount_plural": "{{count}} models",
      "tenantCount": "{{count}} tenant",
      "tenantCount_plural": "{{count}} tenants",
      "moreTenants": "+{{count}} more",
      "loadError": "Could not load grouped models.",
      "empty": "No model groups found.",
      "emptyDrillDown": "No models in this group match the current filters.",
      "backToGroups": "Back to grouped models",
      "loading": "Loading model groups..."
    },
    "defaultModelTooltip": "Default Model",
    "pricing": {
      "title": "Pricing catalog",
      "description": "USD per 1 million tokens — sorted by cheapest input among visible models. Use {{endpoint}} to compare providers.",
      "descriptionPrefix": "USD per 1 million tokens — sorted by cheapest input among visible models. Use",
      "descriptionSuffix": "to compare providers.",
      "allProviders": "All providers",
      "fromInput": "from ${{price}}/in",
      "fromInputTooltip": "From ${{price}} / 1M input (visible models)",
      "viewMore": "View {{count}} more",
      "searchPlaceholder": "Search models or provider…",
      "emptyMessage": "No models found.",
      "loadingMessage": "Loading pricing catalog…",
      "loadModelsFailed": "Failed to load models",
      "harvestSuccess": "Pricing harvest complete: {{summary}}",
      "harvestFailed": "Pricing harvest failed",
      "modelsPriced": "{{count}} model priced",
      "modelsPriced_plural": "{{count}} models priced",
      "skippedCount": "{{count}} skipped",
      "errorsCount": "{{count}} error",
      "errorsCount_plural": "{{count}} errors",
      "viewHistory": "View history",
      "noPricing": "No pricing",
      "live": "Live",
      "notOpenEnded": "Not open-ended",
      "notOpenEndedTooltip": "Latest row is a closed interval — verify an open interval exists for forward pricing.",
      "columns": {
        "model": "Model",
        "inputRate": "Input rate",
        "outputRate": "Output rate",
        "interval": "Interval",
        "source": "Source"
      },
      "history": {
        "title": "Pricing history",
        "subtitle": "Full pricing history. The active catalog row is listed first; manual intervals and harvested rates can be edited (harvest edits become manual overrides). Only manual intervals can be deleted.",
        "currentCatalogRate": "Current catalog rate",
        "liveOpenEnded": "Live (open-ended)",
        "notOpenEnded": "Not open-ended",
        "notOpenEndedTooltip": "No open-ended interval — showing most recent closed slice as fallback.",
        "searchPlaceholder": "Search source, dates, rates…",
        "emptyMessage": "No pricing history rows match this search.",
        "loadingMessage": "Loading pricing history…",
        "failedToLoad": "Failed to load pricing history",
        "refresh": "Refresh",
        "addManualInterval": "Add manual interval",
        "activeRate": "Active rate",
        "historical": "Historical",
        "effectiveFrom": "Effective from",
        "effectiveUntil": "Effective until",
        "unit": "Unit",
        "inputRate": "Input rate",
        "outputRate": "Output rate",
        "source": "Source",
        "deleteModalTitle": "Delete pricing interval",
        "deleteModalMessage": "Are you sure you want to delete this manual pricing interval? This action cannot be undone.",
        "delete": "Delete",
        "intervalAdded": "Pricing interval added",
        "intervalUpdated": "Pricing interval updated",
        "intervalDeleted": "Pricing interval deleted",
        "failedToAdd": "Failed to add pricing interval",
        "failedToUpdate": "Failed to update pricing interval",
        "failedToDelete": "Failed to delete pricing interval",
        "units": {
          "perMinute": "per minute",
          "perMillionChars": "per 1M chars",
          "perMillionTokens": "per 1M tokens"
        }
      },
      "modal": {
        "addTitle": "Add pricing interval",
        "editTitle": "Edit pricing interval",
        "model": "Model",
        "selectModel": "Select a model...",
        "effectiveFrom": "Effective from",
        "effectiveUntil": "Effective until",
        "effectiveUntilHelp": "Optional — leave empty for an open-ended interval (currently active pricing).",
        "unit": "Unit",
        "unitOptions": {
          "tokens": "Per 1M tokens (LLM / embeddings)",
          "minute": "Per minute (STT / audio)",
          "chars": "Per 1M characters (TTS)"
        },
        "fieldLabels": {
          "usdPerMinute": "USD per minute",
          "outputPriceOptional": "Output price (optional)",
          "inputPriceOptional": "Input price (optional)",
          "usdPer1MChars": "USD per 1M characters",
          "inputUsdPer1MTokens": "Input USD per 1M tokens",
          "outputUsdPer1MTokens": "Output USD per 1M tokens"
        },
        "validation": {
          "selectModel": "Please select a model",
          "effectiveFromRequired": "Effective from date is required",
          "effectiveFromFormat": "Effective from must be YYYY-MM-DD",
          "effectiveUntilFormat": "Effective until must be YYYY-MM-DD",
          "effectiveUntilAfterFrom": "Effective until must be on or after effective from",
          "inputNonNegative": "Input USD must be a non-negative number",
          "outputNonNegative": "Output USD must be a non-negative number"
        },
        "cancel": "Cancel",
        "save": "Save interval",
        "add": "Add interval",
        "saving": "Saving..."
      }
    },
    "scopeSelector": {
      "currentScope": "Current scope: {{scope}}",
      "enableTenantNote": "Turn this on to share the model with every project in the tenant.",
      "projectDescription": "Available only within a specific project",
      "projectFieldLabel": "Project",
      "projectHint": "This model can only be used in the selected project.",
      "projectLabel": "Project",
      "projectPlaceholder": "Select a project",
      "projectSearchPlaceholder": "Search projects…",
      "tenantDescription": "Available to all projects in this tenant",
      "tenantHint": "This model can be approved onto any project in this tenant.",
      "tenantLabel": "Tenant",
      "tenantToggleLabel": "Tenant scope"
    },
    "form": {
      "addTitle": "Add Model",
      "editTitle": "Edit Model",
      "loadingQuota": "Loading quota...",
      "modelType": "Model Type",
      "cannotChangeTypeAfterCreation": "Cannot be changed after creation ({{type}})",
      "provider": "Provider",
      "providerTooltip": "Select the AI provider. Showing {{count}} compatible provider(s) for the selected model type.",
      "showingEmbeddingProviders": "Showing {{count}} providers with embedding support",
      "showingTypeProviders": "Showing {{count}} {{type}} providers",
      "providerLockedTooltip": "Provider cannot be changed after creation.",
      "selectModel": "Select Model",
      "optionalTemplate": "(optional template)",
      "discoverFallbackTooltip": "Prefer Discover above for live workspace endpoints; templates are a fallback.",
      "availableModelsTooltip": "Choose from available {{provider}} {{type}} models ({{count}} available)",
      "selectAModel": "Select a Model",
      "selectATypeModel": "Select a {{type}} model",
      "discovered": "discovered",
      "baseUrl": "Base URL",
      "baseUrlTooltip": "Required for local providers like Ollama or LM Studio. Leave empty for cloud providers.",
      "apiKeyRef": "API Key Reference",
      "apiKeyRefTooltip": "Name of the environment variable holding the provider API key (configured in the backend deployment).",
      "displayName": "Display Name",
      "displayNameModelIdSetTooltip": "Model ID will be set from the selected model above.",
      "displayNameAutoGeneratedTooltip": "Model ID will be auto-generated from the display name if no model is selected.",
      "fullModelNamePreview": "Full Model Name Preview:",
      "displayNamePlaceholder": "e.g., Chat Completion",
      "apiVersion": "API Version",
      "apiVersionTooltip": "API version required by the gateway",
      "paramProfile": "Param Profile",
      "defaultParams": "Default Params (JSON)",
      "defaultParamsTooltip": "Optional JSON object with default parameters sent to the model on every request (e.g. temperature, max_tokens).",
      "testSuccess": "✓ Connection Test Successful",
      "testFailed": "✗ Connection Test Failed",
      "modelResponse": "Model Response:",
      "testing": "Testing...",
      "testConnection": "Test Connection",
      "testConnectionTitle": "Test connection before saving",
      "addModel": "Add Model",
      "adding": "Adding...",
      "saving": "Saving...",
      "quotaExceeded": "Model quota exceeded",
      "noChangesToSave": "No changes to save",
      "selectProvider": "Select a provider"
    },
    "tags": {
      "llm": "Text",
      "image": "Image",
      "embedding": "Embedding",
      "audio": "Audio",
      "video": "Video",
      "reranker": "Reranker",
      "tts": "Text-to-Speech",
      "stt": "Speech-to-Text"
    },
    "tagDescriptions": {
      "llm": "Text models generate language responses for chat and completion tasks",
      "image": "Image models generate, edit, or analyze visual content",
      "embedding": "Embedding models convert text into vector embeddings for semantic search and retrieval",
      "audio": "Audio models process and generate sound and music",
      "video": "Video models generate and edit video content",
      "reranker": "Reranking models score and order documents by relevance to a query",
      "tts": "Speech models generate spoken audio from text — not for chat or text completion",
      "stt": "Transcription models convert audio to text — not for chat or text completion"
    },
    "emptyState": {
      "permissionDenied": "You don't have permission to view models. Contact your administrator for access.",
      "noResultsSearch": "No models found matching your search.",
      "default": "No models found. Create your first model to get started."
    }
  },
  "chat": {
    "title": "Chat",
    "placeholder": "Type your message...",
    "send": "Send",
    "modelNotSelected": "No model selected",
    "modelNotFound": "Model not found",
    "failedToLoad": "Failed to load model",
    "failedToSend": "Failed to send message",
    "ollamaNotRunning": "Cannot connect to Ollama. Make sure Ollama is running: ollama serve",
    "modelNotFoundOllama": "Model not found or Ollama is not running. Please check your Ollama installation.",
    "modelArena": {
      "title": "Model Arena",
      "vs": "VS",
      "selectModel": "Select a model",
      "startConversation": "Start a conversation",
      "processing": "Processing...",
      "recording": "Recording...",
      "record": "Record",
      "stop": "Stop",
      "or": "or",
      "uploadAudio": "Upload Audio",
      "query": "Query",
      "documents": "Documents (one per line, min 2)",
      "compare": "Compare",
      "enterInput": "Enter input...",
      "noImageOrText": "No image or text returned",
      "noVideoReturned": "No video returned",
      "copied": "Copied",
      "copy": "Copy",
      "copyResponse": "Copy response",
      "startRecording": "Start recording",
      "stopRecording": "Stop recording",
      "cannotChangeModel": "Model cannot be changed once chat has started",
      "cannotChangeType": "Model type cannot be changed once chat has started",
      "noModelsAvailable": "No models available",
      "addAtLeastOneModel": "Please add at least 1 {{type}} model to use Model Arena",
      "addAnotherModel": "Add another model to compare",
      "onlyOneModelAvailable": "Only one model is available. Model Arena requires two different models for comparison.",
      "sameModelSelected": "You have selected the same model for both sides. Please select a different model to start.",
      "startBeforeRating": "Start a conversation before rating this session",
      "restoreView": "Restore split view",
      "expandLeft": "Expand left panel",
      "expandRight": "Expand right panel",
      "selectModel2": "Select model...",
      "searchModels": "Search models...",
      "syncedToBoth": "{{placeholder}} (synced to both)",
      "placeholders": {
        "searchQuery": "Enter search query...",
        "rerankDocs": "Document 1 text...\nDocument 2 text...\nDocument 3 text...",
        "tts": "Enter text to synthesize...",
        "image": "Describe the image to generate...",
        "video": "Describe the video to generate... (may take a few minutes)"
      },
      "types": {
        "llm": "Text",
        "image": "Image",
        "audio": "Audio",
        "video": "Video",
        "reranker": "Rerank",
        "tts": "Speech",
        "stt": "Transcription"
      },
      "typeDescriptions": {
        "llm": "Text models generate language responses for chat and completion tasks",
        "image": "Image models generate or edit images from text prompts",
        "audio": "Audio models process or generate non-speech audio content",
        "video": "Video models generate or analyze video content",
        "reranker": "Rerank models reorder retrieved documents for improved RAG relevance",
        "tts": "Speech models generate spoken audio from text — not for chat or text completion",
        "stt": "Transcription models convert audio to text — not for chat or text completion"
      }
    },
    "newChat": "New Chat",
    "newSession": "New Chat",
    "endOfSessions": "End of Sessions",
    "noSessionsYet": "No Model Arena sessions yet",
    "startNewConversation": "Start a new conversation",
    "startConversation": "Start a conversation",
    "startConversationWithModel": "Start a conversation with this model",
    "configuration": "Configuration",
    "collapseConfig": "Collapse",
    "expandConfig": "Configuration",
    "backToModels": "Back to Models",
    "refreshSessions": "Refresh sessions",
    "activeSessionEmpty": "Active session is empty",
    "newModelArena": "New Model Arena",
    "loadingDot": "Loading...",
    "loadingMore": "Loading more...",
    "sessionRenamed": "Session renamed",
    "failedToRename": "Failed to rename session",
    "sessionDeleted": "Session deleted successfully",
    "failedToDelete": "Failed to delete session",
    "deleteSession": "Delete Model Arena Session",
    "deleteSessionConfirm": "Are you sure you want to delete this Model Arena session? This will also delete both individual model sessions. This action cannot be undone.",
    "rename": "Rename",
    "delete": "Delete",
    "save": "Save",
    "cancel": "Cancel",
    "selectPrompt": "Select a prompt...",
    "searchPrompts": "Search prompts...",
    "selectSkills": "Select skills...",
    "searchSkills": "Search skills...",
    "version": "Version",
    "rateSession": "Rate Session",
    "rateThisSession": "Rate this session",
    "updateFeedback": "Update feedback",
    "helpful": "Helpful",
    "notHelpful": "Not Helpful",
    "rated": "Rated {{value}}/10",
    "feedbackProvided": "Feedback Provided",
    "startBeforeRating": "Start a conversation before rating this session",
    "selectHelpful": "Please select Helpful or Not Helpful before submitting",
    "failedToSaveComparisonFeedback": "Failed to save comparison feedback",
    "feedbackSubmitted": "Feedback submitted successfully",
    "failedToSubmitSessionFeedback": "Failed to submit session feedback",
    "promptTemplate": "Prompt Template",
    "skills": "Skills",
    "model": "Model",
    "sttModel": "Speech-to-text (attachments)",
    "knowledge": "Knowledge",
    "tools": "Tools",
    "settings": "Settings"
  },
  "admin": {
    "title": "Admin",
    "users": "Users",
    "roles": "Roles",
    "pending": "Pending",
    "active": "Active"
  },
  "solutions": {
    "title": "Solutions",
    "subtitle": "Discover and share repos and code with quick links to QA, UAT, and production.",
    "addSolution": "Add Solution",
    "dialogTitle": "Add solution",
    "editDialogTitle": "Edit solution",
    "submit": "Add to catalog",
    "submitEdit": "Save changes",
    "empty": "No solutions yet. Add the first one to help your team find environments faster.",
    "openGithub": "Open GitHub repository",
    "designPrototype": "Design prototype",
    "openDesignPrototype": "Open design prototype (Figma, etc.)",
    "editSolution": "Edit solution",
    "deleteSolution": "Delete solution",
    "deleteSelected": "Delete Selected",
    "openEditor": "Open editor",
    "sourceGithub": "GitHub URL",
    "sourceCode": "Code Files",
    "codeHint": "After creating, you’ll be taken to the code editor to add and edit files.",
    "shortcutHint": "Tip: Ctrl/⌘ + Enter submits the form.",
    "toast": {
      "created": "Solution added to the catalog.",
      "updated": "Solution updated.",
      "deleted": "Solution deleted.",
      "bulkDeleted": "Deleted {{deleted}} solution(s). {{skipped}} skipped.",
      "conflict": "This solution was changed elsewhere. Refresh the page to load the latest version."
    },
    "fields": {
      "name": "Solution name",
      "description": "Description",
      "githubUrl": "GitHub repository URL",
      "designPrototypeUrl": "Design prototype URL",
      "sourceType": "Source type",
      "tags": "Tags",
      "owner": "Owner"
    },
    "placeholders": {
      "description": "Short summary (2–3 lines)",
      "designPrototypeUrl": "https://www.figma.com/design/..."
    },
    "validation": {
      "nameRequired": "Name is required.",
      "nameTooLong": "Name must be {{max}} characters or fewer.",
      "nameExists": "Solution name already exists.",
      "descriptionTooLong": "Description must be {{max}} characters or fewer.",
      "githubRequired": "GitHub URL is required.",
      "githubInvalid": "Enter a valid https GitHub repository URL.",
      "urlInvalid": "Must be a valid http(s) URL."
    },
    "confirmDeleteTitle": "Delete solution",
    "confirmDeleteMessage": "Are you sure you want to delete \"{{name}}\"? This will permanently remove the solution and all its files.",
    "confirmBulkDeleteTitle": "Delete selected solutions",
    "confirmBulkDeleteMessage": "Are you sure you want to delete {{count}} solution(s)? This will permanently remove them and all their files.",
    "editor": {
      "explorer": "Explorer",
      "newFile": "New file",
      "noFiles": "No files yet.",
      "addFirstFile": "Add a file",
      "selectFile": "Select a file from the explorer to start editing.",
      "noFileSelected": "No file selected",
      "saveChanges": "Save changes",
      "saved": "Saved",
      "unsavedChanges": "Unsaved changes",
      "deleteFile": "Delete file",
      "confirmDelete": "Delete \"{{file}}\"? This cannot be undone.",
      "delete": "Delete",
      "fileExists": "A file with this path already exists.",
      "notFound": "Solution not found.",
      "backToList": "Back to Solutions",
      "settings": "Settings",
      "metadataTitle": "Solution settings",
      "metadataSaved": "Settings saved.",
      "switchToDark": "Dark mode",
      "switchToLight": "Light mode",
      "lineCol": "Ln {{line}}, Col {{col}}",
      "newFolder": "New folder",
      "folderNamePlaceholder": "folder-name",
      "folderExists": "A folder with this name already exists at this level.",
      "deleteFolder": "Delete folder",
      "confirmDeleteFolder": "Delete folder \"{{folder}}\" and all its contents? This cannot be undone.",
      "newFileInFolder": "New file in folder",
      "newSubfolder": "New subfolder",
      "uploadZip": "Upload Zip",
      "uploadZipTitle": "Upload a .zip file to import files and folders",
      "zipUploading": "Extracting zip...",
      "zipSuccess": "Imported {{count}} files from zip archive.",
      "zipSuccessWithSkips": "Imported {{count}} files ({{skipped}} skipped).",
      "zipError": "Failed to upload zip file.",
      "zipDragHint": "Drop a .zip file here to import",
      "binaryFileNotEditable": "Binary file — not editable in the code editor.",
      "downloadFile": "Download file",
      "renameFile": "Rename",
      "renamePlaceholder": "new-name",
      "moveFile": "Move / rename",
      "movePlaceholder": "new/path/to/file.ts"
    }
  },
  "tenant": {
    "switch": "Switch Tenant",
    "subdomain": "Subdomain:"
  },
  "ontology": {
    "canvasTitle": "Ontology Canvas",
    "canvasSubtitle": "End-to-end data lineage from source to ML analytics",
    "dataModelsTitle": "Data Models",
    "dataModelsSubtitle": "Enterprise data model catalog across industries",
    "kpiLibraryTitle": "KPI Library",
    "kpiLibrarySubtitle": "Business KPI definitions and metrics catalog",
    "migrationsStudioTitle": "Migrations Studio",
    "migrationsStudioSubtitle": "Orchestrate discovery through cutover with AI migration agents, validation, and lineage in one workspace.",
    "pipelinesTitle": "Data Studio",
    "pipelinesSubtitle": "Migration handoffs, orchestrator workflows, and KPI-linked processing in one catalog",
    "observabilityTitle": "Data Observability",
    "observabilitySubtitle": "Pipeline health monitoring and data freshness tracking",
    "nodesSelected": "{{count}} nodes selected",
    "overview": "Overview",
    "lineage": "Lineage",
    "buildTimeline": "Build timeline",
    "dataHealth": "Data health",
    "allFamilies": "All Families",
    "allTypes": "All Types",
    "mustHave": "Must Have",
    "goodToHave": "Good to Have",
    "totalKpis": "Total KPIs",
    "families": "Families",
    "export": "Export CSV",
    "exportCard": "Export",
    "exportCardTitleDataModel": "Export data model",
    "exportCardTitleOntology": "Export ontology",
    "exportCardTitleKpi": "Export KPIs",
    "exportCardSubtitle": "Choose a file format, then download.",
    "exportCardDownload": "Download",
    "exportCardCancel": "Cancel",
    "exportFormatPortableJson": "Portable JSON (round-trip via Create data model)",
    "exportFormatPortableYaml": "Portable YAML (same content as JSON)",
    "exportFormatDdl": "SQL DDL",
    "exportFormatDrawio": "Draw.io XML",
    "exportFormatTurtle": "Turtle (.ttl)",
    "exportFormatRdfXml": "RDF/XML",
    "exportFormatJsonLd": "JSON-LD",
    "version": "Version",
    "versions": "Versions",
    "latest": "latest",
    "compareVersions": "Compare",
    "neo4jGraph": "Network Graph",
    "diffAdded": "added",
    "diffRemoved": "removed",
    "diffUnchanged": "unchanged",
    "diffNoChanges": "No changes",
    "diffSelectTwo": "Select two different versions to compare.",
    "exportFormatCsv": "CSV (import on another instance)",
    "exportFormatKpiJson": "JSON snapshot (backup / tooling)",
    "exportKpiJsonNote": "CSV matches the KPI Library CSV import. JSON is for backup or external tools; there is no JSON import yet.",
    "healthy": "Healthy",
    "degraded": "Degraded",
    "critical": "Critical",
    "running": "Running",
    "completed": "Completed",
    "failed": "Failed",
    "scheduled": "Scheduled",
    "published": "Published",
    "draft": "Draft",
    "impactAnalysis": "Impact Analysis",
    "impactActive": "Impact active",
    "viewDataSample": "View Data Sample",
    "resourceOverview": "Resource overview",
    "pipelineDrawerCode": "Code",
    "pipelineDrawerRuns": "Runs",
    "pipelineDrawerMetadata": "Metadata",
    "pipelineDrawerNoCode": "No transform code is registered for this node yet. Connect a repository or publish from the pipeline builder.",
    "pipelineDrawerNoPipeline": "No linked data pipeline was found for this node.",
    "pipelineDrawerNoRuns": "No run history is available for the linked pipeline.",
    "pipelineDrawerNoMetadata": "No additional parameters beyond the transform script.",
    "pipelineLinkedJob": "Linked pipeline",
    "pipelineNodeParams": "Parameters",
    "nodeInfoSection": "Node info",
    "unknownHealth": "Unknown",
    "sourceChip": "Source",
    "dataExplorer": "Data Explorer",
    "openInDataExplorerAriaLabel": "Open in Data Explorer",
    "pipelineRunHistoryUnavailable": "Pipeline run history is not yet available from the backend.",
    "viewSample": "View sample",
    "metadataSectionTitle": "Metadata",
    "kvOwner": "Owner",
    "kvDescription": "Description",
    "kvPipeline": "Pipeline",
    "kvSchedule": "Schedule",
    "kvUpdated": "Updated",
    "kvType": "Type",
    "kvLastUpdated": "Last updated",
    "category": {
      "data_source": "Data Source",
      "data_extract": "Data Extract",
      "pipeline_builder_dataset": "Pipeline Builder Dataset",
      "python_transform": "Python Transform",
      "python_script_transform": "Python Script Transform",
      "virtual_table": "Virtual Table",
      "fusion_sync": "Fusion Sync",
      "fusion_sheet": "Fusion Sheet",
      "kpi_node": "KPI Node",
      "ml_model": "ML Model"
    },
    "stage": {
      "source": "Sources",
      "ingestion": "Ingestion",
      "transformation": "Transform",
      "kpi": "KPI layer",
      "ml_analytics": "ML & analytics"
    },
    "toolbar": {
      "tools": "Tools",
      "layout": "Layout",
      "undo": "Undo",
      "redo": "Redo",
      "clean": "Clean",
      "select": "Select",
      "expand": "Expand",
      "color": "Color",
      "find": "Find",
      "remove": "Remove",
      "align": "Align",
      "flow": "Flow"
    },
    "legend": {
      "categoryLegend": "Category legend",
      "closeLegend": "Close legend"
    },
    "ontoEval": {
      "kpiSessions": "Eval sessions",
      "evaluateButton": "Evaluate",
      "empty": "No eval sessions yet. Click Evaluate to start one.",
      "loadError": "Unable to load eval sessions",
      "filters": {
        "title": "Filters",
        "ontology": "Ontology",
        "allOntologies": "All ontologies",
        "loadingOntologies": "Loading ontologies…",
        "status": "Status",
        "allStatuses": "All statuses"
      },
      "columns": {
        "ontology": "Ontology",
        "status": "Status",
        "baseline": "Baseline",
        "final": "Final",
        "change": "Change",
        "cqs": "CQs passed",
        "published": "Published version",
        "started": "Started"
      },
      "status": {
        "verified": "Verified",
        "enhancing": "In progress",
        "published": "Published",
        "abandoned": "Abandoned"
      },
      "consistency": {
        "consistent": "Consistent",
        "inconsistent": "Inconsistent",
        "skipped": "Skipped",
        "checked": "Checked",
        "unknown": "Not run"
      },
      "metrics": {
        "composite": "Composite score",
        "consistency": "Consistency",
        "cqs": "CQs passed",
        "changes": "Changes",
        "draftQuality": "Draft quality"
      },
      "help": {
        "composite": "Average of the four OQuaRE dimensions.",
        "baseline": "Composite score before edits.",
        "final": "Composite score after publish.",
        "change": "Final minus baseline.",
        "quality": "Composite of the version you started from, compared with the draft.",
        "draftQuality": "Composite score of the draft.",
        "consistency": "Whether the logic checker found a contradiction. Separate from Reliability.",
        "functionalAdequacy": "How well the ontology answers the competency questions and matches the data model.",
        "reliability": "How well the ontology follows its shape rules.",
        "maintainability": "Share of classes that have a human-readable name.",
        "transferability": "Share of classes that have a short description.",
        "cqs": "How many competency questions passed.",
        "changes": "Classes and properties added or retired."
      },
      "facts": {
        "notRun": "Not run",
        "questions": "{{passed}} of {{total}} questions passed",
        "namedClasses": "{{labeled}} of {{total}} classes with a name",
        "describedClasses": "{{commented}} of {{total}} classes with a description",
        "shapeViolations": "{{count}} shape-rule violations"
      },
      "detail": {
        "title": "Eval session",
        "back": "Back to Onto Eval",
        "backToRun": "Back to eval run",
        "loading": "Loading eval session…",
        "notFound": "Eval session not found",
        "subtitle": "v{{semver}} · started {{started}}",
        "openEvaluated": "Open evaluated v{{semver}}",
        "openPublished": "Open v{{semver}}",
        "evaluateAgain": "Evaluate again",
        "dimensions": "OQuaRE dimensions",
        "dimension": "Dimension",
        "noDimensions": "No OQuaRE dimensions recorded.",
        "profiles": "OWL profiles and reasoner",
        "noProfiles": "No OWL profile results recorded.",
        "profileRow": "OWL {{profile}}: {{count}} violation(s)",
        "reasonerNotRun": "DL reasoner not run",
        "reasonerSkipped": "DL reasoner skipped",
        "reasonerConsistent": "DL reasoner: consistent",
        "reasonerInconsistent": "DL reasoner: {{count}} unsatisfiable class(es)",
        "cqa": "CQA verification checklist",
        "noCqa": "No competency questions evaluated.",
        "changelog": "Model changelog",
        "noChanges": "No structural delta recorded.",
        "meta": {
          "title": "Run details",
          "started": "Started",
          "completed": "Completed",
          "startedBy": "Started by",
          "baselineRun": "Baseline verification",
          "finalRun": "Final verification",
          "branch": "Sandbox branch",
          "publishedVersion": "Published version",
          "error": "Error"
        },
        "banner": {
          "verified": "This run stopped after verification. Sessions are read-only; use Evaluate again to continue.",
          "enhancing": "This run was not published. Sessions are read-only; use Evaluate again to continue.",
          "abandoned": "This run was closed without publishing. Sessions are read-only; use Evaluate again to continue."
        },
        "verificationStatus": {
          "verified": "Verified",
          "warnings": "Warnings",
          "failed": "Failed"
        }
      }
    },
    "studio": {
      "loadingOntologies": "Loading ontologies…",
      "loadingPrevOntologies": "Loading previous ontologies…",
      "loadingMoreOntologies": "Loading more ontologies…",
      "industryFilterLabel": "Industry",
      "allIndustries": "All industries",
      "domainFilterLabel": "Domain",
      "allDomains": "All domains",
      "subdomainFilterLabel": "Subdomain",
      "allSubdomains": "All subdomains",
      "failedToDeleteOntology": "Failed to delete ontology",
      "ontologyImportedToast": "Ontology \"{{name}}\" imported",
      "pageTitle": "Ontology Studio",
      "pageSubtitle": "Browse, import, or build OWL/TTL ontologies with AI from a data model. Profiler-derived ontologies appear here automatically after profiling completes in Migration Studio.",
      "evaluateButton": "Evaluate",
      "createOntologyButton": "Create ontology",
      "ontologiesKpiLabel": "Ontologies",
      "yourOntologiesHeading": "Your ontologies",
      "importTooltipBold": "Import",
      "importTooltipRest": "an OWL/TTL file to register a new ontology. Ontologies produced by the profiler workflow are registered here automatically.",
      "filtersTitle": "Filters",
      "searchPlaceholder": "Search ontologies…",
      "clearSearchAriaLabel": "Clear search",
      "noOntologiesMatch": "No ontologies match your search. Create an ontology by importing OWL/TTL or building with AI from a data model, or run the profiler in Migration Studio to auto-register an ontology.",
      "ontologyActionsAriaLabel": "Ontology actions for {{name}}",
      "renameMenuItem": "Rename",
      "industryTagsMenuItem": "Industry tags",
      "deleteMenuItem": "Delete",
      "owlFileBadge": "OWL file",
      "versionsCount": "{{count}} versions",
      "classesLabel": "classes",
      "individualsLabel": "individuals",
      "removeFromCatalogTitle": "Remove from catalog",
      "removeFromCatalogMessage": "Remove \"{{name}}\" from Ontology Studio? The ontology is soft-deleted (removed from the catalog). Direct links to the OWL viewer may show missing until you import again.",
      "couldNotExportOntology": "Could not export ontology",
      "industryTagsUpdated": "Industry tags updated",
      "couldNotUpdateIndustryTags": "Could not update industry tags",
      "industryDialogTitle": "Industry tags",
      "industryDialogSubtitle": "Catalog filter and badges for {{name}}.",
      "unspecifiedOption": "Unspecified",
      "industryFieldLabel": "Industry",
      "saveButton": "Save",
      "savingButton": "Saving…",
      "closeAriaLabel": "Close",
      "renameDialogTitle": "Rename OWL ontology",
      "renameDialogSubtitle": "Display name shown on cards and in lists (up to {{maxLength}} characters).",
      "nameFieldLabel": "Name",
      "nameRequiredError": "Name is required",
      "nameMustContainLetterError": "Name must contain at least one letter or number",
      "renameFailedError": "Rename failed",
      "bulkDelete": {
        "selectAll": "Select all",
        "selectItem": "Select {{name}}",
        "deleteSelected": "Delete selected",
        "clear": "Clear",
        "selectedCount": "{{count}} selected",
        "dialogTitle": "Delete selected ontologies",
        "dialogMessage": "Delete {{count}} ontology(ies)? This cannot be undone.",
        "confirmLabel": "Delete {{count}}",
        "success": "Deleted {{deleted}} ontology(ies).",
        "partial": "Deleted {{deleted}}. {{skipped}} skipped, {{failed}} failed. {{errors}}"
      }
    },
    "justNow": "Just now",
    "hoursAgo": "{{hours}}h ago",
    "daysAgo": "{{days}}d ago",
    "chooser": {
      "subtitle": "Import an existing OWL/TTL file, or build a dense ontology with AI from a registered data model and competency questions.",
      "buildWithAiTitle": "Build Ontology with AI",
      "buildWithAiDesc": "Pick a data model, review competency questions, synthesize OWL",
      "uploadTitle": "Upload OWL/TTL",
      "uploadDesc": "Upload an existing ontology file"
    },
    "import": {
      "title": "Import OWL/TTL Ontology",
      "subtitle": "Upload a Turtle (.ttl), OWL, RDF/XML, or JSON-LD file to create an ontology.",
      "industryHint": "Stored on the catalog card and used for filtering alongside Data Models and KPIs.",
      "nameLabel": "Ontology name (optional)",
      "namePlaceholder": "Override auto-detected title from file",
      "nameHint": "Shown on the catalog card. Leave blank to use the title from the OWL file.",
      "ontologyNameFieldLabel": "Ontology name",
      "dropPrompt": "Drop a TTL/OWL file here, or click to browse",
      "filePreviewHeader": "File preview",
      "importingButton": "Importing...",
      "importButton": "Import ontology",
      "importFailed": "Import failed"
    },
    "builder": {
      "backToStudioAriaLabel": "Back to Ontology Studio",
      "pageTitle": "Build Ontology with AI",
      "pageSubtitle": "Name the ontology, pick a data model, review competency questions, then synthesize OWL and register it in the catalog. Refresh-safe — open a session again anytime.",
      "loadFailed": "Failed to load data models",
      "resumeFailed": "Could not resume ontology session",
      "sessionDiscarded": "Session discarded",
      "discardFailed": "Failed to discard session",
      "nameSpecialCharsError": "Ontology name cannot consist only of special characters",
      "launchTextTooLong": "Launch text must be no more than {{max}} characters",
      "domainSpecialCharsError": "Domain cannot consist only of special characters",
      "subdomainSpecialCharsError": "Subdomain cannot consist only of special characters",
      "enterNamePrompt": "Enter an ontology name to continue",
      "enterDomainPrompt": "Enter a domain to continue",
      "selectDataModelPrompt": "Select a data model to continue",
      "selectOntologyLlmPrompt": "Select an Ontology LLM to continue",
      "startFailed": "Failed to start Ontology Builder",
      "updateCqFailed": "Failed to update competency questions",
      "sendMessageFailed": "Failed to send message",
      "synthesisFailed": "Synthesis failed",
      "registeredToast": "Registered {{name}}",
      "ontologyFallback": "ontology",
      "registrationFailed": "Registration failed",
      "dataModelFilterLabel": "Data model",
      "selectDataModelPlaceholder": "Select a data model…",
      "noDataModelsRegistered": "No registered data models",
      "modeFilterLabel": "Mode",
      "modeGuided": "Guided — review each competency question",
      "modeExpress": "Express — faster accept path",
      "ontologyLlmFilterLabel": "Ontology LLM",
      "selectOntologyLlmPlaceholder": "Select ontology LLM…",
      "noChatModelsRegistered": "No chat models registered",
      "enrichmentLlmFilterLabel": "Enrichment LLM",
      "selectEnrichmentLlmPlaceholder": "Select enrichment LLM (optional)…",
      "stepSourceTitle": "Source",
      "stepSourceDesc": "Name the ontology and pick the data model that defines your concepts",
      "stepQuestionsTitle": "Questions",
      "stepQuestionsDesc": "Accept, drop, or refine competency questions grounded in that model",
      "stepOntologyTitle": "Ontology",
      "stepOntologyDesc": "Synthesize OWL classes, properties, and profile-checked axioms",
      "stepRegisterTitle": "Register",
      "stepRegisterDesc": "Publish to the ontology catalog for Studio and agents",
      "sourceFormSubtitle": "Name the ontology and choose the data model to ground its concepts.",
      "ontologyNameLabel": "Ontology name",
      "ontologyNamePlaceholder": "e.g. Patent Domain Ontology",
      "domainLabel": "Domain",
      "domainPlaceholder": "e.g. Healthcare, Intellectual Property",
      "subdomainLabel": "Subdomain",
      "subdomainPlaceholder": "e.g. Claims, Patent Prosecution",
      "loadingModels": "Loading models…",
      "loadingChatModels": "Loading chat models…",
      "enrichToggleTitle": "Enrich metadata before OWL synthesis",
      "enrichToggleDesc": "Use an LLM to expand definitions and labels before classes are generated.",
      "startBuildingButton": "Start building",
      "backToBuilderAriaLabel": "Back to Build Ontology with AI",
      "ontologyBuilderFallback": "Ontology Builder",
      "dataModelFallback": "Data model",
      "chatEmptyLine1": "Your ontology interview starts here.",
      "chatEmptyLine2": "Review proposed competency questions, then accept what the business must answer.",
      "roleYou": "You",
      "roleAssistant": "Assistant",
      "workingStatus": "Working…",
      "startingSessionStatus": "Starting session…",
      "synthesizingStatus": "Synthesizing",
      "chatInputPlaceholder": "Talk freely — describe business questions, or: accept all · next · proceed…",
      "expandSidePanel": "Expand side panel",
      "collapseSidePanel": "Collapse side panel",
      "reflectionHeading": "Reflection & eval",
      "scoreFallback": "Score {{score}}",
      "addMoreQuestionsButton": "Add more ontology questions",
      "registerLead": "Name the ontology and publish it to the catalog. Preview the draft graph below, then confirm profile lint before registration.",
      "graphReviewNudge": "Tip: open OntoGraf or Neo4j above to review structure before registering.",
      "industryLabel": "Industry",
      "registerToCatalogButton": "Register to catalog",
      "resumingSession": "Resuming ontology session…",
      "launchTitle": "Build an ontology",
      "launchTitleLead": "Build",
      "launchTitleAccent": "Business Ontologies",
      "launchSubtitle": "Name it, pick a data model, and chat your way to a business ontology.",
      "nameYourOntology": "Name your ontology…",
      "dataModelPill": "Data model",
      "searchDataModels": "Search data models…",
      "pickDataModelHint": "Select a data model to continue",
      "noAiModelHint": "No AI model configured. Set one up in Admin.",
      "noDataModelsYet": "No data models yet",
      "createDataModel": "Create one",
      "settingsAria": "Settings",
      "settingsLocked": "Locked for this ontology",
      "aiModelLabel": "AI model",
      "reviewStyleLabel": "How to review questions",
      "modeReviewEach": "Ask me to review each question",
      "modeFillForMe": "Fill answers for me",
      "enrichDescriptions": "Enrich descriptions",
      "enrichmentModelLabel": "Enrichment model",
      "sameModel": "Same model",
      "openingLine": "Build {{name}} from {{model}}",
      "askQuestionPlaceholder": "Ask a question your ontology should answer…",
      "askChangePlaceholder": "Ask for a change or add another question…",
      "acceptRemaining": "Accept all ({{count}})",
      "buildOntology": "Build ontology",
      "buildReadyLead": "Your questions are ready. Build the ontology from them.",
      "rebuildReadyLead": "Questions changed since the last build. Rebuild to pick them up.",
      "rebuildOntology": "Rebuild ontology",
      "send": "Send",
      "questionsIntro": "Here are {{count}} questions your ontology should answer.",
      "questionsReviewed": "{{count}} questions reviewed · {{accepted}} accepted",
      "accept": "Accept",
      "drop": "Drop",
      "collapse": "Collapse",
      "undoQuestion": "Undo",
      "answerPlaceholder": "What should the answer be?",
      "questionAccepted": "Question accepted",
      "questionDropped": "Question dropped",
      "phaseBuilding": "Building your ontology…",
      "phaseConcepts": "Designing concepts…",
      "phaseLinks": "Linking relationships…",
      "phaseWriting": "Writing the ontology…",
      "phaseQuality": "Checking quality…",
      "buildFailed": "Couldn't build the ontology",
      "buildTakesAWhile": "This usually takes a few minutes. You can keep this tab open.",
      "buildEnginePhase": "The ontology engine is building this. For a large data model it can take 15 minutes or more.",
      "tryAgain": "Try again",
      "ontologyReady": "Ontology ready · {{concepts}} concepts · {{relationships}} relationships",
      "ontologyViewLabel": "Ontology view",
      "viewGraph": "Graph",
      "viewDraftPreview": "Preview",
      "viewOwl": "OWL",
      "earlierVersion": "Earlier version",
      "qualitySkipped": "Quality check was skipped",
      "qualityViolations": "{{count}} items may need a look",
      "qualityGaps": "A few gaps are still open",
      "tryAsking": "Try asking about {{hint}}",
      "details": "Details",
      "moreDetails": "More details",
      "registeredLine": "Registered {{name}} to your catalog.",
      "registeredQuiet": "This ontology is registered",
      "openOntology": "Open ontology",
      "buildAnother": "Build another",
      "moreActions": "More actions",
      "deleteSession": "Delete session",
      "close": "Close",
      "attachDocuments": "Attach documents",
      "attachDocumentsHint": "Add a requirements document, policy, or other source. The text is extra context and does not replace the data model.",
      "documentUnreadable": "Couldn't read {{names}}. Continuing with the files that can be read.",
      "documentLimit": "Only {{count}} documents can be attached.",
      "removeDocument": "Remove {{name}}",
      "railDataModel": "Data Model",
      "contextTabs": "Context panel",
      "documentsTab": "Documents ({{count}})",
      "documentTypePdf": "PDF",
      "documentTypeWord": "Word",
      "documentTypeExcel": "Excel",
      "documentTypeCsv": "CSV",
      "documentTypeText": "Text",
      "documentTypeImage": "Image",
      "documentCharacters": "{{count}} characters",
      "documentBack": "Back to documents",
      "documentLoading": "Opening document…",
      "documentOpenFailed": "Couldn't open this document",
      "documentSheetEmpty": "This sheet is empty.",
      "documentSheets": "Sheets",
      "collapsePanel": "Collapse panel",
      "expandPanel": "Expand panel",
      "resizePanel": "Resize panel",
      "openModelCanvas": "Open the data model canvas",
      "loadingModelCanvas": "Loading the data model…",
      "modelCanvasFailed": "Couldn't load this data model",
      "noDataModelBound": "No data model bound yet.",
      "entityCount": "{{count}} entities",
      "relationshipCount": "{{count}} relationships",
      "attachFailed": "Couldn't save the attached documents"
    },
    "viewer": {
      "loadSummaryFailed": "Failed to load summary",
      "generatingSummary": "Generating ontology summary…",
      "retry": "Retry",
      "regenerateSummaryTitle": "Regenerate summary",
      "regenerateButton": "Regenerate",
      "classesLabel": "Classes",
      "objectPropsLabel": "Object props",
      "dataPropsLabel": "Data props",
      "individualsLabel": "Individuals",
      "aboutThisOntology": "About this ontology",
      "cachedSummary": "cached summary",
      "overview": "Overview",
      "noSummaryYet": "No summary available yet. Use Regenerate to create one.",
      "propertiesLabel": "Properties",
      "moreCount": "+{{count}} more",
      "showLess": "Show less",
      "tab": {
        "about": "About Ontology",
        "ontograf": "OntoGraf",
        "neo4j-graph": "Network Graph",
        "object-properties": "Object Props",
        "data-properties": "Data Props",
        "annotation-properties": "Annotations",
        "individuals": "Individuals",
        "compare": "Compare"
      },
      "group": {
        "about": "About",
        "explore": "Explore",
        "compare": "Compare"
      },
      "ontologyNotFound": "Ontology not found",
      "couldNotLoadOntology": "Could not load ontology",
      "backButton": "Back",
      "noGraphData": "No graph data available",
      "selectClassesToVisualize": "Select one or more classes",
      "selectClassInspectorHint": "Select a class to view metadata and properties.",
      "classDetailsAriaLabel": "Class details",
      "compareNeedsTwoVersions": "Version comparison needs at least two versions in this family.",
      "backToOntologies": "Ontologies",
      "builtWithAi": "Built with AI",
      "ontologyViewsAriaLabel": "Ontology views",
      "viewGroupsAriaLabel": "View groups",
      "exploreViewsAriaLabel": "Explore views",
      "faqTitle": "FAQ",
      "configureFaqAriaLabel": "Configure FAQ",
      "exportTurtleTitle": "Export Turtle",
      "classHierarchyAriaLabel": "Class hierarchy",
      "expandClassHierarchy": "Expand class hierarchy",
      "showClassHierarchy": "Show class hierarchy",
      "collapseClassHierarchy": "Collapse class hierarchy",
      "collapseHierarchyPanel": "Collapse hierarchy panel",
      "askOntologyTitle": "Ask the ontology",
      "askOntologySubtitle": "Query classes, properties, and relationships.",
      "askOntologyGreeting": "Ask about classes, hierarchies, or relationships in this ontology.",
      "loading": "Loading...",
      "name": "Name",
      "domain": "Domain",
      "range": "Range",
      "characteristics": "Characteristics",
      "kind": {
        "object": "object",
        "data": "data",
        "annotation": "annotation"
      },
      "noPropertiesForClass": "No {{kind}} properties for this class.",
      "noPropertiesFound": "No {{kind}} properties found.",
      "iriLabel": "IRI",
      "unspecified": "(unspecified)",
      "annotationsLabel": "Annotations",
      "typesLabel": "Types",
      "viewLabel": "View",
      "groupedByClass": "Grouped by class",
      "flatList": "Flat list",
      "loadingIndividuals": "Loading individuals…",
      "noIndividualsForClass": "No individuals for this class.",
      "noIndividualsFound": "No individuals found.",
      "dataPropertiesLabel": "Data properties",
      "objectPropertiesLabel": "Object properties"
    },
    "dataModels": {
      "cancel": "Cancel",
      "bulkDelete": {
        "selectAll": "Select all",
        "selectItem": "Select {{name}}",
        "deleteSelected": "Delete selected",
        "clear": "Clear",
        "selectedCount": "{{count}} selected",
        "dialogTitle": "Delete selected data models",
        "dialogMessage": "Delete {{count}} data model(s)? This cannot be undone.",
        "confirmLabel": "Delete {{count}}",
        "success": "Deleted {{deleted}} data model(s).",
        "partial": "Deleted {{deleted}}. {{skipped}} skipped, {{failed}} failed. {{errors}}"
      },
      "close": "Close",
      "description": "Description",
      "industryVertical": "Industry Vertical",
      "modelName": "Model name",
      "nameInvalidChars": "Model name can only contain letters, numbers, spaces, hyphens, and underscores",
      "nameNeedsAlphanumeric": "Model name must contain alphanumeric characters",
      "nameRequired": "Model name is required",
      "save": "Save",
      "saving": "Saving…",
      "selectIndustry": "Select industry",
      "status": {
        "draft": "draft",
        "published": "published"
      },
      "scope": {
        "tenantWide": "Tenant-wide",
        "project": "Project"
      },
      "scopeSelector": {
        "currentScope": "Current scope: {{scope}}",
        "enableTenantNote": "Turn this on to make the data model tenant-wide.",
        "projectDescription": "Locked to one project and approved for its workflows immediately",
        "projectFieldLabel": "Project",
        "projectHint": "This data model is assigned only to the selected project. Other projects cannot see or request it.",
        "projectLabel": "Project",
        "projectPlaceholder": "Select a project",
        "projectSearchPlaceholder": "Search projects…",
        "tenantDescription": "Available for projects in this tenant to request",
        "tenantHint": "Projects can request access. A workflow can use it only after an administrator approves that project.",
        "tenantLabel": "Tenant-wide",
        "tenantToggleLabel": "Tenant-wide"
      },
      "access": {
        "title": "Data model access requests",
        "pendingTab": "Pending requests",
        "historyTab": "Approved history",
        "empty": "No requests in this tab.",
        "model": "Data model",
        "project": "Project",
        "requestedBy": "Requested by",
        "requestedAt": "Request date",
        "approve": "Approve",
        "reject": "Reject",
        "approved": "Access approved",
        "rejected": "Access request rejected",
        "loadFailed": "Could not load access requests",
        "decideFailed": "Could not update the access request"
      },
      "createDialog": {
        "addColumn": "Add column",
        "addEntity": "Add entity",
        "back": "Back",
        "columnNamePlaceholder": "column_name",
        "columns": "Columns",
        "continue": "Continue",
        "createFailed": "Could not create data model",
        "createModel": "Create Model",
        "createdSummary": "{{name}} has been created as a draft with {{count}} entities.",
        "createdSummaryWithColumns": "{{name}} has been created as a draft with {{count}} entities and {{columns}} columns.",
        "createdTitle": "Data Model Created",
        "creating": "Creating...",
        "descriptionPlaceholder": "Describe the purpose and scope of this data model...",
        "dimension": "dimension",
        "done": "Done",
        "duplicateEntityName": "The same entity name is already added",
        "enterModelName": "Enter a model name",
        "entityNameInvalidChars": "Entity name can only contain letters, numbers, and underscores",
        "entityNameNeedsAlphanumeric": "Entity name must contain alphanumeric characters",
        "entityNamePlaceholder": "Entity name (e.g. Customer)",
        "fillOutField": "Please fill out this field.",
        "foreignKey": "Foreign key",
        "missingIndustry": "Missing industry",
        "missingModelName": "Missing model name",
        "modelNamePlaceholder": "e.g. Common Retail Data Model",
        "modelNameRequired": "Model Name *",
        "modelSummary": "Model Summary",
        "needMoreEntities": "Add at least 2 entities to define relationships.",
        "noColumnsYet": "No columns yet. Optional at creation — you can add them later in the model detail view.",
        "noEntitiesYet": "No entities added yet. Start typing above to add tables.",
        "nullable": "Nullable",
        "primaryKey": "Primary key",
        "removeColumn": "Remove column",
        "removeEntity": "Remove {{name}}",
        "selectIndustryVertical": "Select an industry vertical",
        "missingProject": "Missing project",
        "projectRequired": "Select a project for a project-scoped data model",
        "step1Desc": "Name, industry, and description",
        "summaryScope": "Scope:",
        "step1Label": "Basic Info",
        "step2Desc": "Add tables and columns",
        "step2Intro": "Add entities (tables), then define columns for each.",
        "step2Label": "Define Entities",
        "step3Desc": "Define foreign keys and links",
        "step3Intro": "Define relationships between entities.",
        "step3Label": "Relationships",
        "step4Desc": "Validate and publish",
        "step4Label": "Review & Create",
        "subtitle": "Define a new enterprise data model",
        "summaryColumns": "Columns (named):",
        "summaryEntities": "Entities:",
        "summaryIndustry": "Industry:",
        "summaryName": "Name:",
        "summaryRelationships": "Relationships:",
        "title": "Create Data Model",
        "typePlaceholder": "Type"
      },
      "detail": {
        "add": "Add",
        "addColumnTitle": "Add column",
        "back": "Back",
        "backToDataModels": "Back to data models",
        "cardinality": "Cardinality",
        "chooseBothTables": "Choose both tables",
        "columnNameRequired": "Column name is required",
        "couldNotAddRelationship": "Could not add relationship",
        "couldNotApplyDdl": "Could not apply DDL",
        "couldNotDeleteColumn": "Could not delete column",
        "couldNotDeleteRelationship": "Could not delete relationship",
        "couldNotLoadDdl": "Could not load DDL export",
        "couldNotSaveColumn": "Could not save column",
        "couldNotUpdateRelationship": "Could not update relationship",
        "dataType": "Data type",
        "ddlCouldNotExportYet": "-- Could not export DDL yet.\n",
        "ddlUnavailableLargeModel": "-- DDL export is available from the export menu for large models.\n",
        "ddlValidationPassed": "DDL validation passed",
        "deleteColumnAria": "Delete column {{name}}",
        "deleteColumnMessage": "This removes the column from the data model entity.",
        "deleteColumnTitle": "Delete column",
        "deleteRelationshipAria": "Delete relationship",
        "deleteRelationshipMessage": "Remove this relationship from the model.",
        "deleteRelationshipTitle": "Delete relationship",
        "diagramExported": "Diagram exported",
        "drawioDownloaded": "Draw.io diagram downloaded",
        "drawioExportFailed": "Draw.io export failed",
        "editColumnAria": "Edit column {{name}}",
        "editColumnTitle": "Edit column",
        "editRelationshipAria": "Edit relationship",
        "editRelationshipTitle": "Edit relationship",
        "exportFailed": "Export failed",
        "fkColumnSource": "FK column (source)",
        "foreignKeys": "Foreign Keys",
        "jsonSnapshotDownloaded": "JSON snapshot downloaded",
        "modelNotFound": "Model not found",
        "modelUpdatedFromDdl": "Model updated from DDL",
        "name": "Name",
        "noColumnsYet": "No columns yet. Add one to define this entity.",
        "noDirectRelationships": "No direct relationships",
        "nothingToExport": "Nothing to export",
        "nullableColumns": "Nullable Columns",
        "optional": "optional",
        "optionalCapitalized": "Optional",
        "primaryKeys": "Primary Keys",
        "recordCount": "Record Count",
        "relationshipAdded": "Relationship added",
        "snapshotExportFailed": "Snapshot export failed",
        "svgExportFailed": "SVG export failed",
        "svgExported": "SVG exported",
        "tab": {
          "columns": "Columns",
          "relationships": "Relationships",
          "stats": "Stats"
        },
        "tooManyTablesForImage": "This model has {{count}} tables — too large to render as an image in the browser. Use \"Export as Draw.io\" instead.",
        "validation": "Validation",
        "validationFailed": "Validation failed",
        "viewMode": "View",
        "modifyMode": "Modify",
        "searchTablesPlaceholder": "Search tables & columns…",
        "filterErDiagramAriaLabel": "Filter ER diagram",
        "exportAsPng": "Export as PNG",
        "exportAsSvg": "Export as SVG",
        "exportJsonSnapshot": "Export JSON snapshot",
        "exportAsDrawio": "Export as Draw.io",
        "relationshipButton": "Relationship",
        "modelMetricsAriaLabel": "Model metrics",
        "entitiesLabel": "Entities",
        "entAbbrev": "ent",
        "relationshipsLabel": "Relationships",
        "relAbbrev": "rel",
        "totalRecordsLabel": "Total records",
        "recAbbrev": "rec",
        "linkedKpisLabel": "Linked KPIs",
        "kpiAbbrev": "KPI",
        "noEntitiesYet": "No entities yet",
        "noEntitiesDescription": "Apply DDL on the left or import a model to populate this diagram.",
        "askDataModelTitle": "Ask the data model",
        "askDataModelSubtitle": "Query entities, columns, and relationships.",
        "askDataModelGreeting": "Ask about tables, columns, relationships, or statistics in this data model.",
        "addRelationshipTitle": "Add relationship",
        "addRelationshipSubtitle": "From → To · optional FK column on source table",
        "fromTable": "From table",
        "toTable": "To table",
        "selectEllipsis": "Select…",
        "fkColumnOnSource": "FK column (on source)",
        "optionalLowercase": "optional",
        "ddlRefreshTitle": "Replace editor from server export",
        "ddlRefresh": "Refresh",
        "ddlSwitchToModifyValidate": "Switch to Modify mode to validate",
        "ddlValidate": "Validate",
        "ddlSwitchToModifyApply": "Switch to Modify mode to apply",
        "ddlApply": "Apply"
      },
      "editDialog": {
        "invalidName": "Invalid model name",
        "saveChanges": "Save changes",
        "subtitle": "Update name, industry, and description",
        "title": "Edit Data Model",
        "updateFailed": "Could not update data model",
        "updated": "Data model updated"
      },
      "importDialog": {
        "analyzing": "Analyzing...",
        "chooseFile": "Choose file",
        "chooseFiles": "Choose files",
        "close": "Close",
        "createFromSampleData": "Create from sample data",
        "createdSummary": "Created \"{{name}}\": {{entities}} entities, {{columns}} columns, {{relationships}} relationships.",
        "csvFilesLabel": "CSV files (one per table, up to 30)",
        "downloadSampleHint": "Download a sample file to see the expected layout",
        "excelWorkbook": "Excel workbook",
        "fileLabel": "File: {{name}} ({{size}} KB)",
        "formatContent": "{{label}} content",
        "import": "Import",
        "importAsDataModel": "Import as Data Model",
        "importFailed": "Import failed",
        "importFailedTitle": "Import Failed",
        "importFormat": "Import Format",
        "importSuccessful": "Import Successful",
        "importWithVisionModel": "Import with vision model",
        "importedSummary": "Imported \"{{name}}\": {{entities}} entities, {{columns}} columns, {{relationships}} relationships.",
        "importing": "Importing...",
        "inferredModelNamePlaceholder": "Name for the inferred model",
        "loadSample": "Load sample",
        "mediaFileTypes": "File (PNG, JPEG, GIF, WebP, PDF, TXT, MD)",
        "mediaHelp": "Upload an ER diagram screenshot, exported PDF, or unstructured text. Processing uses your tenant model on the {{brand}} platform; large files may take up to a few minutes.",
        "modelNameOptional": "Model name (optional)",
        "noFormatsAvailable": "No import formats are available from the server.",
        "noImportModelConfigured": "No import model configured.",
        "noImportModelLlmHint": "Ask a tenant admin to open Admin → General settings → Enterprise Ontology and select an LLM before using this tab.",
        "noImportModelVisionHint": "Ask a tenant admin to open Admin → General settings → Enterprise Ontology and select a vision-capable LLM before using this tab.",
        "overrideTitleNoName": "Override title if the file has no clear name",
        "overrideTitlePlaceholder": "Override auto-detected title",
        "placeholderCsv": "Paste UTF-8 CSV or upload a .csv: either tabular (row 1 = columns; optional row 2 = types) or a data-dictionary grid (Table Name / Column Name / Data Type / optional Primary Key / Referenced Table).",
        "placeholderDbml": "Paste your DBML (Table definitions and Ref lines)...",
        "placeholderDdl": "Paste your CREATE TABLE statements here...",
        "placeholderDrawio": "Paste your Draw.io XML content...",
        "placeholderJson": "Paste {{brand}} portable JSON — the same shape as Export data model → Portable JSON (entities + relationships).",
        "placeholderJsonSchema": "Paste your JSON Schema with definitions...",
        "placeholderMermaid": "Paste your erDiagram block...",
        "placeholderPlantuml": "Paste your @startuml entity diagram...",
        "placeholderXlsx": "Excel imports use file upload only. Each worksheet is either one table (header row = columns), a data-dictionary grid (table/column/type rows), or a Relationships sheet (From Table / To Table / Foreign Key Column).",
        "sampleCsv": "Sample CSV",
        "sampleHelp": "Upload one or more CSV files containing representative sample data. The system analyzes column names and values to infer entities, data types, primary/foreign keys, and cross-table relationships.",
        "sampleXlsx": "Sample XLSX",
        "subtitle": "Structured formats, images & documents, or infer from sample CSV data",
        "tabMedia": "Images & documents",
        "tabSample": "From sample data",
        "tabStructured": "Structured formats",
        "title": "Import Data Model",
        "uploadFile": "Upload file",
        "warningPrefix": "Warning:",
        "xlsxHelp": "Each visible worksheet becomes one or more tables: tabular sheets use row 1 as column names; data-dictionary sheets (Table Name + Column Name + Data Type, optional Primary Key / Referenced Table / Cardinality) expand each row into a logical column. Use a Relationships sheet (From Table, To Table, Foreign Key Column, optional Cardinality) for explicit edges, or put Referenced Table on dictionary FK rows. Instruction-style sheet names (README, Template, …) and names starting with _ are skipped. Remaining FKs are still inferred from column names (e.g. store_sk → store) when targets exist in the workbook."
      },
      "industryTagDialog": {
        "subtitle": "Catalog badge and filters for {{name}}",
        "title": "Industry tags",
        "updateFailed": "Could not update industry tags",
        "updated": "Industry tags updated"
      },
      "list": {
        "actionClone": "Clone",
        "actionDelete": "Delete",
        "actionEdit": "Edit",
        "actionIndustryTags": "Industry tags",
        "actionPublish": "Publish",
        "allCreators": "All creators",
        "allIndustries": "All industries",
        "clearSearch": "Clear search",
        "cloneFailed": "Could not clone data model",
        "clonedAs": "Cloned as \"{{name}}\"",
        "createDataModel": "Create Data Model",
        "creator": "Creator",
        "deleteDialogMessage": "This removes the data model from the catalog. Linked KPI references may need to be updated.",
        "deleteDialogTitle": "Delete data model",
        "deleteFailed": "Could not delete data model",
        "deleted": "Data model deleted",
        "emptyDescription": "Create or import a data model to get started.",
        "emptyTitle": "No data models yet",
        "entities": "entities",
        "exportFailed": "Could not export data model",
        "filters": "Filters",
        "import": "Import",
        "industry": "Industry",
        "kpis": "KPIs",
        "loadFailed": "Failed to load data models",
        "loading": "Loading data models…",
        "loadingMore": "Loading more data models…",
        "loadingPrev": "Loading previous data models…",
        "noMatchDescription": "Try another search or industry filter, or create a new model.",
        "noMatchTitle": "No data models match",
        "publishFailed": "Could not publish",
        "published": "Data model published",
        "refresh": "Refresh",
        "refreshError": "Could not refresh catalog",
        "refreshList": "Refresh list",
        "relationships": "relationships",
        "searchPlaceholder": "Search data models…",
        "statEntities": "Entities",
        "statLinkedKpis": "Linked KPIs",
        "statModels": "Models",
        "statPublished": "Published",
        "unableToLoad": "Unable to load catalog"
      },
      "erFlow": {
        "entityType": {
          "dimension": "dimension",
          "fact": "fact",
          "bridge": "bridge",
          "aggregate": "aggregate"
        },
        "columnsCount": "{{count}} columns",
        "loadingEllipsis": "Loading…",
        "showMore": "Show more",
        "showLess": "Show less",
        "resetViewTitle": "Reset view & highlights",
        "resetView": "Reset view",
        "hintReadOnly": "Read-only preview · Scroll to pan · use zoom buttons",
        "hintModify": "Modify: drag from a column’s right dot (FK side) to a column’s left dot on another table · ",
        "hintClickTable": "Click a table for details · ",
        "hintPanZoom": "Scroll to pan · use zoom buttons · drag to move tables"
      }
    },
    "optional": "Optional",
    "type": "Type",
    "kpiAllListView": "All KPIs",
    "kpiLibrary": {
      "all": "All",
      "allCollections": "All collections",
      "allDataTypes": "All Data Types",
      "allIndustries": "All industries",
      "andMoreErrors": "...and {{count}} more",
      "askAboutKpis": "Ask about KPIs",
      "backToFamilies": "Back to families",
      "browseMode": "Browse mode",
      "cardActions": "Card actions",
      "chatGreeting": "Ask about KPI names, definitions, families, data types, or links to data models.",
      "chatSubtitleCollection": "Definitions and families in this collection.",
      "chatSubtitleFamily": "Definitions in this family.",
      "clearFiltersAndSearch": "Clear filters and search",
      "closeAria": "Close",
      "collection": "Collection",
      "collectionCardMenu": "Collection card menu",
      "collectionsView": "Collections view",
      "couldNotLoadCatalog": "Could not load catalog",
      "createCollection": "Create Collection",
      "createFamily": "Create Family",
      "createKpi": "Create KPI",
      "dataType": "Data Type",
      "delete": "Delete",
      "dismiss": "Dismiss",
      "editDetails": "Edit details",
      "editLinkedDataModel": "Edit linked data model",
      "enterpriseOntology": "Enterprise Ontology",
      "family": "Family",
      "familiesCount": "{{count}} families",
      "filters": "Filters",
      "importCompleteLabel": "Import complete:",
      "importCreatedSkipped": "{{created}} created, {{skipped}} skipped",
      "importCsv": "Import CSV",
      "industry": "Industry",
      "industryTags": "Industry tags",
      "internalIdNotePrefix": "Internal ID",
      "internalIdNoteSuffix": "stays the same — CSV imports and links won't break.",
      "kpiType": "KPI type",
      "kpisCount": "{{count}} KPIs",
      "legacySuffix": "{{domain}} (legacy)",
      "linkDataModel": "Link data model",
      "linkFamilyToModel": "Link this KPI family to a reference data model",
      "linkedDataModel": "Linked data model",
      "linkedDataModelTooltip": "Linked data model: {{name}}",
      "linkedModelFallback": "Linked model",
      "loadingLibrary": "Loading KPI library...",
      "noCollectionsDesc": "Create a collection or import a CSV to get started.",
      "noCollectionsMatchTitle": "No collections match your search",
      "noCollectionsTitle": "No KPI collections yet",
      "noDataFound": "No data found",
      "noFamiliesDesc": "Create a family or import a CSV to get started.",
      "noFamiliesMatchTitle": "No families match your search",
      "noFamiliesTitle": "No KPI families in this collection",
      "noKpisMatch": "No KPIs match filters. Try adjusting search or filters, or import definitions.",
      "noMatchDesc": "Try a different search term or clear filters.",
      "none": "None",
      "precisionYes": "Precision (Yes)",
      "rename": "Rename",
      "rowActions": "Row actions",
      "save": "Save",
      "saving": "Saving…",
      "searchPlaceholder": "Search collections, families, or KPI name, definition, description...",
      "selectCollection": "Select collection...",
      "selectFamily": "Select family...",
      "selectIndustry": "Select industry…",
      "selectType": "Select type...",
      "totalCollections": "Total Collections",
      "viewDetails": "View details",
      "viewKpiDetails": "View KPI details",
      "columns": {
        "actions": "Actions",
        "costPositive": "Cost +",
        "dataType": "Data type",
        "definition": "Definition",
        "description": "Description",
        "family": "Family",
        "kpiName": "KPI name",
        "kpiType": "KPI type",
        "precision": "Precision"
      },
      "createCollectionDialog": {
        "descriptionAlnumError": "Description must contain valid text and cannot consist solely of special characters or emojis",
        "descriptionPlaceholder": "Brief description of this KPI collection",
        "displayNameAlnumError": "Display name must include at least one letter or number",
        "displayNameCharsError": "Display name can only contain letters, numbers, spaces, hyphens, and underscores",
        "displayNamePlaceholder": "e.g. Retail KPIs",
        "displayNameRequired": "Display Name *",
        "nameAlnumError": "Name must include at least one letter or number",
        "nameCharsError": "Name can only contain letters, numbers, and underscores",
        "namePlaceholder": "e.g. retail_kpis",
        "nameRequired": "Name *",
        "title": "Create New Collection"
      },
      "createFamilyDialog": {
        "collectionRequired": "KPI Collection *",
        "displayNamePlaceholder": "Customer Level KPIs",
        "displayNameRequired": "Display Name *",
        "namePlaceholder": "e.g. COSMOS_CUSTOMER_LEVEL_KPIS",
        "nameRequired": "Name *",
        "title": "Create New KPI Family"
      },
      "createKpiDialog": {
        "collectionRequired": "Collection *",
        "costPositiveCheckbox": "Cost + (Yes/No)",
        "create": "Create KPI",
        "dataTypePlaceholder": "string",
        "definitionPlaceholder": "Technical definition or calculation notes",
        "descriptionPlaceholder": "Short summary",
        "familyRequired": "Family *",
        "kpiNamePlaceholder": "e.g. CUSTOMER_ATC_RATE",
        "kpiNameRequired": "KPI Name *",
        "precisionCheckbox": "Precision (Yes/No)",
        "title": "Create New KPI"
      },
      "collectionIndustryDialog": {
        "subtitle": "Applies to \"{{name}}\" and how it appears in the KPI catalog.",
        "title": "Collection industry tags"
      },
      "deleteCollectionDialog": {
        "message": "This removes the collection and all KPI families and KPI definitions inside it. Any migration project that pointed at this collection will have its KPI collection target cleared automatically.",
        "title": "Delete KPI collection"
      },
      "deleteFamilyDialog": {
        "message": "Are you sure you want to delete \"{{name}}\"? This will also delete all KPIs in this family and cannot be undone.",
        "title": "Delete family"
      },
      "deleteKpiDialog": {
        "message": "Are you sure you want to delete \"{{name}}\"? This cannot be undone.",
        "title": "Delete KPI"
      },
      "detailPopup": {
        "closeAria": "Close",
        "costPositive": "Cost +",
        "dataType": "Data type",
        "definition": "Definition",
        "description": "Description",
        "linkedModel": "Linked model",
        "no": "No",
        "precision": "Precision",
        "tags": "Tags",
        "yes": "Yes"
      },
      "domainDialog": {
        "missingIndustry": "Missing industry",
        "updateFailed": "Could not update industry tags"
      },
      "editFamilyDialog": {
        "descriptionPlaceholder": "Describe what this KPI family covers…",
        "title": "Edit KPI family",
        "titleLabel": "Title",
        "titlePlaceholder": "e.g. Revenue KPIs",
        "updateFailed": "Could not update family"
      },
      "errors": {
        "createCollectionFailed": "Failed to create collection",
        "createFamilyFailed": "Failed to create family",
        "createKpiFailed": "Failed to create KPI",
        "csvImportFailed": "CSV import failed",
        "deleteCollectionFailed": "Could not delete KPI collection",
        "deleteFamilyFailed": "Failed to delete family",
        "deleteKpiFailed": "Failed to delete KPI",
        "exportFailed": "Could not export KPIs",
        "loadFailed": "Could not load KPI library."
      },
      "familyIndustryDialog": {
        "subtitle": "Applies to \"{{name}}\".",
        "title": "KPI family industry tags"
      },
      "importDialog": {
        "appliedToFamiliesNote": "Applied to KPI families created or touched by this import.",
        "chooseCsvFile": "Choose CSV file",
        "close": "Close",
        "dataTypeHelp": "— e.g. string, decimal; omitted values are inferred from name and definition.",
        "definitionHelp": "— technical definition;",
        "descriptionHelp": "— short summary.",
        "domainHelp": "— optional row-level domain (defaults to import domain).",
        "familyCreatedNote": "Families created during import will be placed in this collection. Defaults to \"Default\" if empty.",
        "familyDisplayHelp": "— shown in the UI when creating or updating families.",
        "familyKpiHelp": "— stable identifiers for the family group and KPI symbol.",
        "industryOptional": "Industry (optional)",
        "kpiCollection": "KPI Collection",
        "kpiTypeDefault": "(default: must have).",
        "linkDataModelOptional": "Link data model (optional)",
        "or": "or",
        "or2": "(or",
        "overridesDomainNote": "Overrides the domain column in individual CSV rows.",
        "precisionCostHelp": ") — Yes/No; if omitted, both default to Yes.",
        "requiredColumns": "Required columns:",
        "title": "Import KPIs from CSV"
      },
      "linkDialog": {
        "noneHint": "Choose \"None\" to detach this family from any ER model. Agent Studio and blueprints use this link to align KPIs with entities.",
        "referenceDataModel": "Reference data model",
        "subtitle": "Choose the reference data model for \"{{name}}\".",
        "title": "Link KPI family to data model",
        "updateFailed": "Could not update data model link"
      },
      "renameCollectionDialog": {
        "displayName": "Display name",
        "placeholder": "e.g. Retail KPIs",
        "renameFailed": "Could not rename collection",
        "title": "Rename collection"
      },
      "toasts": {
        "collectionDeleted": "KPI collection deleted",
        "collectionRenamed": "Collection renamed",
        "dataModelLinkRemoved": "Data model link removed",
        "dataModelLinked": "Data model linked",
        "familyUpdated": "Family updated",
        "industryTagsUpdated": "Industry tags updated"
      },
      "createCollectionButton": "Create Collection",
      "importCsvButton": "Import CSV"
    },
    "dataStudio": {
      "list": {
        "newPipeline": "New pipeline",
        "typeLabel": "Type",
        "statusLabel": "Status",
        "allTypes": "All Types",
        "allStatus": "All Status",
        "columnPipeline": "Pipeline",
        "columnType": "Type",
        "columnStatus": "Status",
        "columnRoute": "Source → target",
        "columnSchedule": "Schedule",
        "columnUpdated": "Updated",
        "columnActions": "Actions",
        "actionOpen": "Open",
        "actionDelete": "Delete",
        "deleteDialogTitle": "Delete pipeline",
        "deleteDialogMessage": "This removes the pipeline from Data Studio. This action cannot be undone.",
        "deleted": "Pipeline \"{{name}}\" deleted",
        "deleteFailed": "Could not delete pipeline",
        "migrationLinkTitle": "From migration: {{id}}",
        "migrationLinkText": "Migration",
        "statsPipelines": "Pipelines",
        "emptyNoPipelines": "Nothing in Data Studio yet. Pipelines are usually promoted from completed migration projects or created with New pipeline above.",
        "emptyNoMatches": "No entries match filters. Try adjusting your search or filter criteria.",
        "filtersTitle": "Filters",
        "searchPlaceholder": "Search catalog...",
        "loadErrorTitle": "Failed to load Data Studio catalog",
        "retry": "Retry"
      },
      "status": {
        "pending": "Pending",
        "terminating": "Terminating"
      },
      "createDialog": {
        "title": "Create pipeline",
        "subtitleChoose": "Choose a pipeline type to get started",
        "subtitleMode": "{{mode}} Pipeline",
        "steps": {
          "type": {
            "label": "Pipeline Type",
            "description": "Choose pipeline mode"
          },
          "sourceTarget": {
            "label": "Source & Target",
            "description": "Select endpoints"
          },
          "configuration": {
            "label": "Configuration",
            "description": "Schedule & options"
          },
          "review": {
            "label": "Review",
            "description": "Confirm & create"
          }
        },
        "modes": {
          "migrate": {
            "label": "Migrate",
            "description": "AI-powered migration — opens Migrations Studio"
          },
          "orchestrator": {
            "label": "Orchestrator Workflow",
            "description": "Visual DAG designer — deploy to Databricks, Vertex AI, or Airflow"
          },
          "map": {
            "label": "Map",
            "description": "Field-level mapping between source and target schemas"
          },
          "transform": {
            "label": "Transform",
            "description": "Apply SQL or Python transformations during transfer"
          },
          "custom": {
            "label": "Custom",
            "description": "Fully configurable pipeline with code editor"
          }
        },
        "createdTitle": "Pipeline Created",
        "createdDesc": "{{name}} ({{mode}}) saved as draft.",
        "pipelineNameLabel": "Pipeline Name",
        "pipelineNamePlaceholder": "e.g. {{source}} → {{target}} {{mode}}",
        "sourceSystemLabel": "Source System",
        "sourceSystemPlaceholder": "e.g. Postgres prod, Snowflake DWH",
        "targetDestinationLabel": "Target Destination",
        "targetDestinationPlaceholder": "e.g. BigQuery curated, S3 lake",
        "modeSuffix": "{{mode}} Mode",
        "change": "Change",
        "scheduleLabel": "Schedule",
        "scheduleSelectPlaceholder": "Select schedule",
        "batchSizeLabel": "Batch Size",
        "retryOnFailureLabel": "Retry on Failure",
        "retryEnabled": "Enabled (3 retries)",
        "retryDisabled": "Disabled",
        "transformationSqlLabel": "Transformation SQL",
        "customPipelineCodeLabel": "Custom Pipeline Code",
        "transformSqlPlaceholder": "SELECT\n  customer_id,\n  SUM(amount) as total_spend,\n  COUNT(*) as txn_count\nFROM source_table\nGROUP BY customer_id",
        "customCodePlaceholder": "# Custom pipeline logic\nimport pandas as pd\n\ndef transform(df):\n    return df",
        "summaryTitle": "Pipeline Summary",
        "summaryName": "Name:",
        "summaryType": "Type:",
        "summarySchedule": "Schedule:",
        "summaryBatchSize": "Batch Size:",
        "summaryRetry": "Retry:",
        "retryAttempts": "3 attempts",
        "back": "Back",
        "done": "Done",
        "continue": "Continue",
        "creating": "Creating…",
        "createPipeline": "Create pipeline"
      },
      "detail": {
        "configured": "Configured",
        "error": "Error",
        "start": "START",
        "end": "END",
        "sourceNodeType": "Source",
        "targetNodeType": "Target",
        "extractNodeLabel": "Extract & Validate",
        "parserNodeType": "Parser",
        "notFoundTitle": "Pipeline not found",
        "backToPipelines": "Back to pipelines",
        "typeLabel": "Type",
        "batchSizeLabel": "Batch size",
        "retryOnFailureLabel": "Retry on failure",
        "updatedLabel": "Updated",
        "yes": "Yes",
        "no": "No",
        "transformationSqlLabel": "Transformation SQL",
        "customCodeLabel": "Custom code"
      }
    }
  },
  "home": {
    "tabs": {
      "overview": "Overview",
      "agents": "Agents",
      "workflows": "Workflows",
      "evals": "Evals",
      "sessions": "Sessions",
      "cost": "Cost",
      "platform": "Platform"
    },
    "dateRangeAriaLabel": "Dashboard date range",
    "sectionInfoAriaLabel": "Section info",
    "viewLabel": "View {{label}}",
    "loading": "Loading dashboard...",
    "loadFailed": "Failed to load data",
    "retry": "Retry",
    "noDataAvailable": "No data available",
    "noData": "No data",
    "quickActions": {
      "createAgent": "Create Agent",
      "newWorkflow": "Create Workflow",
      "runEval": "Run Eval",
      "aiAgentBuilder": "AI Agent Builder",
      "aiWorkflowsBuilder": "AI Workflows Builder",
      "agentStore": "Agent Store",
      "workflowStore": "Workflow Store",
      "tools": "Tools"
    },
    "activity": {
      "title": "Recent Activity",
      "export": "Export",
      "filterAll": "All",
      "filterUpdate": "Update",
      "filterCreate": "Create",
      "filterDelete": "Delete",
      "noActivityFound": "No activity found",
      "actionCreate": "CREATE",
      "actionUpdate": "UPDATE",
      "actionDelete": "DELETE",
      "actionRead": "READ",
      "resourceIdTitle": "Resource ID",
      "viewAll": "View all"
    },
    "overview": {
      "kpi": {
        "totalAgents": "Total Agents",
        "totalAgentsHintDefault": "Created in the selected period",
        "totalAgentsHintAllTenants": "Created in the selected period · all tenants · excludes archived",
        "totalAgentsHintStudio": "Created in the selected period · same scope as Agent Studio",
        "totalWorkflows": "Total Workflows",
        "activeUsers": "Active Users",
        "activeDeployments": "Active Deployments",
        "activeDeploymentsHint": "Active deployments created in the selected period",
        "sessions": "Sessions",
        "evalRuns": "Eval Runs",
        "toolCalls": "Tool Calls",
        "archivedDelta": "archived",
        "totalProjects": "Total Projects",
        "activeProjects": "Active Projects",
        "modelsAvailable": "Models Available",
        "toolsAvailable": "Tools Available",
        "activeConnections": "Active Connections",
        "pendingApprovals": "Pending Approvals",
        "actionNeeded": "Action needed"
      },
      "funnel": {
        "active": "Active",
        "deployments": "Deployments"
      },
      "series": {
        "agentsCreated": "Agents Created",
        "projects": "Projects",
        "sessions": "Sessions",
        "workflows": "Workflows",
        "evals": "Evals",
        "medianRuntime": "Median Runtime (ms)",
        "retryRate": "Retry Rate %",
        "slaBreaches": "SLA Breaches"
      },
      "platformTrendTitle": "Platform Trend",
      "platformTrendSubtitle": "Growth and activity of platform entities over time",
      "loadingPlatformTrend": "Loading platform trend...",
      "loadingActivity": "Loading activity...",
      "quickActionsTitle": "Quick Actions",
      "adoptionHealthTitle": "Adoption & Health",
      "adoptionFunnelTitle": "Adoption Funnel",
      "adoptionFunnelSubtitle": "Project journey from setup to active usage",
      "adoptionFunnelInfo": "Shows project progression. Each bar represents the count of projects that reached that stage.\n• Total Projects: All projects created.\n• Active: Projects modified in the selected timeframe.\n• Deployments: Projects with at least one active deployment.\n• Sessions: Projects with user sessions in the timeframe.",
      "topRiskSignalTitle": "Top Risk Signal",
      "topRiskSignalSubtitle": "Most critical platform risk and health alerts",
      "topRiskSignalInfo": "Highlights the most critical platform risk right now, based on workflow failure rates and session activity trends. The chart shows SLA breach counts.",
      "riskSeverityWarn": "warn",
      "noActiveRiskSignal": "No active risk signal",
      "metricFallback": "Metric",
      "workflowHealthTitle": "Workflow Health",
      "workflowHealthSubtitle": "Performance and reliability metrics for executions",
      "workflowHealthInfo": "Tracks the health of workflow executions. Median Runtime shows processing speed, Retry Rate indicates reliability issues, and SLA Breaches flag failed or timed-out executions.",
      "actionableHighlightsTitle": "Actionable Highlights",
      "actionableHighlightsSubtitle": "Top entities ranked by activity and recommendations",
      "actionableHighlightsInfo": "Top projects ranked by session activity and eval coverage.\n\nHealth Status:\n• Good: > 0 Sessions, > 0 Eval Runs\n• Warn: > 0 Sessions, 0 Eval Runs\n• Bad: 0 Sessions\n\nEach row shows session counts, eval runs, and a recommended action to improve platform adoption or quality.",
      "noHighlightsYet": "No highlights yet",
      "table": {
        "entity": "Entity",
        "type": "Type",
        "sessions": "Sessions",
        "evalRuns": "Eval Runs",
        "failurePercent": "Failure %",
        "health": "Health",
        "recommendedAction": "Recommended Action"
      }
    },
    "na": "N/A",
    "agents": {
      "kpi": {
        "draft": "Draft",
        "published": "Published",
        "registered": "Registered",
        "deployed": "Deployed",
        "storeListings": "Store Listings"
      },
      "sections": {
        "byEnvironment": "Agents by Environment",
        "byEnvironmentInfo": "Distribution of active agents deployed across different environments.",
        "byStatusInfo": "Current operational status of agents (draft, active, archived).",
        "registryStatusInfo": "Registration status of agents in the agent registry.",
        "deploymentPipelineInfo": "Current stage of agents in the deployment lifecycle from draft to production.",
        "byStatus": "Agent Status",
        "registryStatus": "Registry Status",
        "deploymentPipeline": "Deployment Pipeline",
        "byProjectsTitle": "Agents by Projects",
        "byProjectsSubtitle": "Distribution of agents across projects"
      },
      "barName": "Agents"
    },
    "workflows": {
      "kpi": {
        "executions": "Executions",
        "successRate": "Success Rate",
        "activeSchedules": "Active Schedules"
      },
      "sections": {
        "executionStatus": "Execution Status",
        "executionStatusSubtitle": "Distribution of workflow executions by status.",
        "triggerSource": "Trigger Source",
        "triggerSourceSubtitle": "Breakdown of workflow executions by trigger source.",
        "executionVolumeTitle": "Execution Volume",
        "executionVolumeSubtitle": "Total workflow executions over the selected period",
        "successRateTrendTitle": "Success Rate Trend",
        "successRateTrendSubtitle": "Percentage of successful executions over time",
        "scheduleOverview": "Schedule Overview",
        "recentExecutions": "Recent Executions"
      },
      "noRecentExecutions": "No recent executions",
      "series": {
        "executions": "Executions",
        "successPercent": "Success %"
      },
      "statusActive": "Active",
      "statusPaused": "Paused",
      "everySeconds": "Every {{seconds}}s",
      "table": {
        "workflow": "Workflow",
        "type": "Type",
        "schedule": "Schedule",
        "status": "Status",
        "nextRun": "Next Run",
        "trigger": "Trigger",
        "duration": "Duration",
        "started": "Started"
      }
    },
    "evals": {
      "kpi": {
        "totalEvalSessions": "Total Eval Sessions",
        "totalEvalSessionsHint": "Sessions created in the selected period (respects the date filter).",
        "avgEvalQualityScore": "Avg Eval Quality Score",
        "avgEvalQualityScoreHint": "Mean summary metric score across eval sessions in the selected period.",
        "passRate": "Pass Rate",
        "passRateHint": "Share of summary metrics scoring ≥70% in the selected period."
      },
      "zones": {
        "poor": "Poor",
        "fair": "Fair",
        "good": "Good"
      },
      "sections": {
        "averageScoreTitle": "Average Eval Quality Score",
        "averageScoreSubtitle": "Average quality score across evaluated sessions",
        "sessionsByStatus": "Sessions by Status",
        "sessionsByStatusSubtitle": "Breakdown of evaluation sessions by status",
        "sessionsTrendTitle": "Eval Sessions Trend",
        "sessionsTrendSubtitle": "Volume of evaluation sessions over time",
        "frameworkDistribution": "Framework Distribution",
        "frameworkDistributionSubtitle": "Breakdown of evaluation sessions by framework",
        "topEvaluatedAgents": "Top Evaluated Agents",
        "topEvaluatedAgentsSubtitle": "Most frequently evaluated agents and their latest scores"
      },
      "series": {
        "evalSessions": "Eval Sessions"
      },
      "table": {
        "agent": "Agent",
        "evalSessions": "Eval Sessions",
        "latestScore": "Latest Score",
        "framework": "Framework"
      }
    },
    "sessions": {
      "kpi": {
        "activeSessionsInPeriod": "Active Sessions (in period)",
        "activeSessionsHint": "Sessions that had at least one message or turn in the selected time window.",
        "avgTurnsPerSession": "Avg Turns / Session",
        "avgTurnsHint": "Average conversational turns per session among sessions active in the selected time window.",
        "messages": "Messages",
        "avgLatency": "Avg Latency",
        "avgCostPerCall": "Avg Cost / Call",
        "avgCostPerCallHint": "Matches Cost tab (LLM logs + usage events)."
      },
      "sections": {
        "byEnvironment": "Sessions by Environment",
        "byEnvironmentSubtitle": "Distribution of active sessions across different environments.",
        "visibilityDistribution": "Visibility Distribution",
        "visibilityDistributionSubtitle": "Breakdown of sessions by visibility level.",
        "sessionTrendTitle": "Session Trend",
        "sessionTrendSubtitle": "Daily session count over the selected time period.",
        "messagesTrendTitle": "Messages Trend",
        "messagesTrendSubtitle": "Daily message volume across all sessions.",
        "tokenUsageTitle": "Token usage",
        "tokenUsageSubtitle": "Same daily totals as the Cost tab (LLM logs + usage events).",
        "latencyTrendTitle": "Latency Trend",
        "latencyTrendSubtitle": "Average and percentile response latencies over time.",
        "topAgentsBySessions": "Top Agents by Sessions"
      },
      "series": {
        "tokens": "Tokens",
        "avgLatency": "Avg Latency",
        "p90Latency": "P90 Latency",
        "p95Latency": "P95 Latency",
        "p99Latency": "P99 Latency"
      },
      "table": {
        "agent": "Agent",
        "sessions": "Sessions",
        "messages": "Messages",
        "avgLatency": "Avg Latency",
        "avgTokens": "Avg Tokens"
      }
    },
    "cost": {
      "kpi": {
        "totalTokens": "Total Tokens",
        "inputTokens": "Input Tokens",
        "outputTokens": "Output Tokens",
        "cachedTokens": "Cached Tokens",
        "estCost": "Est. Cost",
        "llmCalls": "LLM Calls",
        "avgTokensPerCall": "Avg Tokens/Call",
        "dailyAvgCost": "Daily Avg Cost",
        "peakUsageDate": "Peak Usage Date",
        "peakTokens": "Peak Tokens",
        "dailyAvgTokens": "Daily Avg Tokens",
        "avgCostPerCall": "Avg Cost/Call"
      },
      "sections": {
        "tokenUsageTrendTitle": "Token Usage Trend",
        "tokenUsageTrendSubtitle": "Volume of tokens processed over time",
        "costTrendTitle": "Cost Trend",
        "costTrendSubtitle": "Estimated operational cost over time",
        "tokensByServiceTitle": "Tokens by Service",
        "tokensByServiceSubtitle": "Total token usage across different system services",
        "costByServiceTitle": "Estimated Cost by Service",
        "costByServiceSubtitle": "Financial impact breakdown by system service",
        "tokensByConsumerTitle": "Tokens by Consumer",
        "tokensByConsumerSubtitle": "Token consumption distributed by API consumers",
        "costByConsumerTitle": "Estimated Cost by Consumer",
        "costByConsumerSubtitle": "Cost breakdown across different API consumers",
        "tokenDistByModelTitle": "Token Distribution by Model",
        "tokenDistByModelSubtitle": "Proportional usage of tokens across different AI models",
        "tokenDistByModelSubtitleModelId": "Token totals rolled up by provider model id",
        "tokenDistByModelSubtitleDisplayName": "Token totals for each catalog display name",
        "costByModelTitle": "Cost Estimate by Model",
        "costByModelSubtitle": "Estimated expenses attributed to each AI model",
        "costByModelSubtitleModelId": "Estimated cost rolled up by provider model id",
        "costByModelSubtitleDisplayName": "Estimated cost for each catalog display name",
        "modelGroupingModelId": "Model ID",
        "modelGroupingDisplayName": "Display name",
        "modelGroupingForChart": "{{chart}} grouping",
        "tokensByProjectTitle": "Token Consumption by Project",
        "tokensByProjectSubtitle": "Total tokens utilized per registered project",
        "costByProjectTitle": "Estimated Cost by Project",
        "costByProjectSubtitle": "Financial breakdown of AI usage across projects",
        "tokensByAgentTitle": "Token Consumption by Agent",
        "tokensByAgentSubtitle": "Token usage tracked per individual AI agent",
        "costByAgentTitle": "Estimated Cost by Agent",
        "costByAgentSubtitle": "Financial impact of specific AI agents",
        "tokensByWorkflowTitle": "Token Consumption by Workflow",
        "tokensByWorkflowSubtitle": "Token volume processed by automated workflows",
        "costByWorkflowTitle": "Estimated Cost by Workflow",
        "costByWorkflowSubtitle": "Cost attributed to executing AI workflows",
        "tokensByEnvironmentTitle": "Token Consumption by Environment",
        "tokensByEnvironmentSubtitle": "Usage metrics split across deployment environments",
        "costByEnvironmentTitle": "Estimated Cost by Environment",
        "costByEnvironmentSubtitle": "Financial breakdown by deployment environment",
        "tokensByUsersTitle": "Token Consumption by Users",
        "tokensByUsersSubtitle": "Token volume utilized by individual end users",
        "costByUsersTitle": "Estimated Cost by Users",
        "costByUsersSubtitle": "Operational expenses attributed to specific users",
        "topCostDriversTitle": "Top Cost Drivers",
        "topCostDriversSubtitle": "Highest-consuming agents and workflows contributing to platform costs"
      },
      "noDataRange": {
        "projectToken": "No project token data in this range.",
        "projectCost": "No project cost data in this range.",
        "agentToken": "No agent token data in this range.",
        "agentCost": "No agent cost data in this range.",
        "workflowToken": "No workflow token data in this range.",
        "workflowCost": "No workflow cost data in this range.",
        "environmentToken": "No environment token data in this range.",
        "environmentCost": "No environment cost data in this range.",
        "userToken": "No user token data in this range.",
        "userCost": "No user cost data in this range."
      },
      "barName": {
        "tokens": "Tokens",
        "usd": "USD",
        "models": "Models"
      },
      "table": {
        "driver": "Driver",
        "type": "Type",
        "typeAgent": "Agent",
        "typeWorkflow": "Workflow",
        "totalTokens": "Total Tokens",
        "inputTokens": "Input Tokens",
        "outputTokens": "Output Tokens",
        "estCost": "Est. Cost"
      }
    },
    "platform": {
      "kpi": {
        "totalTenants": "Total Tenants",
        "totalUsers": "Total Users",
        "rejectedUsers": "Rejected Users"
      },
      "sections": {
        "userGrowthTitle": "User Growth",
        "userGrowthSubtitle": "Trend of new user registrations over time.",
        "usersByRoleTitle": "Users by Role",
        "usersByRoleSubtitle": "Distribution of users across different platform roles.",
        "approvalDecisionsTitle": "Approval Decisions",
        "approvalDecisionsSubtitle": "Trend of user access approval and rejection decisions.",
        "userStatusDistributionTitle": "User Status Distribution",
        "userStatusDistributionSubtitle": "Current status distribution of all platform users.",
        "auditActivityTitle": "Audit Activity",
        "tenantOverviewTitle": "Tenant Overview"
      },
      "series": {
        "newUsers": "New Users",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "table": {
        "tenant": "Tenant",
        "users": "Users",
        "projects": "Projects",
        "agents": "Agents",
        "created": "Created"
      }
    }
  },
  "blueprints": {
    "common": {
      "all": "All",
      "cancel": "Cancel",
      "deepThinkingDesc": "Thorough analysis",
      "deepThinkingLabel": "Deep Thinking",
      "delete": "Delete",
      "deleteBlueprintMessage": "Remove \"{{name}}\"? This cannot be undone.",
      "deleteBlueprintTitle": "Delete blueprint?",
      "dismiss": "Dismiss",
      "expressModeDesc": "Fast, direct generation",
      "expressModeLabel": "Express Mode",
      "loading": "Loading blueprints...",
      "modeDeep": "Deep",
      "modeFast": "Fast",
      "noProjectsFound": "No projects found. Please create a project and select it to continue.",
      "noProjectsFoundBusinessUser": "No projects are assigned to your account. Contact your administrator to be added to a project before you can continue.",
      "noSystemBlueprints": "No system blueprints.",
      "proceed": "Proceed",
      "removeAttachedFile": "Remove attached file",
      "scopeLibrary": "Custom",
      "scopeLibraryTooltip": "Blueprints created in your workspace",
      "scopeSystem": "System",
      "scopeSystemTooltip": "Default blueprints from the platform",
      "searchAriaLabel": "Search blueprints",
      "searchPlaceholder": "Search blueprints…",
      "searchSelectProjectPlaceholder": "Search and select a project...",
      "selectProjectLabel": "A project is required to get started:",
      "selectProjectTitle": "Select Project",
      "selectThinkingModeTitle": "Select thinking mode",
      "sourceAriaLabel": "Blueprint source",
      "stopRecording": "Stop recording",
      "systemBadge": "System",
      "systemBadgeTitle": "Platform starter — read-only",
      "targetAgent": "Agent",
      "targetWorkflow": "Workflow",
      "thinkingModeHeader": "Thinking Mode",
      "uploadFile": "Upload file",
      "voiceInput": "Voice input"
    },
    "list": {
      "activeBlueprintsTitle": "Active blueprints",
      "addToSpotlight": "Add to spotlight",
      "archive": "Archive",
      "archiveBlueprintMessage": "Archive \"{{name}}\"? It will be hidden from active listings.",
      "archiveBlueprintTitle": "Archive blueprint?",
      "archivedBlueprintsTitle": "Archived blueprints",
      "backTitle": "Back",
      "cardActionsAriaLabel": "Card actions",
      "catalogScopeTitle": "Blueprint catalog scope",
      "closeAriaLabel": "Close",
      "delete": "Delete",
      "done": "Done",
      "edit": "Edit",
      "errorCount": "{{count}} error(s)",
      "export": "Export",
      "filters": {
        "type": "Type",
        "status": "Status",
        "draft": "Draft",
        "pendingReview": "Pending review",
        "pending": "Pending",
        "approved": "Approved",
        "archived": "Archived",
        "industry": "Domain",
        "creator": "Creator"
      },
      "filtersTitle": "Filters",
      "fork": "Fork",
      "goBackAriaLabel": "Go back",
      "importAriaLabel": "Import blueprint",
      "importCompleteHeading": "Import complete",
      "importErrorSubtitle": "Some items could not be imported. See details below.",
      "importFinishedWithErrorsHeading": "Import finished with errors",
      "importSuccessSubtitle": "Your blueprint was imported as a draft and is ready to review.",
      "importTitle": "Import blueprint from YAML",
      "loadingMore": "Loading more blueprints...",
      "newBlueprint": "New blueprint",
      "noBlueprintsMatchFilters": "No blueprints match your filters.",
      "noBlueprintsYet": "No blueprints yet.",
      "pageSubtitle": "Process specs for Conversational Workflow and Agent Builder",
      "pageTitle": "Blueprints",
      "refreshAriaLabel": "Refresh list",
      "refreshTitle": "Refresh",
      "removeFromSpotlight": "Remove from spotlight",
      "spotlightBadgeTitle": "Spotlight {{rank}} — shown first on the DIP landing page (Quick Start)",
      "spotlightFullTitle": "Spotlight is full (max {{max}}). Remove one from spotlight first.",
      "statCreated": "Created",
      "statFailed": "Failed",
      "statSkipped": "Skipped",
      "systemCreatorFallback": "System",
      "toasts": {
        "addedToSpotlight": "Blueprint added to DIP spotlight",
        "archiveFailed": "Archive failed",
        "blueprintArchived": "Blueprint archived",
        "blueprintDeleted": "Blueprint deleted",
        "blueprintExported": "Blueprint exported",
        "blueprintForked": "Blueprint forked",
        "blueprintImported": "Blueprint imported",
        "blueprintUnarchived": "Blueprint unarchived",
        "couldNotAddToSpotlight": "Could not add to spotlight",
        "couldNotRemoveFromSpotlight": "Could not remove from spotlight",
        "deleteFailed": "Delete failed",
        "exportFailed": "Export failed",
        "forkFailed": "Fork failed",
        "importCompletedWithErrors": "Import completed with errors",
        "importFailed": "Import failed",
        "importedWithWarnings": "Blueprint imported with {{count}} warning(s)",
        "removedFromSpotlight": "Removed from DIP spotlight",
        "unarchiveFailed": "Unarchive failed"
      },
      "typeAgent": "Agent",
      "typeTabsAriaLabel": "Blueprint type",
      "typeWorkflow": "Workflow",
      "unarchive": "Unarchive",
      "unarchiveBlueprintMessage": "Restore \"{{name}}\" back to draft status?",
      "unarchiveBlueprintTitle": "Unarchive blueprint?",
      "unarchiveRename": {
        "confirm": "Restore to draft",
        "fieldName": "Blueprint name",
        "message": "An active blueprint named \"{{name}}\" already exists. Enter a new name to restore the archived blueprint as a draft.",
        "nameLabel": "New blueprint name*",
        "namePlaceholder": "Enter a unique blueprint name",
        "nameTaken": "A blueprint with this name already exists",
        "restoring": "Restoring…",
        "title": "Restore blueprint",
        "nameInUseToast": "That name is already in use. Choose a different name."
      },
      "warningCount": "{{count}} warning(s)"
    }
  },
  "ideate": {
    "aiPrefix": "AI",
    "backToPlatformAriaLabel": "Back to Decision Intelligence Platform",
    "blueprintDeletedToast": "Blueprint deleted",
    "blueprintFallback": "Blueprint",
    "blueprintLaunchHeader": "Blueprint launch",
    "buildWithBlueprint": "Build with a Blueprint",
    "buildDirectLabel": "Build directly",
    "buildDirectHint": "Skip follow-up questions and build from a complete spec. Set this before attaching a file. Off keeps the current questions.",
    "chooseProjectPlaceholder": "Choose a project…",
    "complianceAriaLabel": "Compliance requirements",
    "complianceLabel": "Compliance",
    "couldNotOpenSharedSession": "Could not open shared session",
    "deleteFailedToast": "Delete failed",
    "deleteSessionMessage": "Are you sure you want to delete this session? This action cannot be undone.",
    "deleteSessionTitle": "Delete Session",
    "deployAriaLabel": "Deploy {{name}} with {{brand}}",
    "deployWithDip": "Deploy with Decision Intelligence Platform",
    "deployWithDipAriaLabel": "Deploy {{name}} with Decision Intelligence Platform",
    "deployWithTitle": "Deploy with {{brand}}",
    "guidedLaunchDesc": "Full web research, clarification & LLM validation",
    "guidedLaunchLabel": "Guided Launch",
    "importHeader": "Import",
    "importN8nDesc": "Bring an existing n8n JSON into AI Workflows",
    "importN8nLabel": "Import n8n workflow",
    "lookingForBlueprints": "Looking for blueprints in this domain…",
    "moreIndustries": "More",
    "noBlueprintsAvailable": "No blueprints available. Add blueprints to try.",
    "noBlueprintsForFilter": "No blueprints available for this filter.",
    "noBlueprintsForIndustry": "No blueprints for this domain.",
    "placeholderAgent": "Describe an agent to build...",
    "placeholderWorkflow": "Describe a use case to automate...",
    "placeholderWorkflowShort": "Describe a workflow to automate...",
    "preBuiltBlueprints": "Blueprints",
    "quickLaunchDesc": "Skip research; use blueprint guidelines & KPIs as-is",
    "quickLaunchLabel": "Quick Launch",
    "requireOptTitle": "Require {{label}}",
    "spotlightBadgeTitleShort": "Shown first on the DIP landing page (Quick Start)",
    "spotlightRank": "Spotlight {{rank}}",
    "tagline": "Discover. Reimagine. Optimize. Go Live",
    "untitledSession": "Untitled Session",
    "uploadDocumentOrImage": "Upload document or image",
    "compliance": {
      "soc2": "SOC 2 / SOX",
      "gdpr": "GDPR / Data residency",
      "hipaa": "HIPAA",
      "pii": "PII masking required"
    }
  },
  "pipelineDesigner": {
    "list": {
      "searchPlaceholder": "Search designs...",
      "emptyMessage": "No Orchestrator Workflows yet",
      "newWorkflow": "New Orchestrator Workflow",
      "columnName": "Name",
      "columnDescription": "Description",
      "columnStatus": "Status",
      "columnUpdatedAt": "Updated At",
      "columnCreatedAt": "Created At",
      "columnActions": "Actions",
      "actionEdit": "Edit",
      "actionDelete": "Delete",
      "createFailed": "Failed to create design",
      "deleteFailed": "Failed to delete design",
      "deletedToast": "Design \"{{name}}\" deleted",
      "filterStatusLabel": "Status",
      "deleteDialogTitle": "Delete Design",
      "deleteDialogMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "deleteDialogConfirm": "Delete Design",
      "cancel": "Cancel"
    },
    "status": {
      "draft": "Draft",
      "published": "Published",
      "pending": "Pending",
      "running": "Running",
      "success": "Success",
      "failed": "Failed",
      "cancelled": "Cancelled",
      "terminating": "Terminating",
      "timed_out": "Timed out",
      "unknown": "Unknown"
    },
    "canvas": {
      "loading": "Loading design...",
      "tabCanvas": "Canvas",
      "tabRuns": "Runs",
      "tabSettings": "Settings",
      "publishButton": "Publish & Run",
      "publishDisabledTitle": "Choose an orchestrator connection on the Settings tab to publish.",
      "settingsTitle": "Design settings",
      "orchestratorRuntimeTitle": "Orchestrator runtime",
      "orchestratorRuntimeDesc": "Publishing requires a tenant orchestrator connection that matches the target type. Credentials are resolved from the connector, not stored in the graph.",
      "targetOrchestratorLabel": "Target orchestrator",
      "saveFailed": "Failed to save design",
      "validationFailed": "Design validation failed",
      "publishFailed": "Publish failed"
    },
    "createDialog": {
      "title": "New orchestrator workflow",
      "closeAria": "Close dialog",
      "nameLabel": "Design name",
      "namePlaceholder": "e.g. nightly-feature-batch",
      "descriptionLabel": "Description (optional)",
      "descriptionPlaceholder": "Short summary for the catalog",
      "orchestratorLabel": "Target orchestrator",
      "orchestratorHint": "Publish & run uses the Enterprise Ontology publisher for Databricks Workflows today. Vertex AI and Airflow are planned.",
      "cancel": "Cancel",
      "create": "Create",
      "creating": "Creating…"
    },
    "publishDialog": {
      "title": "Publish & Run",
      "selectConnectionWarning": "Select an <1>orchestrator connection</1> on the Settings tab before publishing. The execution layer resolves credentials from that connector.",
      "translateJobText": "This will translate <1>{{designName}}</1> into a <2>{{orchestratorType}}</2> job, create it, and immediately trigger a run.",
      "notebookParamsLabel": "Notebook Parameters (optional JSON)",
      "cancel": "Cancel",
      "publish": "Publish & Run",
      "publishing": "Publishing...",
      "orchestratorFallback": "orchestrator"
    },
    "nodeConfig": {
      "nodeTitle": "{{type}} Node",
      "noConfigurableProps": "This node has no configurable properties.",
      "taskConfigTitle": "Task Configuration",
      "labelLabel": "Label",
      "labelPlaceholder": "Task name",
      "notebookPathLabel": "Notebook Path",
      "notebookPathPlaceholder": "/notebooks/my_notebook.py",
      "notebookPathHint": "Path relative to the Git repository root.",
      "timeoutLabel": "Timeout (seconds)",
      "maxRetriesLabel": "Max Retries",
      "retryOnTimeoutLabel": "Retry on timeout"
    },
    "canvasEditor": {
      "addTask": "Add Task",
      "saveNow": "Save now",
      "allChangesSaved": "All changes saved",
      "saving": "Saving…",
      "saveFailedUseSaveNow": "Save failed — use Save now",
      "unsavedWillAutoSave": "Unsaved — will save automatically",
      "delete": "Delete",
      "newTaskLabel": "New Task"
    },
    "gitSource": {
      "title": "Git Source",
      "repoUrlLabel": "Repository URL",
      "repoUrlPlaceholder": "https://github.com/org/repo",
      "providerLabel": "Provider",
      "branchLabel": "Branch",
      "branchPlaceholder": "main",
      "branchError": "Enter a valid branch name (letters, numbers, /, -, _, . only)."
    },
    "runs": {
      "noRuns": "No runs yet. Publish the design to create a run.",
      "colStatus": "Status",
      "colRunId": "Run ID",
      "colStarted": "Started",
      "colDuration": "Duration",
      "colExternal": "External",
      "colActions": "Actions",
      "runningLabel": "Running...",
      "view": "View",
      "cancel": "Cancel"
    },
    "runDetail": {
      "loading": "Loading run details...",
      "title": "Run Detail",
      "runId": "Run ID",
      "externalRunId": "External Run ID",
      "started": "Started",
      "completed": "Completed",
      "viewInOrchestrator": "View in orchestrator",
      "cancelling": "Cancelling...",
      "cancelRun": "Cancel Run",
      "taskStates": "Task States"
    },
    "orchestratorConnection": {
      "label": "Orchestrator connection",
      "loadingConnections": "Loading connections…",
      "optionalSelectToEnable": "Optional — select to enable Publish & Run",
      "noConnections": "No connections for this orchestrator type.",
      "addOneLink": "Add one under Connections → Orchestrators"
    },
    "nodes": {
      "start": "Start",
      "end": "End",
      "untitledTask": "Untitled Task"
    }
  },
  "agentStudio": {
    "loading": "Loading agent studio...",
    "permissionDeniedMessage": "You are not Authorized to view this Page, Please contact your administrator",
    "untitledAgent": "Untitled Agent",
    "identityAccess": {
      "subtitle": "How this agent reaches its tools and knowledge",
      "loading": "Loading access",
      "empty": "No tools or knowledge sources are attached.",
      "error": "Could not load identity access.",
      "usesIdentity": "Uses agent identity",
      "usesOwn": "Uses its own credential",
      "entraUnsupported": "Entra credential not supported yet - uses registered service principal",
      "coverageOff": "Identity coverage is off - uses registered service principal",
      "blocked": "Blocked: turn OBO on or off",
      "verify": "Verify access",
      "verifying": "Verifying",
      "verified": "Verified",
      "tokenOk": "Token issued",
      "consentMissing": "Consent missing",
      "needsUser": "Needs a signed-in user",
      "denied": "Resource denied",
      "tokenFailed": "Token failed",
      "notApplicable": "Not applicable",
      "unsupported": "Unsupported",
      "stale": "Stale",
      "blockedStatus": "Blocked",
      "saveWarning": "Some attached resources still use their registered credential.",
      "fallbackFail": "Fail (recommended)",
      "fallbackRegistered": "Use the registered credential",
      "fallbackLabel": "If the identity is denied",
      "fallbackHelp": "The registered credential is broader than the agent identity. Use it only when this agent must keep working if the identity is refused.",
      "fallbackColumn": "If denied",
      "knowledgeHint": "If the resource rejects the identity, this agent will fail. Grant access, or ask an admin to remove the identity.",
      "fallbackChip": "Falls back to the registered service principal"
    },
    "fallbackAgentName": "Agent",
    "ok": "OK",
    "closeDialogAriaLabel": "Close dialog",
    "list": {
      "columnAgentName": "Agent Name",
      "columnProject": "Project",
      "columnAgentIdentity": "Agent Identity",
      "columnAgentIdentityShort": "Identity",
      "columnVersion": "Version",
      "columnStatus": "Status",
      "columnCreator": "Creator",
      "columnCreatedAt": "Created at",
      "columnUpdatedAt": "Updated at",
      "columnActions": "Actions",
      "registeredToRegistryTitle": "Registered to Registry",
      "emptyFavorites": "No favorite agents yet — star agents in the list to bookmark them",
      "emptyArchived": "No archived agents",
      "emptyDefault": "No agents found",
      "filterFavoritesTitle": "Filter by favorites",
      "allAgents": "All Agents",
      "favorites": "Favorites",
      "catalogTitle": "Agent catalog",
      "activeAgentsTitle": "Active agents",
      "archivedAgentsTitle": "Archived agents",
      "guidedTourTitle": "Take guided tour of Agent Studio",
      "autoTune": "Auto Tune",
      "createAgent": "Create Agent",
      "exportSelected": "Export Selected",
      "archiveSelected": "Archive Selected",
      "deleteSelected": "Delete Selected",
      "exportFileName": "Agent_Studio",
      "exportFileNameArchived": "Agent_Studio_Archived"
    },
    "filters": {
      "status": "Status",
      "registryStatus": "Registry status",
      "draft": "Draft",
      "published": "Published",
      "registered": "Registered",
      "unregistered": "Unregistered",
      "project": "Project",
      "creator": "Creator"
    },
    "actions": {
      "restoreToDraft": "Restore to draft",
      "view": "View",
      "chat": "Chat",
      "traces": "Traces",
      "selfHeal": "Self heal",
      "logs": "Logs",
      "exportYaml": "Export (YAML)",
      "exportJson": "Download Agent JSON",
      "evaluate": "Evaluate",
      "viewEvaluationRuns": "View Evaluation Runs",
      "registerToRegistry": "Register to Registry",
      "registrationPending": "Registration Pending",
      "approvalLogs": "Approval logs",
      "unregisterFromRegistry": "Unregister from Registry",
      "clone": "Clone",
      "archive": "Archive"
    },
    "selfHeal": {
      "breadcrumb": "Self heal",
      "agentStudio": "Agent Studio",
      "title": "Self heal",
      "intro": "Scan traces created since the last successful Self heal run, find performance gaps, and save a recommendation for each one.",
      "llmModel": "LLM model",
      "llmModelPlaceholder": "Select a model",
      "llmModelEmpty": "No LLM models are configured for this project.",
      "llmModelSearch": "Search models",
      "run": "Self heal",
      "running": "Scanning traces…",
      "loading": "Loading recommendations…",
      "emptyPrompt": "Run Self heal to scan traces created since the last successful run. Each gap is saved as a recommendation you can mark done after you read it.",
      "recommendations": "Recommendations",
      "howToFix": "How to fix",
      "markDone": "Mark as done",
      "markingDone": "Saving…",
      "done": "Done",
      "statusOpen": "Open",
      "readHint": "Mark this done after you have read the recommendation.",
      "cannotEdit": "You need Agent Studio edit access to run Self heal or mark a recommendation done.",
      "loadFailed": "Could not load self-heal recommendations.",
      "runFailed": "Self heal could not finish.",
      "analysis": {
        "engineLabel": "Analysis engine",
        "engineModel": "{{model}}",
        "engineModelFallback": "Selected model",
        "engineRules": "Rule-based",
        "engineFallback": "Fallback (Rule-based)",
        "fallbackTitle": "Model unavailable",
        "fallbackNotice": "Model \"{{model}}\" failed ({{reason}}). Results fell back to standard rule-based analysis.",
        "fallbackNoticeUnnamed": "The selected model failed ({{reason}}). Results fell back to standard rule-based analysis.",
        "reasonAuthFailed": "API key rejected",
        "reasonRateLimited": "rate limit reached",
        "reasonTimeout": "the request timed out",
        "reasonMisconfigured": "the model is not available for this project",
        "reasonInvalidModel": "the model selection is invalid",
        "reasonInvalidJson": "the reply could not be read",
        "reasonUnusable": "the model returned no usable recommendations",
        "reasonUnavailable": "the model could not be reached"
      },
      "markFailed": "Could not mark the recommendation done.",
      "scannedAt": "Last scan {{time}}.",
      "lastRun": "Last run",
      "detectedAt": "Detected {{time}}.",
      "openCount": "{{count}} open of {{total}}",
      "back": "{{label}}",
      "backAria": "Back to {{label}}",
      "closeDetail": "Close recommendation",
      "metadataHoverHint": "Hover for details",
      "metadataMore": "+{{count}} more",
      "metadataAria": "Metadata: {{count}} fields. Hover or open the row for full details.",
      "openTraceNamed": "Open example trace {{id}}",
      "searchPlaceholder": "Search recommendations…",
      "columns": {
        "severity": "Severity",
        "recommendation": "Recommendation",
        "issue": "Issue",
        "finding": "What we found",
        "status": "Status",
        "metadata": "Metadata",
        "exampleTraces": "Example traces",
        "traceId": "Trace ID"
      },
      "nextScan": "The next scan includes traces created after {{time}}.",
      "nextScanFirst": "The first scan includes traces that have not been scanned yet.",
      "severity": {
        "high": "High",
        "medium": "Medium",
        "low": "Low"
      },
      "drawer": {
        "summary": "What we found",
        "details": "Details"
      },
      "tabsLabel": "Self heal sections",
      "tabRecommendations": "Recommendations",
      "tabRuns": "Runs",
      "runs": {
        "title": "Run history",
        "intro": "Open any run to read the recommendations from that scan, then compare them with the next run. Configuration revision shows whether the agent changed between those scans.",
        "listLabel": "Self heal runs",
        "latestBadge": "Latest",
        "loading": "Loading runs…",
        "loadFailed": "Could not load self-heal runs.",
        "detailLoading": "Loading this run…",
        "detailFailed": "Could not load this run.",
        "empty": "No self-heal runs yet. Run Self heal to start a history you can come back to.",
        "traces": "{{count}} traces",
        "recommendations": "{{count}} recommendations",
        "configRevision": "Config revision {{revision}}",
        "configVersion": "Agent version {{version}}",
        "configSaved": "Agent saved {{time}}",
        "legacy": "Recommendations not stored",
        "older": "Older run",
        "newer": "Newer run",
        "position": "{{index}} of {{total}}, newest first",
        "meta": "{{traces}} traces · {{spans}} spans",
        "latest": "This is the latest run. After new traces are collected, run Self heal again to compare results.",
        "noSnapshot": "This run was saved before recommendation history. Later runs keep each recommendation so you can compare them.",
        "noGaps": "No performance gaps found",
        "noGapsHint": "This scan did not detect anything to fix. New recommendations appear here when a later run finds gaps.",
        "noSnapshotTitle": "Recommendations not stored",
        "historicalNote": "These are the recommendations from this run. Marking a recommendation done stays on the Recommendations tab.",
        "compareTitle": "Compared with the newer run",
        "compareWhen": "Newer run {{time}}",
        "configChanged": "The agent configuration changed before that run (revision {{from}} to {{to}}). The gaps below are what showed up after that change.",
        "configUnchanged": "The agent configuration did not change before the newer run.",
        "configUnknown": "Configuration revision was not recorded for one of these runs, so a configuration change cannot be confirmed.",
        "notComparable": "Recommendation changes are unavailable because one of these runs does not store a snapshot.",
        "sameGaps": "The newer run found the same gaps at the same severity.",
        "resolvedTitle": "No longer detected",
        "introducedTitle": "New in the newer run",
        "changedTitle": "Changed in the newer run",
        "severityShift": "{{from}} to {{to}}",
        "previousSummary": "Previously: {{summary}}"
      }
    },
    "backLabels": {
      "traces": "Traces",
      "blueprint": "Blueprint"
    },
    "publishDialog": {
      "title": "Publish Agent",
      "confirmHeading": "Are you sure you want to publish?",
      "confirmDescription": "Publishing will make this agent available for use. This action can be undone by archiving the agent.",
      "agentLabel": "Agent:",
      "frameworkLabel": "Framework:",
      "nodesLabel": "Nodes:",
      "publishButton": "Publish Agent"
    },
    "archiveDialog": {
      "title": "Archive Agent",
      "publishedHeading": "This agent is published",
      "publishedDescription": "To archive, first retire any Agent Store listing, archive deployments in Monitoring, and unregister from the Agent Registry if still registered. The agent will move to the Archived list when those are cleared.",
      "confirmMessage": "Are you sure you want to archive \"{{name}}\"?",
      "checkingDependencies": "Checking dependencies…",
      "archiveButton": "Archive Agent",
      "draftConfirmMessage": "Archive \"{{name}}\"? It will appear under Archived; you can restore it to a draft or delete it permanently from there."
    },
    "deleteDialog": {
      "title": "Delete agent",
      "confirmMessage": "Permanently delete \"{{name}}\"? This removes the agent from the system and cannot be undone."
    },
    "bulkArchive": {
      "title_one": "Archive agent",
      "title_other": "Archive agents",
      "confirmMessage": "Archive {{count}} agent(s)? They will appear under Archived; you can restore them to drafts or delete them permanently from there.",
      "confirmButton": "Archive",
      "failureMessage": "Failed to archive agents",
      "blockedMessage": "\"{{name}}\" has dependencies that must be cleared before it can be archived."
    },
    "bulkDelete": {
      "title_one": "Delete agent",
      "title_other": "Delete agents",
      "confirmMessage": "Permanently delete {{count}} agent(s)? This removes the agents from the system and cannot be undone.",
      "confirmButton": "Delete",
      "failureMessage": "Failed to delete agents",
      "blockedMessage": "\"{{name}}\" has dependencies that must be cleared before it can be deleted."
    },
    "blockedDialogs": {
      "cannotArchiveTitle": "Cannot archive agent yet",
      "cannotUnregisterTitle": "Cannot remove from registry yet",
      "unregisterDependenciesMessage": "Remove Agent Store listings and archive deployments before removing this agent from the Agent Registry.",
      "dependenciesMustBeCleared": "Dependencies must be cleared first."
    },
    "registerDialog": {
      "title": "Register to Registry",
      "submitHeading": "Submit for admin approval",
      "submitDescription": "This sends a registration request to tenant admins. The agent will not appear in the Agent Registry until an admin approves it under Approvals → Request Approvals.",
      "confirmMessage": "Submit registration request for \"{{name}}\"?",
      "metadata": "Metadata",
      "submitting": "Submitting...",
      "submitRequest": "Submit Request"
    },
    "deletePrerequisites": {
      "stillRegistered": "This agent is still registered in the Agent Registry.",
      "activeStoreListing": "There is an active Agent Store listing for this agent.",
      "nonArchivedDeployments": "There are agent deployments that are not archived yet.",
      "clearBeforeArchive": "{{details}} Clear these before you can archive."
    },
    "blockerMessages": {
      "registry": "Unregister this agent from the Agent Registry before archiving.",
      "agent_store": "Retire the active Agent Store listing for this agent before archiving.",
      "agent_deployments": "Archive all agent deployments for this agent in Monitoring before archiving.",
      "agent_store_unregister": "Retire the active Agent Store listing for this agent before removing it from the Agent Registry.",
      "agent_deployments_unregister": "Archive all deployments for this agent in Monitoring before removing it from the Agent Registry."
    },
    "blockerNav": {
      "registry": "Open Agent Registry",
      "workflow_registry": "Open Workflow Registry",
      "agent_store": "Open Agent Store (manage)",
      "agent_deployments": "Open Monitoring — Deployments",
      "workflow_store": "Open Workflow Store (manage)",
      "workflow_deployments": "Open Monitoring — Deployments",
      "running_executions": "Open Runs"
    }
  },
  "projects": {
    "status": {
      "active": "Active",
      "draft": "Draft",
      "archived": "Archived",
      "error": "Error",
      "pending": "Pending"
    },
    "list": {
      "permissionDeniedMessage": "You don't have permission to view projects. Please contact your administrator.",
      "loading": "Loading projects...",
      "columnName": "Project Name",
      "columnMembers": "Members",
      "columnStatus": "Status",
      "columnActions": "Actions",
      "filterCreatorLabel": "Creator",
      "actionOpen": "Open",
      "actionConfigure": "Configure",
      "actionEdit": "Edit",
      "actionDelete": "Delete",
      "bulkDeleteSelected": "Delete Selected",
      "emptyMessage": "No projects found",
      "createProject": "Create Project",
      "setupWizard": "Setup Wizard",
      "setupWizardTooltip": "Setup Wizard - Import YAML files to create a project",
      "deleteDialogTitle": "Delete Project",
      "deleteDialogMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "fetchingDependenciesMessage": "Fetching project dependencies…",
      "forceDeleteDialogTitle": "Confirm force delete",
      "forceDeleteDialogMessage": "Force delete will permanently remove \"{{name}}\" and all agents, deployments, Agent Store listings, simulations, prompts, skills, tools, and other project data. This cannot be undone.",
      "forceDeleteConfirmLabel": "Force delete project",
      "bulkDeleteDialogTitle": "Delete Selected Projects",
      "bulkDeleteConfirmMessage_one": "Are you sure you want to delete {{count}} project? This action cannot be undone.",
      "bulkDeleteConfirmMessage_other": "Are you sure you want to delete {{count}} projects? This action cannot be undone.",
      "bulkDeleteConfirmLabel_one": "Delete {{count}} Project",
      "bulkDeleteConfirmLabel_other": "Delete {{count}} Projects",
      "forceDeleteSuccessToast": "Project \"{{name}}\" was force-deleted",
      "forceDeleteErrorToast": "Force delete failed. Remove remaining dependencies or try again.",
      "noProjectsSelectedWarning": "No projects selected",
      "bulkDeletePartialWarning": "Deleted {{deleted}} project(s), {{skipped}} failed: {{errors}}",
      "bulkDeleteSuccessToast": "Deleted {{deleted}} project(s) successfully",
      "bulkDeleteErrorToast": "Failed to delete projects",
      "andOthers": "and {{count}} others"
    },
    "createDialog": {
      "title": "Create New Project",
      "closeAriaLabel": "Close dialog",
      "loadingQuota": "Loading quota...",
      "quotaLabel": "Projects",
      "nameLabel": "Project Name *",
      "namePlaceholder": "Enter project name",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Brief description of the project",
      "descriptionEmojiError": "Description cannot contain emoji. Use plain text only.",
      "quotaExceededTitle": "Project quota exceeded",
      "creating": "Creating..."
    },
    "editDialog": {
      "title": "Edit Project",
      "closeAriaLabel": "Close dialog",
      "nameLabel": "Project Name *",
      "descriptionLabel": "Description",
      "saving": "Saving...",
      "saveChanges": "Save Changes"
    },
    "actions": {
      "view": "View",
      "edit": "Edit",
      "chat": "Chat",
      "traces": "Traces",
      "selfHeal": "Self heal",
      "logs": "Logs",
      "evaluate": "Evaluate",
      "viewEvaluationRuns": "View Evaluation Runs",
      "cloneInAgentStudio": "Clone in Agent Studio",
      "openInAgentStudio": "Open in Agent Studio",
      "manageArchiveInStudio": "Manage archive in Studio",
      "open": "Open",
      "runs": "Runs",
      "editCanvas": "Edit canvas",
      "viewInStudio": "View in Studio",
      "testChat": "Test / Chat",
      "deployInRegistry": "Deploy in Registry",
      "guardrails": "Guardrails",
      "chatDetail": "Chat / detail",
      "runtimeSettings": "Runtime settings",
      "openInMonitoring": "Open in Monitoring"
    },
    "detail": {
      "notFound": "Project not found",
      "backToProjectsButton": "Back to Projects",
      "backToProjectsAriaLabel": "Back to projects",
      "viewOnlyBadge": "View Only",
      "tabsAriaLabel": "Project Details Tabs",
      "tabs": {
        "overview": "Overview",
        "agents": "Agents",
        "workflows": "Workflows",
        "registry": "Registry",
        "evals": "Evals",
        "deployments": "Deployments"
      }
    },
    "overview": {
      "hubSubtitle": "Project hub",
      "noTabsAvailable": "No details tabs are available for your role.",
      "openInBrand": "Open {{label}} in {{brand}}",
      "cards": {
        "agents": "Agents",
        "workflows": "Workflows",
        "registry": "Registered",
        "evals": "Eval agents",
        "deployments": "Active deployments"
      }
    },
    "members": {
      "title": "Members",
      "refreshTooltip": "Refresh members list",
      "addMemberButton": "Add Member",
      "selectedCount": "{{count}} selected",
      "changeRoleButton": "Change Role",
      "remove": "Remove",
      "clearButton": "Clear",
      "selectAllButton": "Select All",
      "noMembersYet": "No members yet",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "unknown": "Unknown",
      "creatorBadge": "Creator",
      "role": {
        "member": "Member",
        "admin": "Admin",
        "viewer": "Viewer",
        "creator": "Creator"
      },
      "memberSince": "Member since {{date}}",
      "changeRoleTitle": "Change role",
      "memberFallbackName": "member",
      "select": "Select",
      "deselect": "Deselect",
      "removeMembersTitle": "Remove Members",
      "removeMemberTitle": "Remove Member",
      "removeMembersMessage": "Are you sure you want to remove {{count}} member(s) from this project? This action cannot be undone.",
      "removeMemberMessage": "Are you sure you want to remove \"{{name}}\" from this project? This action cannot be undone.",
      "changeRoleForCount_one": "Change Role for {{count}} Member",
      "changeRoleForCount_other": "Change Role for {{count}} Members",
      "selectNewRoleLabel": "Select New Role",
      "updating": "Updating...",
      "updateRole": "Update Role",
      "loadErrorFallback": "Unable to load members. Please refresh the page.",
      "selectAtLeastOneUserError": "Please select at least one user",
      "addedSuccessToast_one": "{{count}} member added successfully",
      "addedSuccessToast_other": "{{count}} members added successfully",
      "removedSuccessToast": "Member removed successfully",
      "roleUpdatedSuccessToast": "Member role updated successfully",
      "bulkRoleUpdatedWithErrorsToast": "Updated {{updated}} members. {{errorCount}} errors occurred.",
      "bulkRoleUpdatedSuccessToast": "Successfully updated {{updated}} member role(s)",
      "bulkRemovedWithErrorsToast": "Removed {{removed}} members. {{errorCount}} errors occurred.",
      "bulkRemovedSuccessToast": "Successfully removed {{removed}} member(s)"
    },
    "configure": {
      "tabsAriaLabel": "Project Configuration Tabs",
      "tabs": {
        "members": "Members",
        "orchestrators": "Orchestrators",
        "connections": "Connections",
        "prompts": "Prompts",
        "models": "Models",
        "tools": "Tools",
        "skills": "Skills",
        "knowledge": "Knowledge",
        "dataModels": "Data Models",
        "graph": "Graph",
        "vector": "Vector",
        "storage": "Storage"
      }
    },
    "setupWizard": {
      "title": "Project Setup Wizard",
      "projectFieldLabel": "Project",
      "projectFieldPlaceholder": "Select a project...",
      "projectFieldRequiredLabel": "Project *",
      "projectNameFieldName": "Project name",
      "projectNameFieldRequiredLabel": "Project Name *",
      "projectNamePlaceholder": "My Awesome Project",
      "orDivider": "or",
      "createNewProject": "Create New Project",
      "descriptionFieldLabel": "Description",
      "descriptionPlaceholder": "Brief description...",
      "filesImportedIntoSelectedProject": "Files will be imported into the selected project",
      "dropzoneAriaLabel": "Upload YAML files. Drag and drop files here, or click or press Enter or Space to browse.",
      "dropzoneText": "Drop files here or click to browse",
      "dropzoneHint": ".yaml, .yml — agents, models, tools, prompts, skills, knowledge, connectors, IAM",
      "validFilesCount": "{{count}} valid file(s)",
      "filesWithErrorsCount": "{{count}} with errors",
      "noAgentYamlWarning": "No agent YAML detected. Consider adding an agent configuration.",
      "reviewStepTitle": "Review Import Order",
      "reviewStepDescription": "Files will be imported in the following order based on dependencies:",
      "filesWithErrorsSkipped": "{{count}} file(s) with errors will be skipped",
      "importingStepTitle": "Importing...",
      "importingProgress": "Importing {{current}} of {{total}}: {{fileName}}",
      "importActions": {
        "created": "created",
        "matched": "matched",
        "failed": "failed"
      },
      "completeStepTitleSuccess": "Setup Complete!",
      "completeStepTitleWithErrors": "Setup Completed with Errors",
      "completeStepDescription": "Your project has been set up with the following entities:",
      "summaryBadges": {
        "created": "+{{count}} created",
        "matched": "{{count}} matched",
        "failed": "{{count}} failed"
      },
      "errorsHeading": "Errors:",
      "steps": {
        "selectProject": "Select Project",
        "addFiles": "Add Files",
        "review": "Review",
        "import": "Import"
      },
      "creatingLabel": "Creating...",
      "createAndContinue": "Create & Continue",
      "continueLabel": "Continue",
      "reviewImport": "Review Import",
      "startImport": "Start Import",
      "importingLabel": "Importing...",
      "goToProject": "Go to Project",
      "entityTypes": {
        "agent": "Agent",
        "model": "Model",
        "tool": "Tool",
        "prompt": "Prompt",
        "skill": "Skill",
        "knowledge": "Knowledge",
        "connector": "Connector",
        "iam": "IAM",
        "bundle": "Bundle",
        "unknown": "Unknown"
      },
      "toasts": {
        "dropYamlFiles": "Please drop YAML files",
        "enterProjectName": "Please enter a project name",
        "projectCreated": "Project \"{{name}}\" created",
        "selectProject": "Please select a project",
        "projectSelected": "Selected project \"{{name}}\"",
        "addAtLeastOneFile": "Please add at least one YAML file",
        "noValidYamlFiles": "No valid YAML files found",
        "projectNotCreated": "Project not created",
        "noValidFilesToImport": "No valid files to import",
        "importReportedFailure": "Import of {{name}} reported failure",
        "allImportedSuccessfully": "All entities imported successfully!",
        "importPermissionError": "Import failed due to insufficient permissions. Please contact your administrator.",
        "importCompletedWithErrors": "Import completed with {{count}} error(s)"
      },
      "unknownProject": "Unknown"
    },
    "agentsTab": {
      "agentStatusTitle": "Agent status",
      "activeAgentsTitle": "Active agents",
      "archivedAgentsTitle": "Archived agents",
      "openInAgentStudio": "Open in Agent Studio",
      "noArchivedAgents": "No archived agents in this project.",
      "noAgents": "No agents in this project.",
      "goToAgentStudio": "Go to Agent Studio",
      "archiveDialogTitle": "Archive {{count}} agent(s)",
      "archiveDialogMessage": "Archive {{count}} agent(s)? They will appear under Archived; you can restore them to drafts or delete them permanently from there.",
      "archiveButtonLabel": "Archive",
      "archivedWithSkippedToast": "Archived {{deleted}} agent(s), {{skipped}} skipped due to active dependencies.",
      "archivedToast": "Archived {{count}} agent(s)",
      "exportSelected": "Export Selected",
      "archiveSelected": "Archive Selected",
      "columns": {
        "name": "Name",
        "status": "Status",
        "framework": "Framework",
        "creator": "Creator",
        "createdAt": "Created At",
        "updatedAt": "Updated At",
        "actions": "Actions"
      },
      "searchPlaceholder": "Search agents…",
      "clearSearch": "Clear search",
      "totalAgents": "Total agents {{count}}"
    },
    "workflowsTab": {
      "statusPublished": "Published",
      "columns": {
        "workflow": "Workflow",
        "status": "Status",
        "schedule": "Schedule",
        "controls": "Controls",
        "creator": "Creator",
        "runs": "Runs",
        "createdAt": "Created At",
        "tags": "Tags",
        "actions": "Actions"
      },
      "registeredToRegistryAtVersion": "Registered to Registry at v{{version}}",
      "registeredToRegistry": "Registered to Registry",
      "scheduleActive": "Schedule active",
      "schedulePaused": "Schedule paused",
      "notScheduled": "Not scheduled",
      "draftCadenceTooltip": "Cadence saved on draft — publish to start the schedule ({{cadence}}).",
      "neverRun": "never run",
      "lastRunTitle": "Last run",
      "searchPlaceholder": "Search workflows…",
      "clearSearch": "Clear search",
      "totalWorkflows": "Total workflows {{count}}",
      "catalogTitle": "Catalog",
      "activeWorkflowsTitle": "Active workflows",
      "archivedWorkflowsTitle": "Archived workflows",
      "gridViewTitle": "Grid view",
      "listViewTitle": "List view",
      "openInAgentWorkflows": "Open in Agent Workflows",
      "noSearchResults": "No workflows match your search.",
      "noArchivedWorkflows": "No archived workflows in this project.",
      "noWorkflows": "No workflows in this project.",
      "goToAgentWorkflows": "Go to Agent Workflows",
      "lastRunStatusTooltip": "Last run status: {{status}}",
      "lastRunTooltip": "Last run: {{time}}",
      "updatedTooltip": "Updated: {{time}}",
      "noDescriptionProvided": "No description provided",
      "runsCount": "{{count}} runs",
      "lastRunLabel": "Last run {{time}}",
      "pageOfTotal": "Page {{page}} of {{totalPages}}",
      "versionTitle": "Version"
    },
    "dataModelsTab": {
      "addDataModel": "Add Data Model",
      "addDataModelsToProjectTitle": "Add Data Models to Project",
      "showApprovedDataModels": "Show approved data models",
      "noRequestable": "No tenant-wide data models are available to request.",
      "requestedAccessToast": "Requested access for {{count}} data model(s). Approval is pending.",
      "alreadyInProjectToast": "{{count}} data model(s) already in project",
      "requestFailed": "Could not request data model access",
      "loadRequestableFailed": "Could not load data models available to request",
      "loadFailed": "Could not load project data models",
      "removed": "Data model removed from this project",
      "removeFailed": "Could not remove the data model",
      "bulkRemovedToast": "Successfully removed {{count}} data model(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} data model(s)",
      "remove": "Remove",
      "removeFromProject": "Remove from project",
      "removeTitle": "Remove data model",
      "removeMessage": "Remove {{name}} from this project? Workflows in this project will no longer be able to select it.",
      "bulkRemoveDialogTitle": "Remove data models",
      "bulkRemoveDialogMessage": "Remove {{count}} data model(s) from this project?",
      "empty": "No data models are linked to this project yet.",
      "pending": "Pending",
      "scopeTenant": "Tenant",
      "scopeProject": "Project",
      "statusApproved": "Approved",
      "statusPending": "Approval Pending",
      "columns": {
        "name": "Name",
        "description": "Description",
        "version": "Version",
        "scope": "Scope",
        "actions": "Actions"
      }
    },
    "skillsTab": {
      "loadError": "Failed to load skills",
      "requestedAccessToast": "Requested access for {{count}} skill(s) (pending approval)",
      "addedToast": "Added {{count}} skill(s) to project",
      "alreadyInProjectToast": "{{count}} skill(s) already in project",
      "addFailedToast": "Failed to add {{count}} skill(s)",
      "removedToast": "Skill removed from project",
      "bulkRemovedToast": "Successfully removed {{count}} skill(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} skill(s)",
      "removeFromProject": "Remove from project",
      "pending": "Pending",
      "platform": "Platform",
      "allModels": "All models",
      "columns": {
        "name": "Skill Name",
        "category": "Category",
        "type": "Type",
        "model": "Model",
        "version": "Version",
        "added": "Added",
        "lastUpdated": "Last Updated",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Unable to load skills. Please refresh the page.",
      "emptyMessage": "No skills configured for this project",
      "addSkill": "Add Skill",
      "addSkillsToProjectTitle": "Add Skills to Project",
      "showApprovedSkills": "Show approved skills",
      "removeDialogTitle": "Remove Skill",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "remove": "Remove",
      "bulkRemoveDialogTitle": "Remove Skills",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected skill(s) from this project?"
    },
    "toolsTab": {
      "requestedAccessToast": "Requested access for {{count}} tool(s) (pending approval)",
      "alreadyInProjectToast": "{{count}} tool(s) already in project",
      "addFailedToast": "Failed to add {{count}} tool(s)",
      "removedToast": "Tool removed from project",
      "bulkRemovedToast": "Successfully removed {{count}} tool(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} tool(s): {{errors}}",
      "removeFromProject": "Remove from project",
      "exportSelected": "Export Selected",
      "pending": "Pending",
      "columns": {
        "name": "Tool Name",
        "type": "Type",
        "endpoint": "Endpoint",
        "created": "Created",
        "lastUpdated": "Last Updated",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Unable to load tools. Please refresh the page.",
      "emptyMessage": "No tools configured for this project",
      "addTool": "Add Tool",
      "addToolsToProjectTitle": "Add Tools to Project",
      "showApprovedTools": "Show approved tools",
      "removeDialogTitle": "Remove Tool",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "remove": "Remove",
      "bulkRemoveDialogTitle": "Remove Tools",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected tool(s) from this project?"
    },
    "modelsTab": {
      "requestedAccessToast": "Requested access for {{count}} model(s) (pending approval)",
      "alreadyInProjectToast": "{{count}} model(s) already in project",
      "addFailedToast": "{{count}} model(s) could not be added",
      "removedToast": "Model removed successfully",
      "bulkRemovedToast": "Successfully removed {{count}} model(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} model(s): {{errors}}",
      "removeFromProject": "Remove from project",
      "pending": "Pending",
      "columns": {
        "name": "Model Name",
        "provider": "Provider",
        "modelId": "Model ID",
        "created": "Created",
        "lastUpdated": "Last Updated",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Unable to load models. Please refresh the page.",
      "emptyMessage": "No models configured for this project",
      "addModel": "Add Model",
      "addModelsToProjectTitle": "Add Models to Project",
      "showApprovedModels": "Show approved models",
      "removeDialogTitle": "Remove Model",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "remove": "Remove",
      "bulkRemoveDialogTitle": "Remove Models",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected model(s) from this project?"
    },
    "orchestratorsTab": {
      "selectAtLeastOne": "Please select at least one orchestrator",
      "requestedAccessToast": "Requested access for {{count}} orchestrator(s) (pending approval)",
      "removedToast": "Removed \"{{name}}\" from project",
      "bulkRemovedToast": "Successfully removed {{count}} orchestrator(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} orchestrator(s): {{errors}}",
      "removeFromProject": "Remove from project",
      "testConnection": "Test connection",
      "testConnectionSuccess": "Connection test successful for \"{{name}}\"",
      "testConnectionFailure": "Connection test failed for \"{{name}}\": {{message}}",
      "columns": {
        "name": "Name",
        "type": "Type",
        "host": "Host",
        "status": "Status",
        "addedBy": "Added By",
        "addedAt": "Added At",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Unable to load orchestrators. Please refresh the page.",
      "emptyMessage": "No orchestrators configured for this project",
      "addOrchestrator": "Add Orchestrator",
      "addOrchestratorsToProjectTitle": "Add Orchestrators to Project",
      "removeDialogTitle": "Remove Orchestrator",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "remove": "Remove",
      "bulkRemoveDialogTitle": "Remove Orchestrators",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected orchestrator(s) from this project?"
    },
    "connectionsTab": {
      "selectAtLeastOne": "Please select at least one connection",
      "requestedAccessToast": "Requested access for {{count}} connection(s). Tenant-wide connections stay pending until a connections admin approves them.",
      "removedToast": "Removed \"{{name}}\" from project",
      "bulkRemovedToast": "Successfully removed {{count}} connection(s) from project",
      "bulkRemoveFailedToast": "Failed to remove {{count}} connection(s): {{errors}}",
      "removeFromProject": "Remove from project",
      "pending": "Pending",
      "columns": {
        "name": "Name",
        "type": "Type",
        "host": "Host",
        "addedBy": "Added By",
        "addedAt": "Added At",
        "actions": "Actions"
      },
      "errorBoundaryMessage": "Unable to load connections. Please refresh the page.",
      "emptyMessage": "No connections configured for this project",
      "addConnection": "Add Connection",
      "addConnectionsTitle": "Add Connections to Project",
      "removeDialogTitle": "Remove Connection",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "remove": "Remove",
      "bulkRemoveDialogTitle": "Remove Connections",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected connection(s) from this project?"
    },
    "knowledgeTab": {
      "unknown": "Unknown",
      "vectorDatabase": "Vector Database",
      "vectorDbBadge": "Vector DB",
      "schemaTitle": "Schema: {{schema}}",
      "searchPlaceholder": "Search tables...",
      "clearSearch": "Clear search",
      "columns": {
        "name": "Name",
        "database": "Database",
        "rows": "Rows",
        "status": "Status",
        "creator": "Creator",
        "actions": "Actions"
      },
      "status": {
        "error": "Error",
        "active": "Active",
        "syncing": "Syncing",
        "pending": "Pending"
      },
      "actions": {
        "previewData": "Preview Data",
        "removeFromProject": "Remove from Project",
        "remove": "Remove"
      },
      "toasts": {
        "requestedAccess": "Requested access for {{count}} {{tableLabel}}{{plural}} (pending approval)",
        "alreadyInProject": "{{count}} {{tableLabel}}{{plural}} already in project",
        "requestAccessFailed": "Failed to request access for {{count}} {{tableLabel}}{{plural}}",
        "removed": "Knowledge table removed from project",
        "bulkRemoved": "Successfully removed {{count}} {{typeLabel}} table{{plural}} from project",
        "bulkRemoveFailed": "Failed to remove {{count}} {{typeLabel}} table{{plural}}: {{errors}}"
      },
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected table(s) from this project?",
      "viewToggle": {
        "database": "Database view",
        "collection": "Collection view"
      },
      "variant": {
        "knowledge": {
          "tableLabel": "knowledge table",
          "typeLabel": "knowledge",
          "addButton": "Add Knowledge",
          "emptyMessage": "No knowledge tables configured for this project",
          "addModalTitle": "Add Knowledge to Project",
          "membershipToggleLabel": "Show approved tables",
          "removeDialogTitle": "Remove Knowledge Table",
          "removeDialogTitlePlural": "Remove Knowledge Tables",
          "errorBoundaryMessage": "Unable to load knowledge tables. Please refresh the page."
        },
        "graph": {
          "tableLabel": "graph table",
          "typeLabel": "graph",
          "addButton": "Add Graph",
          "emptyMessage": "No graph tables configured for this project",
          "addModalTitle": "Add Graph Tables to Project",
          "membershipToggleLabel": "Show approved graph tables",
          "removeDialogTitle": "Remove Graph Table",
          "removeDialogTitlePlural": "Remove Graph Tables",
          "errorBoundaryMessage": "Unable to load graph tables. Please refresh the page."
        },
        "vector": {
          "tableLabel": "vector table",
          "typeLabel": "vector",
          "addButton": "Add Vector",
          "emptyMessage": "No vector tables configured for this project",
          "addModalTitle": "Add Vector Tables to Project",
          "membershipToggleLabel": "Show approved vector tables",
          "removeDialogTitle": "Remove Vector Table",
          "removeDialogTitlePlural": "Remove Vector Tables",
          "errorBoundaryMessage": "Unable to load vector tables. Please refresh the page."
        }
      }
    },
    "storageTab": {
      "unknown": "Unknown",
      "addButton": "Add Storage",
      "addModalTitle": "Add Storage to Project",
      "emptyMessage": "No storage folders configured for this project",
      "errorBoundaryMessage": "Unable to load storage folders. Please refresh the page.",
      "membershipToggleLabel": "Show approved storage",
      "removeDialogTitle": "Remove Storage Folder",
      "removeDialogTitlePlural": "Remove Storage Folders",
      "removeDialogMessage": "Remove \"{{name}}\" from this project?",
      "bulkRemoveDialogMessage": "Are you sure you want to remove the {{count}} selected storage folder(s) from this project?",
      "columns": {
        "folder": "Folder",
        "connector": "Connector",
        "files": "Files",
        "size": "Size",
        "status": "Status",
        "creator": "Creator",
        "actions": "Actions"
      },
      "status": {
        "active": "Active",
        "error": "Error",
        "pending": "Pending"
      },
      "actions": {
        "previewFiles": "Preview Files",
        "sync": "Sync",
        "syncing": "Syncing...",
        "removeFromProject": "Remove from Project",
        "remove": "Remove"
      },
      "toasts": {
        "requestedAccess": "Requested access for {{count}} storage folder{{plural}} (pending approval)",
        "alreadyInProject": "{{count}} storage folder{{plural}} already in project",
        "addFailed": "Failed to add {{count}} storage folder{{plural}}",
        "synced": "'{{name}}' metadata synced.",
        "removed": "Storage folder removed from project",
        "bulkRemoved": "Successfully removed {{count}} storage folder{{plural}} from project",
        "bulkRemoveFailed": "Failed to remove {{count}} storage folder{{plural}}"
      }
    },
    "registryTab": {
      "columnAgent": "Agent",
      "columnFramework": "Framework",
      "columnStatus": "Status",
      "columnEnv": "ENV",
      "columnOrchestrator": "Orchestrator",
      "columnRegisteredBy": "Registered By",
      "columnRegisteredAt": "Registered At",
      "columnActions": "Actions",
      "columnWorkflow": "Workflow",
      "actionOpenCanvas": "Open canvas",
      "actionRuns": "Runs",
      "registryViewsAriaLabel": "Registry views",
      "agentRegistryTitle": "Agent registry",
      "agentsLabel": "Agents",
      "workflowRegistryTitle": "Workflow registry",
      "workflowsLabel": "Workflows",
      "registryStatusTitle": "Registry status",
      "activeItemsTitle": "Active registry items",
      "archivedItemsTitle": "Archived registry items",
      "openInRegistryTitle": "Open in Registry",
      "emptyActiveAgents": "No registered agents in this project.",
      "emptyArchivedAgents": "No archived registered agents in this project.",
      "emptyActiveWorkflows": "No registered workflows in this project.",
      "emptyArchivedWorkflows": "No archived registered workflows in this project.",
      "goToRegistry": "Go to Agent Registry",
      "searchRegistryPlaceholder": "Search registry…",
      "searchWorkflowsPlaceholder": "Search workflows…"
    },
    "promptsTab": {
      "columnName": "Prompt Name",
      "columnCategory": "Category",
      "columnDescription": "Description",
      "columnCreated": "Created",
      "columnLastUpdated": "Last Updated",
      "columnActions": "Actions",
      "noDescription": "No description",
      "viewVersionsTitle": "View prompt versions",
      "errorBoundaryMessage": "Unable to load prompts. Please refresh the page.",
      "emptyMessage": "No prompts in this project. Prompts are managed via the Prompts page.",
      "dialogCloseAriaLabel": "Close dialog",
      "categoryLabel": "Category:",
      "versionsHeading": "VERSIONS ({{count}})",
      "loadingVersions": "Loading versions...",
      "noVersionsFound": "No versions found",
      "versionLabel": "Version {{version}}",
      "latestBadge": "LATEST",
      "selectVersionPrompt": "Select a version to view content"
    },
    "deploymentsTab": {
      "columnAgent": "Agent",
      "columnEnv": "Env",
      "columnStatus": "Status",
      "columnDeployedBy": "Deployed by",
      "columnDeployedAt": "Deployed At",
      "columnActions": "Actions",
      "columnWorkflow": "Workflow",
      "actionOpen": "Open",
      "actionChat": "Chat",
      "actionRuntimeSettings": "Runtime settings",
      "actionOpenInMonitoring": "Open in Monitoring",
      "actionManageArchive": "Manage archive in Monitoring",
      "actionGuardrails": "Guardrails",
      "deploymentViewsAriaLabel": "Deployment views",
      "agentDeploymentsTitle": "Agent deployments",
      "agentsLabel": "Agents",
      "workflowDeploymentsTitle": "Workflow deployments",
      "workflowsLabel": "Workflows",
      "deploymentStatusTitle": "Deployment status",
      "activeDeploymentsTitle": "Active deployments",
      "archivedDeploymentsTitle": "Archived deployments",
      "openInMonitoringTitle": "Open in Monitoring",
      "emptyActiveAgents": "No active agent deployments for this project.",
      "emptyArchivedAgents": "No archived agent deployments for this project.",
      "emptyActiveWorkflows": "No active workflow deployments for this project.",
      "emptyArchivedWorkflows": "No archived workflow deployments for this project.",
      "goToMonitoring": "Go to Monitoring",
      "searchDeploymentsPlaceholder": "Search deployments…",
      "searchWorkflowDeploymentsPlaceholder": "Search workflow deployments…"
    },
    "evalsTab": {
      "columnAgent": "Agent",
      "columnLatestSession": "Latest session",
      "columnActions": "Actions",
      "actionOpenEvals": "Open evals",
      "actionManageInEvals": "Manage in Evals",
      "portfolioSubtitle": "Evaluation portfolio for this project",
      "openInEvalsTitle": "Open in Evals",
      "emptyMessage": "No evaluation data for this project.",
      "goToEvals": "Go to Evals & Simulations",
      "searchAgentsPlaceholder": "Search agents…"
    }
  },
  "prompts": {
    "exportFileName": "Prompts",
    "searchPlaceholder": "Search prompts...",
    "columns": {
      "name": "Prompt Name",
      "description": "Description",
      "category": "Category",
      "model": "Model",
      "project": "Project",
      "visibility": "Visibility",
      "createdBy": "Created by",
      "updatedAt": "Updated at",
      "actions": "Actions"
    },
    "filters": {
      "title": "Filters",
      "visibility": "Visibility",
      "category": "Category",
      "project": "Project",
      "creator": "Creator",
      "all": "All",
      "favorites": "Favorites"
    },
    "visibility": {
      "project": "Project",
      "public": "Platform"
    },
    "list": {
      "uncategorized": "Uncategorized",
      "allModels": "All models",
      "platformBadge": "Platform",
      "platformBadgeTooltip": "Code-backed system prompt — read-only",
      "versionCount": "{{count}} version",
      "versionCount_other": "{{count}} versions",
      "unknownProject": "Unknown",
      "missingTargetModelsWarning": "Configure the listed target model(s) to use the inactive prompt(s): {{models}}",
      "emptyState": {
        "permissionDenied": "You don't have permission to view prompts. Contact your administrator for access.",
        "noResultsSearch": "No prompts found matching your search.",
        "default": "No prompts found. Create your first prompt to get started."
      }
    },
    "actions": {
      "view": "View",
      "chat": "Chat",
      "exportYaml": "Export as YAML",
      "optimize": "Optimize",
      "cloneForModel": "Clone for Model",
      "edit": "Edit",
      "delete": "Delete",
      "exportSelected": "Export Selected",
      "deleteSelected": "Delete Selected",
      "createPrompt": "Create Prompt",
      "newPrompt": "New Prompt",
      "creating": "Creating..."
    },
    "quota": {
      "loading": "Loading quota...",
      "label": "Prompts"
    },
    "toast": {
      "projectFilterReset": "The previously selected project no longer exists. Filter has been reset.",
      "draftInserted": "Draft prompt inserted. Edit if needed, then create — you can run Optimization from the prompt editor after saving.",
      "clonedForModel": "Prompt cloned for model \"{{model}}\"",
      "bulkDeletePartial": "Deleted {{deleted}} prompt(s), {{skipped}} failed: {{errors}}",
      "bulkDeleteSuccess": "Deleted {{count}} prompt(s) successfully",
      "platformDeleteBlocked": "Platform prompts cannot be deleted"
    },
    "form": {
      "modelAgnostic": "Model-agnostic (all models)",
      "selectProjectFirst": "Select a project first.",
      "selectProjectModel": "Select an LLM model assigned to this project.",
      "selectModel": "Select an LLM model.",
      "minBusinessContext": "Enter at least 10 characters of business context.",
      "selectProjectAndModelFirst": "Select Project and Model first",
      "selectModelFirst": "Select Model first",
      "minCharsRequired": "Minimum 10 characters required",
      "selectProjectFirstPlaceholder": "Select a project first",
      "loadingModels": "Loading models…",
      "noLlmForProject": "No LLM assigned to this project",
      "noLlmAvailable": "No LLM available",
      "nameAlreadyExists": "A prompt with this name already exists",
      "promptNameLabel": "Prompt Name *",
      "promptNamePlaceholder": "e.g., Customer Support Assistant",
      "categoryLabel": "Category",
      "categoryPlaceholder": "e.g., Support, Sales",
      "targetModelLabel": "Target Model",
      "targetModelRequiredLabel": "Target Model *",
      "selectModelPlaceholder": "Select a model...",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Brief description of what this prompt does",
      "charCount": "{{count}}/{{max}} characters",
      "modelLabel": "Model",
      "selectAiModelPlaceholder": "Select AI Model",
      "generating": "Generating…",
      "generate": "Generate",
      "businessContextPlaceholder": "Audience, tone, tasks, constraints — the model will draft your prompt from this. Minimum 10 characters to generate.",
      "aiGenerateHint": "After generation you will switch to Manual mode to review and edit the prompt, then create.",
      "contentPlaceholderPrefix": "You are a helpful assistant that...\n\nWrite your system prompt here. Use ",
      "contentPlaceholderSuffix": " to reference state variables that will be resolved at runtime.",
      "variableNamePlaceholder": "variable_name",
      "addVariable": "Add Variable",
      "nameLabel": "Name *",
      "fixValidationErrors": "Please fix validation errors before saving",
      "saving": "Saving...",
      "saveChanges": "Save Changes",
      "quotaExceeded": "Prompt quota exceeded",
      "fillRequiredFields": "Please fill in all required fields",
      "cloning": "Cloning..."
    },
    "modal": {
      "detailsHeader": "Details",
      "describePromptHeader": "Describe what you want the prompt to do",
      "promptDetailsHeader": "Prompt Details",
      "createTitle": "Create New Prompt",
      "creationModeAriaLabel": "Prompt creation mode",
      "modeManual": "Manual",
      "modeAi": "AI",
      "editorSectionsAriaLabel": "Prompt editor sections",
      "tabPrompt": "Prompt",
      "tabState": "State",
      "editorHintPrefix": "Use",
      "editorHintSuffix": "for state variables",
      "aiGeneratedNote": "AI-generated — edit as needed. Use Optimization to tune further.",
      "loadingEditor": "Loading prompt editor...",
      "stateVariablesHintPrefix": "Define state variables to use with",
      "stateVariablesHintSuffix": "in your prompt. Each variable referenced in the prompt must be listed here.",
      "noStateVariables": "No state variables defined yet.",
      "stateVariableNameAriaLabel": "State variable name {{name}}",
      "removeStateVariableAriaLabel": "Remove state variable {{name}}",
      "newVariableFallback": "new",
      "editTitle": "Edit Prompt Metadata",
      "deleteTitle": "Delete Prompt",
      "deleteMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "bulkDeleteTitle": "Delete Selected Prompts",
      "bulkDeleteMessage": "Are you sure you want to delete {{count}} prompt? This action cannot be undone.",
      "bulkDeleteMessage_other": "Are you sure you want to delete {{count}} prompts? This action cannot be undone.",
      "bulkDeleteConfirm": "Delete {{count}} Prompt",
      "bulkDeleteConfirm_other": "Delete {{count}} Prompts",
      "cloneTitle": "Clone for Model",
      "cloneMessage": "Clone “{{name}}” with all versions for a different model.",
      "cloneSubmit": "Clone Prompt"
    },
    "optimizeModal": {
      "header": {
        "title": "Optimize Prompt",
        "subtitlePlaceholder": "Select a prompt"
      },
      "stepper": {
        "configure": "Configure",
        "running": "Running",
        "result": "Result"
      },
      "framework": {
        "sectionTitle": "Select Framework",
        "bestFor": "Best for: {{value}}",
        "catalog": {
          "dspy": {
            "label": "DSPy",
            "tier": "Tier 1",
            "desc": "Declarative optimization (MIPROv2, COPRO, or bootstrap few-shot). Best with labeled examples.",
            "tooltip": "Compiles a declarative program into optimized prompts. Pick a compiler type below (default MIPROv2).",
            "bestFor": "Classification, Q&A, extraction tasks"
          },
          "cot": {
            "label": "Chain-of-Thought",
            "tier": "Tier 2",
            "desc": "Reasoning optimization: step-by-step, trace quality, step decomposition.",
            "tooltip": "Tries multiple CoT strategies (e.g. \"Think step by step\"), optimizes reasoning-trace quality and step decomposition. Use prompt type \"Chain-of-Thought\" for full strategies.",
            "bestFor": "Reasoning, math, multi-step tasks"
          },
          "opro": {
            "label": "OPRO",
            "tier": "Tier 2",
            "desc": "LLM-as-Optimizer. Feeds (prompt, score) history and asks for improvement.",
            "tooltip": "Uses the LLM itself as an optimizer — iteratively proposes better prompts by analyzing score trajectories. Simple to deploy, no gradient computation.",
            "bestFor": "Quick iteration on any task"
          },
          "reflexion": {
            "label": "Reflexion",
            "tier": "Tier 2",
            "desc": "Self-reflective verbal RL. Generates critique → rewrite loop.",
            "tooltip": "Generates a self-critique after each trial, then rewrites the prompt to fix identified failures. Combines reflection with episodic memory for persistent improvement.",
            "bestFor": "Complex reasoning, multi-step tasks"
          },
          "gepa": {
            "label": "GEPA",
            "tier": "Tier 3",
            "desc": "Upstream Genetic-Pareto engine with per-example Pareto selection and candidate merging.",
            "tooltip": "Runs the reference GEPA engine. Keeps a Pareto frontier per validation example instead of a single aggregate score, so prompts that only help on a subset of cases still survive to be combined.",
            "bestFor": "Multi-node agent graphs, plateaued runs"
          },
          "gepa_legacy": {
            "label": "GEPA (legacy)",
            "tier": "Tier 3",
            "desc": "In-house reflective evolutionary with LLM-driven failure diagnosis.",
            "tooltip": "The previous built-in GEPA approximation. Kept as a fallback when the upstream package is unavailable, and for A/B comparison.",
            "bestFor": "Offline installs without the gepa package"
          },
          "optimize_anything": {
            "label": "optimize_anything",
            "tier": "Tier 3",
            "desc": "Upstream GEPA launcher for non-prompt artifacts (agent graph, node config).",
            "tooltip": "Optimizes graph JSON or node configuration knobs via the same Genetic-Pareto engine. Invalid candidates score 0 with the validation error as feedback. Persistence is gated behind an explicit apply step.",
            "bestFor": "Topology and config search beyond prompts"
          },
          "evoprompt": {
            "label": "EvoPrompt",
            "tier": "Tier 3",
            "desc": "Population-based evolutionary with crossover & mutation operators.",
            "tooltip": "Maintains a population of prompt candidates and applies crossover / mutation operators inspired by genetic algorithms. Great for exploring diverse prompt formulations.",
            "bestFor": "Diverse prompt exploration"
          },
          "ape": {
            "label": "APE",
            "tier": "Tier 3",
            "desc": "Automatic Prompt Engineer. Generate → score → resample.",
            "tooltip": "Generates many candidate instructions from I/O demonstrations, scores them, then resamples around the best. Fast and effective for instruction discovery.",
            "bestFor": "Instruction discovery from examples"
          },
          "textgrad": {
            "label": "TextGrad",
            "tier": "Tier 4",
            "desc": "Textual backpropagation. Computes text gradients for targeted fixes.",
            "tooltip": "Propagates textual \"gradients\" — natural language feedback — backward through the prompt to identify exactly which parts need editing. Precise, surgical refinement.",
            "bestFor": "Precision editing of long prompts"
          },
          "rl_tuning": {
            "label": "RL-PPO",
            "tier": "Tier 5",
            "desc": "PPO-style policy optimization with custom reward functions.",
            "tooltip": "Treats prompt selection as a policy and optimizes it via Proximal Policy Optimization. Define your own reward function for full control over the optimization objective.",
            "bestFor": "Custom reward objectives"
          },
          "rag_aware": {
            "label": "RAG-Aware",
            "tier": "Tier 6",
            "desc": "Joint prompt + retrieval pipeline co-optimization.",
            "tooltip": "Co-optimizes the prompt and the retrieval configuration together. Adjusts query formatting, context placement, and instruction phrasing for RAG-heavy workflows.",
            "bestFor": "Retrieval-augmented generation"
          },
          "multi_obj": {
            "label": "Multi-Objective",
            "tier": "Cross",
            "desc": "Pareto front optimization across accuracy, latency, cost.",
            "tooltip": "Explores the Pareto frontier across multiple competing objectives (accuracy, latency, token cost). Returns a set of trade-off optimal prompts rather than a single winner.",
            "bestFor": "Balancing accuracy vs cost"
          },
          "ensemble": {
            "label": "Ensemble",
            "tier": "Cross",
            "desc": "Run multiple optimizers in parallel, then fuse results (tournament, merge, or voting).",
            "tooltip": "Runs 2+ complementary frameworks concurrently (e.g. Reflexion + OPRO + TextGrad), then combines their best candidates. Higher cost than a single framework; best when you want robust, multi-view prompt improvement.",
            "bestFor": "Maximum coverage and robustness"
          }
        }
      },
      "promptVersion": {
        "sectionTitle": "Prompt & Version",
        "projectLabel": "Project",
        "promptLabel": "Prompt",
        "promptPlaceholder": "Select a prompt...",
        "promptSearchPlaceholder": "Search by name...",
        "promptRequiredError": "Prompt selection is required.",
        "versionLabel": "Version",
        "versionPlaceholder": "Select a version...",
        "versionRequiredError": "Prompt version selection is required.",
        "versionCurrentSuffix": " (current)",
        "compilerTypeLabel": "Compiler type",
        "compilerTypeTitle": "Which DSPy teleprompter runs (MIPROv2 is the default multiplexer optimizer).",
        "compilerOptions": {
          "miprov2": "MIPROv2",
          "copro": "COPRO",
          "bootstrapFewShot": "Bootstrap few-shot"
        },
        "promptTypeLabel": "Prompt type",
        "promptTypeTitle": "Chain-of-Thought optimizer strategies.",
        "promptTypeOptions": {
          "standard": "Standard",
          "cot": "Chain-of-Thought",
          "fewShot": "Few-shot",
          "structuredOutput": "Structured output (JSON/XML)"
        },
        "allProjectsLabel": "All projects"
      },
      "model": {
        "sectionTitle": "Model Configuration",
        "responseModelLabel": "Response Model",
        "responseModelPlaceholder": "Select LLM model...",
        "responseModelRequiredError": "Response model is required (or enable Multi-model with 2+ targets).",
        "judgeModelLabel": "Judge Model",
        "judgeModelPlaceholder": "Select a judge model",
        "gepaMutationModelLabel": "GEPA mutation model",
        "gepaMutationModelTitle": "LLM used for GEPA reflection and mutation (LiteLLM model id or platform model UUID).",
        "gepaMutationModelPlaceholder": "Select mutation model",
        "gepaMutationModelHint": "Reflection and mutant generation; evaluation still uses your judge/response models above.",
        "multiModelLabel": "Optimize across multiple models",
        "multiModelHint": "Evaluate prompt on 2+ models and aggregate (model-agnostic prompt)",
        "targetModelsLabel": "Target models (select 2+)",
        "selectAtLeast2Hint": "Select at least 2 models.",
        "modelsSelectedCount": "{{count}} models selected.",
        "aggregationStrategyLabel": "Aggregation strategy",
        "aggregationOptions": {
          "mean": "Mean — average across models",
          "min": "Min — worst-case (no model left behind)",
          "pareto": "Pareto — balance min and mean"
        },
        "aggregationHint": "Min = optimize for weakest model; Mean = average; Pareto = balance.",
        "noModelsHint": "No LLM models are linked to this project. Add models in Project → Models, or optimization may fall back to backend defaults.",
        "selectPromptHint": "Select a prompt to load response and judge models from that prompt's project."
      },
      "ensemble": {
        "sectionTitle": "Ensemble configuration",
        "subFrameworksLabel": "Sub-frameworks (select 2+)",
        "subFrameworksHint": "Each selected optimizer runs in parallel; results are fused using the strategy below.",
        "fusionLabel": "Fusion strategy",
        "fusionOptions": {
          "tournament": "Tournament — evaluate candidates on full dataset, pick best",
          "merge": "Merge — LLM synthesizes top candidates into one prompt",
          "voting": "Voting — score candidates on test set, weighted combination"
        },
        "minTwoToast": "Select at least two sub-frameworks for ensemble"
      },
      "metrics": {
        "sectionTitle": "Evaluation Metric",
        "autoDiscoverLabel": "Auto-discover metrics from dataset and prompt (recommends faithfulness, relevance, etc. when context is present)",
        "selectPromptHint": "Select a prompt to load the metrics catalog for its project.",
        "weightsTitle": "Metric weights (optional — composite score)",
        "weightsHint": "Leave blank for equal weight. Weights are normalized to sum to 1.",
        "weightPlaceholder": "equal",
        "noMetricsWarning": "No metrics selected — will default to Answer Correctness.",
        "embeddingLabel": "Embedding model (required for selected metrics)",
        "embeddingPlaceholder": "Select an embedding model…",
        "embeddingNoModelsHint": "No active embedding models in this project. Register one under Project → Models.",
        "sqlLabel": "Execution database (required for Text2SQL EX/VES)",
        "sqlPlaceholder": "Select a database connector…",
        "sqlNoConnectorsHint": "No database connectors registered. Add one under Knowledge → Connectors.",
        "schemaLabel": "Schema definition (JSON, required for schema compliance)",
        "schemaPlaceholder": "{\"tables\": [{\"name\": \"orders\", \"columns\": [\"id\", \"amount\"]}]}"
      },
      "dataset": {
        "sectionTitle": "Benchmark Dataset",
        "optionalGepaSuffix": "(optional for GEPA)",
        "selectPromptHint": "Select a prompt to list benchmark datasets linked to that project's knowledge.",
        "datasetPlaceholder": "Select a registered table...",
        "datasetSearchPlaceholder": "Search datasets by name or table...",
        "datasetRowsSuffix": "({{count}} rows)",
        "datasetRequiredError": "Benchmark dataset selection is required.",
        "noDatasetsHint": "No knowledge tables mapped to this project. Map tables under Project → Knowledge.",
        "inputColumnLabel": "Input Column",
        "columnPlaceholder": "Select column...",
        "expectedOutputColumnLabel": "Expected Output Column",
        "expectedOutputRequiredError": "Expected Output column is required for DSPy.",
        "contextColumnsLabel": "Context columns (optional)",
        "selectDatasetFirst": "Select a dataset first",
        "contextColumnsHint": "Multiple columns are joined for evaluation context (RAGAS / DeepEval).",
        "jinjaContextWarning": "This prompt uses {{placeholder}}, but the selected dataset has no context column. Map a column such as knowledge_text as a context column, or remove the tag.",
        "jinjaMissingWarning": "This prompt uses placeholders that are not dataset columns: {{list}}. Map a matching column or remove the tags before starting.",
        "samplingStrategyLabel": "Sampling strategy",
        "samplingOptions": {
          "random": "Random",
          "stratified": "Stratified (by expected output)",
          "difficultyWeighted": "Difficulty-weighted (focus on hard examples)",
          "progressive": "Progressive (expand subset as optimization converges)"
        },
        "samplingHint": "Stratified and difficulty-weighted can improve signal from fewer rows."
      },
      "dspyContext": {
        "title": "DSPy Context Integration",
        "modeLabel": "Context passing mode",
        "modeOptions": {
          "auto": "Auto — inject context as DSPy input when detected",
          "injectField": "Inject field — always add context as a DSPy input",
          "ragModule": "RAG module — retrieval from context corpus before prediction"
        },
        "modeHints": {
          "auto": "Automatically injects context from the dataset into the DSPy signature, even if the prompt template does not reference it.",
          "injectField": "Forces context injection as a DSPy input field. DSPy learns to use context during compilation.",
          "ragModule": "Builds a compound Retrieve + Predict DSPy module. MIPROv2 can jointly optimize retrieval and prediction."
        },
        "demoStrategyLabel": "Demo selection strategy",
        "demoOptions": {
          "default": "Default — let DSPy compiler choose",
          "diverseContext": "Diverse context — maximize context diversity across demos",
          "maxCoverage": "Max coverage — cover widest range of context topics"
        },
        "demoHint": "Diverse context and max coverage select demonstrations with richer context variety for better few-shot quality.",
        "topKLabel": "Retrieval top-K",
        "topKHint": "Number of context passages retrieved per query from the golden dataset.",
        "truncateLabel": "Truncate long contexts",
        "truncateHint": "Cap context passages to fit token budgets",
        "maxTokensLabel": "Max context tokens",
        "maxTokensHint": "Approximate word-level truncation per passage."
      },
      "advanced": {
        "sectionTitle": "Advanced options",
        "warmStartLabel": "Meta-learning warm start",
        "warmStartHint": "Seed from similar past runs",
        "adversarialLabel": "Adversarial robustness testing",
        "adversarialHint": "Test on perturbed inputs; combine with clean score",
        "adversarialWeightLabel": "Adversarial weight (0–1)",
        "adversarialWeightHint": "robust_score = (1 − α)×clean + α×adversarial; higher α weights adversarial more.",
        "requireApprovalLabel": "Require approval before saving",
        "requireApprovalHint": "Review optimized prompt before it becomes a new version",
        "driftGuardLabel": "Semantic drift guard",
        "driftGuardHint": "Reject candidates that drift too far from original intent",
        "maxDriftLabel": "Max drift (0–1)",
        "maxDriftHint": "Candidates with drift > this are rejected. Lower = stricter (e.g. 0.3).",
        "driftMethodLabel": "Drift method",
        "driftMethodOptions": {
          "jaccard": "Jaccard (token-based)",
          "vector": "Vector (embedding cosine)"
        },
        "driftMethodHint": "Vector drift uses the embedding model below; Jaccard is lexical only.",
        "embeddingModelLabel": "Embedding model",
        "embeddingLoading": "Loading models…",
        "embeddingNoModelsHint": "No active embedding models in this project. Use Jaccard drift or register models under Foundation Models.",
        "embeddingPlaceholder": "Select an embedding model",
        "embeddingRequiredHint": "Required when drift method is Vector (stored as drift_embedding_model_id).",
        "guardrailsLabel": "Content safety guardrails",
        "guardrailsHint": "Reject candidates that fail toxicity, PII, prompt injection, or brand safety checks",
        "guardrailBackendLabel": "Guardrail backend",
        "guardrailBackendOptions": {
          "builtin": "Built-in (pattern-based)",
          "azureContentSafety": "Azure Content Safety",
          "awsBedrock": "AWS Bedrock Guardrails",
          "custom": "Custom (HTTP endpoint)"
        },
        "guardrailBackendHint": "Built-in runs PII, toxicity, jailbreak, and optional brand-safety checks without external APIs.",
        "checksLabel": "Checks to run",
        "checksHint": "Candidates failing any selected check are rejected before evaluation.",
        "checkLabels": {
          "piiCheck": "PII",
          "toxicity": "toxicity",
          "promptInjection": "Prompt injection",
          "jailbreak": "jailbreak",
          "brandSafety": "brand safety",
          "lengthCheck": "length check"
        }
      },
      "parameters": {
        "sectionTitle": "Parameters",
        "maxIterationsLabel": "Max Iterations",
        "maxIterationsEnsembleLabel": "Max iterations (per sub-framework)",
        "maxIterationsHint": "Higher = more refinement, longer runtime",
        "maxIterationsEnsembleHint": "Each parallel optimizer runs up to this many iterations (ensemble uses sub_max_iterations).",
        "timeBudgetLabel": "Time budget (seconds)",
        "timeBudgetHint": "Hard cap on wall-clock runtime (60–14,400s). The run stops when the budget is reached.",
        "maxCostLabel": "Max cost (USD, optional)",
        "maxCostPlaceholder": "No limit",
        "maxCostHint": "Estimated spend ceiling; session aborts when exceeded. Leave empty for no cap.",
        "targetScoreLabel": "Target score (optional)",
        "targetScorePlaceholder": "None",
        "targetScoreHint": "Stop early when the composite score reaches this value (0–1). Leave empty to run until iterations or other limits.",
        "candidateCountHint": "Number of candidate prompts generated or evaluated per iteration for this optimizer.",
        "evalMaxRowsLabel": "Eval dataset max rows",
        "evalMaxRowsHint": "Rows fetched from the benchmark per evaluation (baseline uses full cap; inner loops may use fewer).",
        "rowsPerIterationLabel": "Rows per candidate eval (optional)",
        "rowsPerIterationPlaceholder": "Auto",
        "rowsPerIterationHint": "Caps rows when scoring each proposed prompt; leave empty for automatic (about half of max rows, min 5).",
        "earlyStoppingLabel": "Early stopping",
        "patienceHint": "Patience (rounds without improvement)",
        "candidateLabels": {
          "gepa": "Mutants per iteration",
          "ape": "Candidates per round",
          "opro": "Proposals per iteration",
          "evoprompt": "Population size",
          "rl_tuning": "Rollouts per iteration"
        }
      },
      "reward": {
        "sectionTitle": "Reward Function (Python)",
        "description": "Define your custom reward function. It receives each evaluation row and returns a reward signal in [-1, 1]. The policy will maximize this reward."
      },
      "estimate": {
        "title": "Estimated resources",
        "summary": "~{{calls}} LLM calls · approx. ${{low}}–${{high}} USD",
        "monthlyUsed": "Monthly used: ${{used}} / ${{limit}}",
        "acknowledge": "I acknowledge the estimated cost (up to ${{cost}} USD) and want to start this run"
      },
      "start": {
        "button": "Start {{framework}} Optimization",
        "confirmButton": "Confirm and start",
        "changeParams": "Change parameters"
      },
      "toast": {
        "selectPrompt": "Please select a prompt",
        "selectVersion": "Please select a prompt version",
        "selectDataset": "Please select a benchmark dataset",
        "selectResponseModel": "Please select a response model or enable multi-model with at least 2 models",
        "multiModelMin2": "Multi-model optimization requires at least 2 target models",
        "dspyExpectedOutput": "For DSPy, select an Expected Output column",
        "vectorDriftEmbedding": "Vector drift requires an embedding model, or set drift method to Jaccard.",
        "embeddingForMetrics": "Select an embedding model for the chosen metrics.",
        "sqlForMetrics": "Select an execution database for the chosen Text2SQL metrics.",
        "schemaForMetrics": "Provide valid JSON schema definition for schema compliance metric.",
        "ensembleMin2": "Ensemble requires at least two sub-frameworks",
        "unsupportedSubframework": "Unsupported sub-framework: {{list}}",
        "maxCostInvalid": "Max cost (USD) must be a non-negative number",
        "targetScoreInvalid": "Target score must be between 0 and 1",
        "llmCapExceeded": "Estimated LLM calls ({{calls}}) exceed the per-session limit ({{cap}}). Reduce iterations or population size.",
        "cancelRequested": "Optimization run cancellation requested",
        "cancelFailed": "Failed to cancel optimization run"
      },
      "running": {
        "title": "Optimizing “{{name}}”",
        "engineLabel": "Engine:",
        "jobLabel": "Job:",
        "progressLabel": "Progress",
        "statusLabel": "Status:",
        "statusStarting": "STARTING",
        "iterationSuffix": " · Iteration {{current}}/{{max}}",
        "initializing": "Initializing {{engine}} engine...",
        "loadingDataset": "Loading benchmark dataset",
        "completedIterations": "Completed {{current}}/{{max}} iterations",
        "errorPrefix": "Error: {{message}}",
        "cancelButton": "Cancel Run"
      },
      "result": {
        "awaitingApproval": "Awaiting Approval",
        "complete": "Optimization Complete",
        "cancelled": "Optimization Cancelled",
        "failed": "Optimization Failed",
        "approvalHint": "The optimized prompt requires human approval before being saved as a new version. Review and approve it on the run detail page.",
        "baseline": "Baseline",
        "optimized": "Optimized",
        "iterationsSuffix": "Iterations: {{count}}",
        "evaluationsSuffix": " · Evaluations: {{count}}",
        "reviewApprove": "Review & Approve",
        "viewRunDetails": "View Run Details",
        "viewOptimizedVersion": "View optimized version"
      }
    },
    "runDetail": {
      "pageTitle": "Prompt Optimization",
      "backToRuns": "Back to runs",
      "backToOptimizationRuns": "Back to Optimization Runs",
      "notFound": "Optimization run not found",
      "loading": "Loading optimization details...",
      "status": {
        "completed": "completed",
        "failed": "failed",
        "cancelled": "cancelled",
        "running": "running",
        "queued": "queued",
        "pending_approval": "pending approval"
      },
      "approvalBadge": {
        "pending": "Pending Approval",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "viewOptimizedPrompt": "View Optimized Prompt",
      "errorBanner": {
        "title": "Optimization Failed"
      },
      "createdAt": "Created {{date}}",
      "approval": {
        "reviewTitle": "Review Optimized Prompt",
        "reviewSubtitle": "This optimization requires approval before the optimized prompt is saved as a new version.",
        "reasonPlaceholder": "Optional reason for approval/rejection...",
        "reject": "Reject",
        "approve": "Approve & Save as New Version",
        "approvedMessage": "Prompt approved and saved as a new version.",
        "rejectedMessage": "Prompt rejected. No new version was created.",
        "promptApprovedTitle": "Prompt Approved",
        "promptRejectedTitle": "Prompt Rejected",
        "approvedSubtitle": "This optimized prompt was approved and saved as a new version.",
        "rejectedSubtitle": "This optimized prompt was rejected. No new version was created."
      },
      "diff": {
        "originalPrompt": "Original Prompt",
        "optimizedPrompt": "Optimized Prompt"
      },
      "tabs": {
        "overview": "Overview",
        "insights": "Insights",
        "rowMetrics": "Row metrics",
        "candidates": "Candidates",
        "trace": "Trace",
        "abTest": "A/B Test",
        "configuration": "Configuration"
      },
      "configView": {
        "formatted": "Formatted",
        "raw": "Raw",
        "copy": "Copy",
        "copied": "Copied"
      },
      "metrics": {
        "baselineScore": "Baseline Score",
        "optimizedScore": "Optimized Score",
        "improvement": "Improvement",
        "holdoutScore": "Holdout Score",
        "holdoutSubValue": "True score on held-out set",
        "iterations": "Iterations",
        "iterationsSubValue": "of {{max}} max",
        "evaluations": "Evaluations",
        "duration": "Duration",
        "totalTokens": "Total Tokens",
        "tokensSubValue": "{{prompt}} prompt / {{completion}} completion",
        "estimatedCost": "Estimated Cost",
        "estimatedCostSubValue": "LLM consumption"
      },
      "orchestrator": {
        "label": "Orchestrator",
        "openRun": "Open workflow run"
      },
      "earlyStopping": {
        "label": "Early stopping",
        "completedOf": "Completed {{completed}} of {{max}} configured iterations."
      },
      "perModelScores": {
        "title": "Per-model scores (model-agnostic run)",
        "desc": "Aggregate score above is derived from these per-model scores. Prompt was evaluated on each foundation model."
      },
      "coproDescription": "COPRO: your <strong>max iterations</strong> setting is optimization depth ({{depth}}). Each depth evaluates multiple proposed prompts (breadth {{breadth}}), so the score chart lists {{candidatesTracked}} — not one point per depth step alone.",
      "coproScoredCandidates": "{{count}} scored candidates",
      "coproOneRowPerCandidate": "one row per scored candidate",
      "miproDescription": "MIPROv2: <strong>Max iterations</strong> ({{trials}}) is the number of Bayesian optimization trials. The chart and candidate list show prompts evaluated on the <strong>full</strong> validation set (minibatch-only probes are omitted), so the number of rows ({{rows}}) can differ from trials — especially when minibatching is on.",
      "scoreChartTitle": "Score Progression",
      "scoreChartSubtitle": "Eligible candidate score by iteration",
      "scoreChartSeries": "Score",
      "scoreChartXAxis": "Iteration",
      "optimizedPromptCard": {
        "title": "Optimized Prompt",
        "viewMore": "View More",
        "viewLess": "View less"
      },
      "scoreChartYAxis": "Aggregated Score",
      "scoreChartYAxisAggregated": "Aggregate Score ({{strategy}})",
      "scoreChartAggregation": {
        "mean": "Mean",
        "min": "Min",
        "pareto": "Pareto"
      },
      "chartTooltip": "Iteration {{iteration}}: {{score}}",
      "chartTooltipBestSuffix": " (best)",
      "insights": {
        "title": "Optimizer Insights",
        "foundationModel": "Foundation Model",
        "judgeModel": "Judge Model",
        "evalMetrics": "Eval Metrics",
        "mutationModel": "Mutation Model",
        "targetScore": "Target Score",
        "timeBudget": "Time Budget",
        "defaultModel": "Default (server default)",
        "runSetup": "Run setup",
        "frameworkDetails": "Framework details",
        "viewDetailsFields": "View details ({{count}} fields)",
        "viewFullText": "View full text"
      },
      "componentsTitle": "Optimized Components",
      "rowEvaluations": {
        "title": "Row-level evaluations",
        "sourceLabel": "Source:",
        "source": {
          "optimization_trace": "Last best benchmark pass from the optimizer trace",
          "final_eval": "Post-run evaluation of the optimized prompt on the dataset",
          "none": "No dataset rows were evaluated for this run",
          "failed": "Row snapshot could not be captured"
        },
        "metricsConfigured": "Metrics configured: {{metrics}}.",
        "emptyFailed": "The optimizer finished, but storing per-row scores failed. Check server logs.",
        "emptyNoDataset": "This run did not produce row-level scores (no dataset or no eval rows).",
        "emptyDefault": "No row-level rows were returned for this session.",
        "columns": {
          "index": "#",
          "input": "Input / question",
          "generatedAnswer": "Generated answer",
          "metrics": "Metrics",
          "score": "Score",
          "reasoning": "Reasoning"
        },
        "expectedOutput": "Expected output"
      },
      "candidates": {
        "title": "Candidate Prompts ({{count}})",
        "iteration": "Iteration {{iteration}}",
        "candidateLabel": "Candidate {{index}}",
        "best": "Best",
        "driftRejected": "Drift rejected",
        "guardrails": "Guardrails",
        "rejectionReason": "Rejection reason:"
      },
      "trace": {
        "title": "Optimization Trace ({{count}} entries)",
        "iter": "Iter {{iteration}}"
      },
      "abTest": {
        "dailyTrafficLabel": "Expected daily traffic (optional):",
        "dailyTrafficPlaceholder": "e.g. 10000",
        "generateButton": "Generate A/B test",
        "generating": "Generating…",
        "variantsLabel": "Variants",
        "sampleSizeLabel": "Sample size per variant",
        "sampleSizeValue": "{{perVariant}} (total {{total}})",
        "improvementCiLabel": "Improvement (CI)",
        "recommendedDurationLabel": "Recommended duration",
        "durationDays": "~{{days}} days",
        "durationHours": "~{{hours}} hours",
        "variantPromptsSummary": "Variant prompts",
        "controlLabel": "Control (A)",
        "treatmentLabel": "Treatment (B)"
      },
      "metadataLabels": {
        "meta_model": "Meta Model",
        "reflection_model": "Reflection Model",
        "stale_rounds": "Stale Rounds",
        "population_size": "Population Size",
        "gradient_model": "Gradient Model",
        "mutation_model": "Mutation Model",
        "gen_model": "Generation Model",
        "policy_model": "Policy Model",
        "optimizer_model": "Optimizer Model",
        "compiler": "DSPy Compiler",
        "dspy_version": "DSPy Version",
        "dspy_copro": "COPRO (depth / breadth)",
        "final_avg_reward": "Final Avg Reward",
        "baseline_reward": "Baseline Reward",
        "reward_function": "Reward Function",
        "objectives": "Objectives",
        "pareto_size": "Pareto Front Size",
        "early_stopping_reason": "Early stopping",
        "ensemble_frameworks": "Ensemble sub-frameworks",
        "fusion_strategy": "Fusion strategy",
        "dspy_mipro": "MIPRO settings",
        "dspy_num_trials": "MIPRO trials",
        "dspy_demo_cap": "Demo cap",
        "dspy_compile_passes": "Compile passes",
        "dspy_trainset_rows_used": "Train rows used",
        "golden_dataset_context": "Dataset context",
        "drift_guard_passed": "Drift guard",
        "convergence_stale_count": "Convergence stale count",
        "new_version_id": "New prompt version",
        "optimized_prompt": "Optimized prompt",
        "prompt_type": "Prompt type"
      },
      "frameworkTier": {
        "dspy": "Declarative Program Optimization",
        "opro": "Meta-Prompting / LLM-as-Optimizer",
        "reflexion": "Self-Reflective Refinement",
        "gepa": "Reflective Evolutionary Search",
        "evoprompt": "Evolutionary + LLM Search",
        "ape": "Automatic Prompt Engineering",
        "textgrad": "Textual Backpropagation",
        "rl_tuning": "RL-Based Policy Optimization",
        "rag_aware": "Retrieval-Augmented Joint Opt.",
        "multi_obj": "Multi-Objective Pareto Opt.",
        "ensemble": "Multi-Framework Fusion",
        "cot": "Reasoning-Structured Prompting"
      }
    },
    "comparison": {
      "backAriaLabel": "Back",
      "title": "Compare Optimization Runs",
      "subtitle": "Select a prompt, then pick 2+ completed runs to compare trajectories, frameworks, and optimized outputs",
      "promptFieldLabel": "Prompt",
      "promptPlaceholder": "Select a prompt...",
      "runsFieldLabel": "Optimization Runs",
      "runsFilterLabel": "Optimization Runs",
      "selectPromptFirst": "Select a prompt first",
      "loadingRuns": "Loading…",
      "noCompletedRuns": "No completed runs",
      "clearSelection": "Clear selection",
      "compareButton": "Compare ({{count}} selected)",
      "selectAtLeastTwo": "Select at least 2 runs to compare.",
      "genericCompareError": "Failed to compare sessions",
      "scoreTrajectoriesTitle": "Score trajectories",
      "yAxisScore": "Score",
      "xAxisIteration": "Iteration",
      "summaryTitle": "Summary",
      "exportCsvTitle": "Export CSV",
      "columns": {
        "framework": "Framework",
        "original": "Original",
        "optimized": "Optimized",
        "improvement": "Improvement",
        "holdout": "Holdout",
        "duration": "Duration",
        "iterations": "Iterations",
        "actions": "Actions"
      },
      "view": "View",
      "promptComparisonTitle": "Prompt Comparison",
      "selectPromptVersion": "Select a prompt version...",
      "originalPromptLabel": "Original",
      "optimizedPromptLabel": "Optimized",
      "originalPromptOption": "Original Prompt",
      "noPromptContent": "(No prompt content available)",
      "csv": {
        "sessionId": "Session ID",
        "framework": "Framework",
        "originalScore": "Original Score",
        "optimizedScore": "Optimized Score",
        "improvementPct": "Improvement %",
        "holdoutScore": "Holdout Score",
        "duration": "Duration",
        "iterations": "Iterations",
        "evaluations": "Evaluations"
      }
    },
    "editPage": {
      "backAriaLabel": "Back to prompts",
      "backToPrompts": "Back to Prompts",
      "platformTooltip": "Code-backed system prompt — read-only",
      "platformBadge": "Platform",
      "viewOnlyBadge": "View only",
      "editDetails": "Edit details",
      "editMetadata": "Edit metadata",
      "editMetadataTooltip": "Name, description, category, visibility, and target model",
      "detailsTitle": "Edit prompt metadata",
      "saveVersion": "Save as new version",
      "contentEditingGuide": "Edit the prompt below, then save as a new version. Prompt text is not auto-saved.",
      "unsavedContent": "You've updated the prompt. Save as a new version to keep these changes in history.",
      "historicalReadOnly": "This version is read-only. Create a new version to edit its text.",
      "createVersionFromThis": "Create new version",
      "versionsCount": "{{count}} Versions",
      "targetModelTooltip": "Target model",
      "allModels": "All models",
      "changeModelTooltip": "Change model or clone",
      "changeModelHeader": "Change Model",
      "modelAgnostic": "Model-agnostic (all models)",
      "autoSavingAriaLabel": "Auto-saving description",
      "autoSaving": "Auto-saving...",
      "autoSaveTooltip": "Only the description is auto-saved. Prompt content changes require a manual commit.",
      "loadingPrompt": "Loading prompt...",
      "notFound": "Prompt not found",
      "contentPlaceholder": "Enter prompt content... Use {{syntax}} to reference state variables.",
      "comingSoon": "Coming soon...",
      "targetModelLabel": "Target Model *",
      "selectModelPlaceholder": "Select a model...",
      "cloning": "Cloning...",
      "tabs": {
        "text": "Prompt Text",
        "diffs": "Prompt Diffs",
        "testing": "Prompt Testing",
        "evals": "Prompt Evals",
        "metrics": "Metrics"
      },
      "testing": {
        "title": "Prompt Testing",
        "description": "Test your prompts with different inputs and models"
      },
      "evals": {
        "title": "Prompt Evaluations",
        "description": "Evaluate prompt performance and quality metrics"
      },
      "metrics": {
        "title": "Optimization Metrics",
        "description": "This version was created by AI optimization",
        "descriptionWithFramework": "This version was created by AI optimization ({{framework}})",
        "baselineScore": "Baseline Score",
        "optimizedScore": "Optimized Score",
        "improvement": "Improvement",
        "iterations": "Iterations",
        "evaluations": "Evaluations",
        "duration": "Duration",
        "viewAllRuns": "View All Optimization Runs"
      },
      "toast": {
        "retagged": "Retagged to \"{{modelId}}\"",
        "setModelAgnostic": "Set to model-agnostic",
        "cloned": "Prompt cloned for \"{{modelId}}\"",
        "forkedSuccess": "Version forked successfully",
        "noChangesToCommit": "No changes to commit",
        "enterCommitMessage": "Please enter a commit message",
        "detailsSaved": "Prompt details saved",
        "platformReadOnlyFork": "Platform prompts are read-only and cannot be forked",
        "platformReadOnlyModify": "Platform prompts are read-only and cannot be modified"
      }
    },
    "playground": {
      "loadingPlayground": "Loading playground...",
      "unableToLoad": "Unable to load prompt. Please try again.",
      "unableToLoadSessions": "Unable to load chat sessions.",
      "headerTitle": "{{name}} — Playground",
      "versionOption": "v{{version}}",
      "versionOptionCurrent": "v{{version}} (current)",
      "selectModelOption": "Select model...",
      "loadingSession": "Loading session...",
      "noModelSelected": "No model selected",
      "typeMessage": "Type a message...",
      "emptyStateTitleFallback": "Playground",
      "emptyStateMessage": "Start testing your prompt",
      "noResponseGenerated": "(No response generated)",
      "toast": {
        "noModelsAvailable": "No models available",
        "promptNotLoaded": "Prompt not loaded",
        "noModelsAvailableAddOne": "No models available. Please add a model first.",
        "switchedModel": "Switched to {{name}}",
        "stopBeforeSending": "Please stop the current response before sending a new message",
        "uploadAttachmentsFailed": "Failed to upload attachments",
        "messageNotFoundForRetry": "Message not found for retry",
        "noUserMessageToRegenerate": "No user message found to regenerate",
        "cannotRegenerateEmptyContent": "Cannot regenerate: user message has no content",
        "cannotRetryMessageType": "Cannot retry this message type",
        "addAttachmentFailed": "Failed to add attachment: {{name}}"
      }
    },
    "runsPage": {
      "title": "Prompt Optimization",
      "subtitle": "History of all optimization runs across your prompts",
      "backToPrompts": "Back to prompts",
      "compareRuns": "Compare runs",
      "newOptimization": "New Optimization",
      "loadingMessage": "Loading optimization runs...",
      "emptyMessage": "No optimization runs yet. Click 'New Optimization' to get started.",
      "status": {
        "queued": "Queued",
        "running": "Running",
        "completed": "Completed",
        "failed": "Failed",
        "cancelled": "Cancelled"
      },
      "columns": {
        "promptName": "Prompt Name",
        "framework": "Framework",
        "status": "Status",
        "metrics": "Metrics",
        "improvementPct": "Improvement %",
        "cost": "Cost",
        "tokens": "Tokens",
        "createdBy": "Created By",
        "createdAt": "Created At",
        "updatedAt": "Updated At",
        "actions": "Actions"
      },
      "tokensTooltip": "Prompt: {{prompt}} | Completion: {{completion}}",
      "actions": {
        "retry": "Retry",
        "delete": "Delete"
      },
      "retryConfirm": "Start a new optimization for \"{{label}}\" using the same framework and options as this run?",
      "retryDefaultLabel": "this prompt",
      "deleteConfirm": "Delete optimization session for \"{{label}}\"? This cannot be undone.",
      "deleteDefaultLabel": "this session",
      "toast": {
        "newRunStarted": "New optimization run started.",
        "retryFailed": "Failed to retry optimization.",
        "sessionDeleted": "Optimization session deleted.",
        "deleteSessionFailed": "Failed to delete session.",
        "bulkDeleteWarning": "Deleted {{deleted}} run(s); {{skipped}} could not be deleted.{{detail}}",
        "bulkDeleteSuccess_one": "Deleted {{count}} optimization run.",
        "bulkDeleteSuccess_other": "Deleted {{count}} optimization runs.",
        "bulkDeleteFailed": "Failed to delete selected optimization runs."
      },
      "bulkDelete": {
        "selectedLabel": "Delete Selected",
        "title": "Delete Selected Runs",
        "message_one": "Are you sure you want to delete {{count}} optimization run? This cannot be undone.",
        "message_other": "Are you sure you want to delete {{count}} optimization runs? This cannot be undone.",
        "confirmLabel_one": "Delete {{count}} Run",
        "confirmLabel_other": "Delete {{count}} Runs"
      }
    },
    "optimizationLogModal": {
      "title": {
        "complete": "Optimization Complete",
        "cancelled": "Optimization Cancelled",
        "failed": "Optimization Failed",
        "running": "Optimizing..."
      },
      "subtitleDefault": "Prompt",
      "closeAriaLabel": "Close",
      "progressLabel": "Progress",
      "statusLabel": "Status:",
      "statusStarting": "STARTING",
      "iterationSuffix": " · Iteration {{iteration}}/{{max}}",
      "bestSuffix": " · Best: {{value}}",
      "runIdLabel": "Run ID:",
      "jobIdLabel": "Job ID:",
      "initializingEngine": "Initializing {{framework}} engine...",
      "loadingDataset": "Loading benchmark dataset",
      "completedIterations": "Completed {{completed}}/{{max}} iterations",
      "cancelRun": "Cancel Run",
      "viewResults": "View Results"
    },
    "commitMessageModal": {
      "title": "Commit Version",
      "closeAriaLabel": "Close",
      "description": "Enter a commit message to describe the changes in this version.",
      "placeholder": "e.g., Fixed typo in prompt, Added new examples...",
      "commit": "Commit",
      "committing": "Committing..."
    },
    "diffView": {
      "noVersionsTitle": "No versions to compare",
      "noVersionsDesc": "Create more versions to see differences between them.",
      "baseLabel": "base:",
      "compareLabel": "compare:",
      "swapTooltip": "Swap base and compare",
      "fileLabel": "prompt.txt",
      "collapseContextTooltip": "Collapse context",
      "expandContextTooltip": "Expand context",
      "copyDiffTooltip": "Copy diff",
      "loadingDiff": "Loading diff...",
      "expandHiddenLines": "Expand {{count}} hidden lines",
      "sameVersionTitle": "Same version selected",
      "sameVersionDesc": "Select different versions to see the differences.",
      "noDifferencesTitle": "No differences",
      "noDifferencesDesc": "These versions are identical.",
      "toast": {
        "copied": "Diff copied to clipboard"
      }
    },
    "versionList": {
      "title": "Versions",
      "refreshTooltip": "Refresh versions",
      "searchPlaceholder": "Search versions...",
      "emptyMessage": "No versions found",
      "editingHint": "Add or edit prompt text on the latest version, then save as a new version."
    },
    "versionItem": {
      "commitTooltip": "Commit Version",
      "commitLabel": "Commit",
      "forkTooltip": "Fork version {{version}}",
      "forkLabel": "Fork",
      "createdByPrefix": "by {{name}}",
      "wordCount_one": "{{count}} word",
      "wordCount_other": "{{count}} words"
    },
    "visibilitySelector": {
      "label": "Visibility",
      "platformDescription": "Available across all projects within the platform",
      "projectDescription": "Available only within the selected project",
      "platformHint": "Prompt will be available across all projects within the platform.",
      "projectHint": "Prompt will be available only to the selected project.",
      "projectLabel": "Project",
      "selectProjectPlaceholder": "Select a project",
      "searchProjectsPlaceholder": "Search projects..."
    }
  },
  "data": {
    "tabs": {
      "knowledge": "Knowledge",
      "graph": "Graph",
      "vector": "Vector DB",
      "storage": "Storage"
    }
  },
  "knowledge": {
    "connections": {
      "tabs": {
        "databases": "Databases",
        "storage": "Storage Accounts",
        "orchestrators": "Orchestrators",
        "telephony": "Telephony",
        "service_connections": "Service Connections"
      }
    },
    "serviceConnectionModal": {
      "titleCreate": "Add Service Connection",
      "titleEdit": "Edit Service Connection",
      "titleView": "View Service Connection",
      "loadingTypes": "Loading service types…",
      "loadingQuota": "Checking quota…",
      "groups": {
        "microsoft": "Microsoft",
        "developer_tools": "Developer tools",
        "google": "Google",
        "business_apps": "Business apps",
        "messaging_and_events": "Messaging and events",
        "http_and_webhooks": "HTTP and webhooks",
        "ai_search": "AI search",
        "observability": "Observability",
        "other": "Other"
      },
      "fields": {
        "name": "Name",
        "description": "Description",
        "iam": "IAM entry",
        "iamPlaceholder": "Select an IAM entry",
        "host": "Resolved host",
        "advanced": "Advanced (optional)"
      },
      "hints": {
        "iamEmpty": "No active IAM entry matches {{subtypes}}. Create one in IAM.",
        "iamLink": "Open IAM",
        "inbound": "Inbound Service Connections do not use an IAM entry.",
        "testRequired": "Test the connection before saving.",
        "secretsOnIam": "Secrets stay on the IAM entry and are never stored here.",
        "missing": "Required: {{fields}}"
      },
      "buttons": {
        "back": "Back",
        "close": "Close",
        "cancel": "Cancel",
        "create": "Create",
        "save": "Save"
      },
      "toasts": {
        "created": "Service Connection created",
        "updated": "Service Connection updated"
      },
      "errors": {
        "testFailed": "Connection test failed",
        "selectTenant": "Select a tenant",
        "selectProject": "Select a project",
        "saveFailed": "Could not save the Service Connection"
      }
    },
    "connectorsTab": {
      "testErrorToast": "Failed to test connection",
      "batchTestSuccessToast_one": "Connection test successful for {{count}} imported connection",
      "batchTestSuccessToast_other": "Connection test successful for {{count}} imported connections",
      "batchTestFailedToast_one": "Connection test failed for {{count}} imported connection",
      "batchTestFailedToast_other": "Connection test failed for {{count}} imported connections",
      "batchTestFinishedToast": "Connection tests finished: {{success}} succeeded, {{fail}} failed",
      "loadErrorToast": "Failed to load connectors",
      "loadingMessage": "Loading connections...",
      "filterResourceLabel": {
        "database": "Database engine",
        "storage": "Storage type",
        "orchestrator": "Orchestrator type",
        "telephony": "Telephony type",
        "service": "Service type"
      },
      "filterAllTypesPlaceholder": "All types",
      "filterCreatorLabel": "Creator",
      "filterAllCreatorsPlaceholder": "All creators",
      "filterStatusLabel": "Status",
      "filterAllStatusesPlaceholder": "All Statuses",
      "filterStatusError": "Error",
      "deletePermissionDeniedToast": "You do not have permission to delete this connector",
      "deleteErrorToast": "Failed to delete connector",
      "bulkDeletePermissionDeniedToast": "You do not have permission to delete connectors",
      "bulkDeletePartialWarning": "Deleted {{deleted}} connector(s), {{skipped}} failed: {{errors}}",
      "bulkDeleteSuccessToast_one": "Deleted {{count}} connector successfully",
      "bulkDeleteSuccessToast_other": "Deleted {{count}} connectors successfully",
      "bulkDeleteErrorToast": "Failed to delete connectors",
      "unsetDefaultToast": "{{name}} is no longer the default {{category}}",
      "setDefaultToast": "{{name}} is now the default {{category}}",
      "unsetDefaultErrorToast": "Failed to remove default {{category}}",
      "setDefaultErrorToast": "Failed to set default {{category}}",
      "status": {
        "active": "Active",
        "failed": "Failed",
        "notTested": "Not tested",
        "unknown": "Unknown"
      },
      "statusTooltip": "Status: {{status}}",
      "authModeTooltip": "Auth: {{mode}}",
      "columnName": "Name",
      "columnCloud": "Cloud",
      "columnResource": "Resource",
      "columnType": "Type",
      "columnHost": "Host",
      "columnStatus": "Status",
      "columnLastTested": "Last Tested",
      "columnCreatedBy": "Created By",
      "columnUpdatedBy": "Updated By",
      "columnActions": "Actions",
      "actionView": "View",
      "actionTestConnection": "Test Connection",
      "actionRemoveAsDefault": "Remove as Default {{category}}",
      "actionSetAsDefault": "Set as Default",
      "actionExport": "Export",
      "actionEdit": "Edit",
      "actionDelete": "Delete",
      "entityFilterAllLabel": "All",
      "entityFilterFavoritesLabel": "Favorites",
      "bulkExportSelected": "Export Selected",
      "bulkDeleteSelected": "Delete Selected",
      "emptyMessage": "No connectors found. Add a connection to connect to databases, storage, or other data sources.",
      "addConnection": "Add Connection",
      "deleteDialogTitle": "Delete Connector",
      "deleteDialogMessage": "Are you sure you want to delete \"{{name}}\"? This will also delete all registered tables from this connector.",
      "deleteDialogConfirmLabel": "Delete",
      "bulkDeleteDialogTitle": "Delete Selected Connectors",
      "bulkDeleteDialogMessage_one": "Are you sure you want to delete {{count}} connector? This will also delete all registered tables from these connectors. This action cannot be undone.",
      "bulkDeleteDialogMessage_other": "Are you sure you want to delete {{count}} connectors? This will also delete all registered tables from these connectors. This action cannot be undone.",
      "bulkDeleteDialogConfirmLabel_one": "Delete {{count}} Connector",
      "bulkDeleteDialogConfirmLabel_other": "Delete {{count}} Connectors"
    },
    "tab": {
      "unknownConnectorType": "Unknown",
      "filterEngineLabel": "Database engine",
      "filterAllEnginesPlaceholder": "All engines",
      "filterCreatorLabel": "Creator",
      "filterAllCreatorsPlaceholder": "All creators",
      "deleteErrorToast": "Failed to delete knowledge table",
      "bulkDeletePartialWarning": "Deleted {{deleted}} table(s), {{skipped}} failed: {{errors}}",
      "bulkDeleteSuccessToast_one": "Deleted {{count}} table successfully",
      "bulkDeleteSuccessToast_other": "Deleted {{count}} tables successfully",
      "bulkDeleteErrorToast": "Failed to delete tables",
      "deleteSchemaErrorToast": "Failed to delete schema",
      "deleteSchemaPartialWarning": "Deleted {{deleted}} table(s) across {{schemaCount}} schema(s); {{skipped}} failed",
      "deleteSchemaSuccessToast_one": "Deleted schema ({{count}} table)",
      "deleteSchemaSuccessToast_other": "Deleted schema ({{count}} tables)",
      "deleteSchemaSuccessToastNamed_one": "Deleted schema \"{{schema}}\" ({{count}} table)",
      "deleteSchemaSuccessToastNamed_other": "Deleted schema \"{{schema}}\" ({{count}} tables)",
      "deleteSchemasSuccessToast_one": "Deleted {{schemaCount}} schemas ({{count}} table)",
      "deleteSchemasSuccessToast_other": "Deleted {{schemaCount}} schemas ({{count}} tables)",
      "syncRequeuedToast": "Metadata sync re-queued (was stuck) for '{{name}}'",
      "syncQueuedToast": "Metadata sync queued for '{{name}}'",
      "syncQueueErrorToast": "Failed to queue metadata sync for '{{name}}'",
      "bulkSyncStartedRequeuedToast_one": "Started metadata sync for {{count}} table (re-queued any stuck introspection)",
      "bulkSyncStartedRequeuedToast_other": "Started metadata sync for {{count}} tables (re-queued any stuck introspection)",
      "bulkSyncStartedToast_one": "Started metadata sync for {{count}} table",
      "bulkSyncStartedToast_other": "Started metadata sync for {{count}} tables",
      "bulkSyncStartErrorToast": "Failed to start bulk metadata sync",
      "columnName": "Name",
      "defaultBadgeTooltip": "Default",
      "schemaTooltip": "Schema: {{schema}}",
      "columnDatabase": "Database",
      "columnType": "Type",
      "columnRows": "Rows",
      "columnIntrospection": "Introspection",
      "syncStatus": {
        "queued": "Queued",
        "running": "Running",
        "synced": "Synced",
        "failed": "Failed",
        "active": "Active"
      },
      "viewSyncLogsTooltip": "View synchronization logs",
      "columnStatus": "Status",
      "columnCreated": "Created",
      "columnUpdated": "Updated",
      "columnCreator": "Creator",
      "unknownCreator": "Unknown",
      "columnLogs": "Logs",
      "viewLink": "View",
      "columnActions": "Actions",
      "actionViewDetails": "View Details",
      "actionPreviewData": "Preview Data",
      "actionApprovals": "Approvals",
      "actionEvals": "Evals",
      "actionEdit": "Edit",
      "actionRequeueSync": "Re-queue metadata sync",
      "actionSyncMetadata": "Sync metadata",
      "actionExport": "Export",
      "actionDelete": "Delete",
      "databaseViewLabel": "Database view",
      "collectionViewLabel": "Collection view",
      "addGraphTable": "Add Graph Table",
      "addKnowledgeTable": "Add Knowledge Table",
      "leafTitleTables": "Tables",
      "leafTitleGraphTables": "Graph tables",
      "defaultSchemaLabel": "(default)",
      "entityFilterAllLabel": "All",
      "entityFilterFavoritesLabel": "Favorites",
      "noGraphConnectorsEmptyMessage": "No graph DB connectors yet.",
      "noDataConnectorsEmptyMessage": "No data connectors yet.",
      "schemasPaneTitle": "Schemas",
      "bulkExportSelected": "Export Selected",
      "bulkSyncMetadata": "Sync metadata",
      "bulkDeleteSelected": "Delete Selected",
      "graphDataExplorerAriaLabel": "Graph data explorer",
      "knowledgeDataExplorerAriaLabel": "Knowledge data explorer",
      "deleteDialogTitle": "Delete Knowledge Table",
      "deleteDialogMessage": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "deleteDialogConfirmLabel": "Delete",
      "deleteSchemaDialogTitle": "Delete Schema",
      "deleteSchemasDialogTitle": "Delete Schemas",
      "deleteSchemaDialogMessage_one": "Are you sure you want to delete schema \"{{schema}}\" and all {{count}} registered table in it? This removes {{brand}} metadata only and cannot be undone.",
      "deleteSchemaDialogMessage_other": "Are you sure you want to delete schema \"{{schema}}\" and all {{count}} registered tables in it? This removes {{brand}} metadata only and cannot be undone.",
      "deleteSchemasDialogMessage_one": "Are you sure you want to delete {{schemaCount}} schemas and all {{count}} registered table in them? This removes {{brand}} metadata only and cannot be undone.",
      "deleteSchemasDialogMessage_other": "Are you sure you want to delete {{schemaCount}} schemas and all {{count}} registered tables in them? This removes {{brand}} metadata only and cannot be undone.",
      "deletingLabel": "Deleting…",
      "deleteSchemasDialogConfirmLabel": "Delete {{count}} Schemas",
      "andOthersLabel": "{{names}} and {{count}} others",
      "bulkDeleteDialogTitle": "Delete Selected Tables",
      "bulkDeleteDialogMessage_one": "Are you sure you want to delete {{count}} table? This action cannot be undone.",
      "bulkDeleteDialogMessage_other": "Are you sure you want to delete {{count}} tables? This action cannot be undone.",
      "bulkDeleteDialogConfirmLabel_one": "Delete {{count}} Table",
      "bulkDeleteDialogConfirmLabel_other": "Delete {{count}} Tables",
      "emptyStatePermissionDenied": "You don't have permission to view {{resource}}. Contact your administrator for access.",
      "emptyStateSearching": "No {{resource}} found matching your search.",
      "emptyStateDefault": "No {{resource}} found. Create your first {{resourceSingular}} to get started.",
      "resourceGraphTables": "graph tables",
      "resourceGraphTable": "graph table",
      "resourceKnowledgeTables": "knowledge tables",
      "resourceKnowledgeTable": "knowledge table"
    },
    "addTableModal": {
      "title": "Add Knowledge Table",
      "closeDialogAriaLabel": "Close dialog",
      "cancelButton": "Cancel",
      "loadConnectorsError": "Failed to load connectors",
      "noDatabasesFoundWarning": "No databases found. The connector may not have access to any databases.",
      "loadTablesTimedOut": "Loading tables timed out. Try a narrower scope or check your connection.",
      "loadTablesForSchemaError": "Failed to load tables for schema",
      "loadingTablesForSchema": "Loading tables for {{schema}}...",
      "schemaFallbackLabel": "schema",
      "inlineSearch": {
        "defaultPlaceholder": "Search",
        "clearAriaLabel": "Clear search"
      },
      "breadcrumb": {
        "backAriaLabel": "Back",
        "schemasCount_one": "{{count}} schema",
        "schemasCount_other": "{{count}} schemas"
      },
      "connectorSelection": {
        "emptyTitle": "No connectors",
        "emptyMessage": "Create a connector first to add knowledge tables",
        "filterByTypeLabel": "Filter by connector type",
        "connectorTypeLabel": "Connector type",
        "allConnectorTypesPlaceholder": "All connector types ({{count}})",
        "searchPlaceholder": "Search connectors",
        "noMatchingConnections": "No matching connections. Adjust the search or pick another connector type."
      },
      "databaseSelection": {
        "loadingCatalog": "Loading catalog…",
        "catalogUnavailableTitle": "Catalog unavailable",
        "catalogUnavailableMessage": "Unable to load the catalog. Check the connector configuration and try again.",
        "noDatabasesTitle": "No databases found",
        "noDatabasesMessage": "The connector does not have access to any databases, or introspection failed.",
        "title": "Select Database",
        "countLabel_one": "{{shown}} of {{count}} database",
        "countLabel_other": "{{shown}} of {{count}} databases",
        "searchPlaceholder": "Search databases",
        "noMatchMessage": "No databases match your search.",
        "schemaCount_one": "{{count}} schema",
        "schemaCount_other": "{{count}} schemas"
      },
      "schemaSelection": {
        "title": "Select Schema",
        "countLabel_one": "{{shown}} of {{count}} schema",
        "countLabel_other": "{{shown}} of {{count}} schemas",
        "selectedCount": "{{count}} selected",
        "deselectAll": "Deselect all",
        "selectAll": "Select all",
        "continueWith_one": "Continue with {{count}} schema",
        "continueWith_other": "Continue with {{count}} schemas",
        "searchPlaceholder": "Search schemas",
        "hint": "Check schemas and Continue to browse them one at a time, or click a card to open one schema.",
        "noMatchMessage": "No schemas match your search.",
        "selectSchemaAriaLabel": "Select schema {{schema}}",
        "tableCount_one": "{{count}} table",
        "tableCount_other": "{{count}} tables",
        "clickToLoadTables": "Click to load tables"
      },
      "tableSelection": {
        "loadingTables": "Loading tables…",
        "noTablesFoundTitle": "No tables found",
        "noTablesInSchema": "No tables available in this schema",
        "noTablesInDatabase": "No tables available in this database",
        "hint": "Tables load for the open schema only. Click rows or use the header checkbox to select.",
        "searchPlaceholder": "Search tables",
        "showingCount": "Showing {{shown}} of {{count}}",
        "selectedAcrossSchemas": "{{count}} selected across schemas",
        "deselectAllAriaLabel": "Deselect all tables",
        "selectAllAriaLabel": "Select all tables",
        "columnTable": "Table",
        "columnDatabase": "Database",
        "columnRows": "Rows",
        "columnCols": "Cols",
        "noMatchMessage": "No tables match your search.",
        "selectTableAriaLabel": "Select {{label}}",
        "updateAvailableTooltip": "New nodes/labels available",
        "updateAvailableBadge": "Update Available",
        "alreadyRegisteredTooltip": "You already registered this table",
        "registeredBadge": "Registered"
      },
      "registrationStep": {
        "loadingTables": "Loading tables…",
        "selectedSchemasAriaLabel": "Selected schemas",
        "multiGraphRegistrationLabel": "Multi-Graph Registration:",
        "multiGraphRegistrationTextPrefix": "Each selected",
        "multiGraphRegistrationTextSuffix": "row registers as a Knowledge asset for that graph.",
        "graphSchemaRegistrationLabel": "Graph Schema Registration:",
        "graphSchemaRegistrationText": "Selected graph tables will be registered as a single graph schema entry.",
        "relationshipTypesDetected_one": "{{count}} relationship type detected.",
        "relationshipTypesDetected_other": "{{count}} relationship types detected.",
        "finalizeAndRegisterTitle": "Finalize & register",
        "subtitleRegisterPrefix": "Register",
        "subtitleChoosePrefix": "Choose how this knowledge is used, then register",
        "subtitleGraphSchemaSuffix_one": "graph table as a single graph schema entry.",
        "subtitleGraphSchemaSuffix_other": "graph tables as a single graph schema entry.",
        "subtitleGraphsSuffix_one": "graph in one step.",
        "subtitleGraphsSuffix_other": "graphs in one step.",
        "subtitleGraphTablesSuffix_one": "graph table in one step.",
        "subtitleGraphTablesSuffix_other": "graph tables in one step.",
        "subtitleTablesSuffix_one": "table in one step.",
        "subtitleTablesSuffix_other": "tables in one step.",
        "selectGraphTablesAbove": "Select graph tables above",
        "selectGraphsAbove": "Select graphs above",
        "selectTablesAbove": "Select tables above",
        "registerGraphSchema_one": "Register graph schema ({{count}} graph table)",
        "registerGraphSchema_other": "Register graph schema ({{count}} graph tables)",
        "registerGraphs_one": "Register {{count}} graph",
        "registerGraphs_other": "Register {{count}} graphs",
        "registerGraphTables_one": "Register {{count}} graph table",
        "registerGraphTables_other": "Register {{count}} graph tables",
        "registerTables_one": "Register {{count}} table",
        "registerTables_other": "Register {{count}} tables"
      },
      "introspectionError": {
        "thisConnection": "this connection",
        "timedOut": "{{name}} took too long to respond.",
        "forbidden": "You don’t have access to browse {{name}} — ask a project admin.",
        "credentialsRejected": "{{name}} rejected the saved credentials.",
        "missingSecret": "{{name}} is missing a password or secret.",
        "databaseNotFound": "The database or catalog saved on {{name}} no longer exists.",
        "hostUnreachable": "Can’t reach the host configured on {{name}}.",
        "serviceBusy": "{{name}} is busy right now.",
        "notConnecting": "{{name}} isn’t connecting.",
        "genericFailure": "Couldn’t load the catalog from {{name}}.",
        "validateInConnections": "Validate in Connections",
        "tryAgain": "Try again"
      }
    },
    "editModal": {
      "title": "Edit Knowledge Table",
      "closeDialogAriaLabel": "Close dialog",
      "vectorDbBadge": "Vector DB",
      "displayNameLabel": "Display Name",
      "displayNamePlaceholder": "Enter display name",
      "nameAlreadyExistsToast": "A knowledge table with this name already exists",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Enter description (optional)",
      "knowledgeTypeLabel": "Knowledge type",
      "knowledgeTypeData": "Data",
      "knowledgeTypeDataHint": "= general knowledge.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksFull": "Benchmarks (Evals & Simulations)",
      "knowledgeTypeBenchmarksHint": "= shown in Evals and Simulations.",
      "knowledgeTypePlaceholder": "Select knowledge type...",
      "benchmarkTypeLabel": "Benchmark type",
      "benchmarkTypeHint": "Workload category shown on the Benchmarks tab (Text2SQL, RAG, Tool-use, …).",
      "benchmarkTypePlaceholder": "Select benchmark type…",
      "benchmarkIconLabel": "Benchmark icon",
      "benchmarkIconHint": "Shown on the benchmark card in Evals & Simulations. Falls back to the connector icon when no image is set.",
      "embeddingModelLabel": "Embedding Model",
      "embeddingModelHint": "Select the embedding model used to create vectors in this table.",
      "embeddingModelPlaceholder": "Select embedding model...",
      "searchModelsPlaceholder": "Search models...",
      "loadingModelsMessage": "Loading embedding models...",
      "noModelsRegisteredMessage": "No embedding models registered. Please register an embedding model first.",
      "noModelSelectedWarning": "No embedding model selected. Vector search may fail or return incorrect results.",
      "defaultBadge": "Default",
      "loadModelsErrorToast": "Failed to load embedding models",
      "updateErrorToast": "Failed to update knowledge table",
      "cancelButton": "Cancel",
      "savingButton": "Saving...",
      "saveChangesButton": "Save Changes"
    },
    "modal": {
      "title": "Register tables for knowledge base",
      "closeDialogAriaLabel": "Close dialog",
      "registeringTooltip_one": "Registering {{count}} table from {{name}}",
      "registeringTooltip_other": "Registering {{count}} tables from {{name}}",
      "registeringText_one": "Registering {{count}} table from {{name}}",
      "registeringText_other": "Registering {{count}} tables from {{name}}",
      "registerSubmitLabel_one": "Register {{count}} table",
      "registerSubmitLabel_other": "Register {{count}} tables",
      "tablesToRegisterLabel": "Tables to register",
      "columnsCount_one": "{{count}} column",
      "columnsCount_other": "{{count}} columns",
      "rowsCount_one": "{{formattedCount}} row",
      "rowsCount_other": "{{formattedCount}} rows",
      "columnsHeader": "Columns",
      "notNullBadge": "NOT NULL",
      "cancelButton": "Cancel"
    },
    "viewModal": {
      "title": "Knowledge Table Details",
      "closeDialogAriaLabel": "Close dialog",
      "closeButton": "Close",
      "notAvailable": "N/A",
      "yesLabel": "Yes",
      "noLabel": "No",
      "noneDetectedMessage": "None detected",
      "statusUnknown": "Unknown",
      "statusActive": "Active",
      "statusError": "Error",
      "statusSyncing": "Syncing",
      "noErrorsMessage": "No errors",
      "noColumnInfoMessage": "No column information available",
      "basicInformationHeader": "Basic Information",
      "tableInformationHeader": "Table Information",
      "graphInformationHeader": "Graph Information",
      "embeddingModelHeader": "Embedding Model",
      "columnsHeader": "Columns",
      "errorInformationHeader": "Error Information",
      "metadataHeader": "Metadata",
      "auditInformationHeader": "Audit Information",
      "fieldId": "ID",
      "fieldConnector": "Connector",
      "fieldStatus": "Status",
      "fieldDatabase": "Database",
      "fieldSchema": "Schema",
      "fieldTableName": "Table Name",
      "fieldRowCountNodes": "Row Count (Nodes)",
      "fieldTotalNodes": "Total Nodes",
      "fieldTotalEdges": "Total Edges",
      "fieldRelationshipTypes": "Relationship Types",
      "fieldNodeLabels": "Node Labels",
      "fieldModel": "Model",
      "fieldErrorMessage": "Error Message",
      "fieldCreatedAt": "Created At",
      "fieldUpdatedAt": "Updated At",
      "fieldCreatedBy": "Created By",
      "fieldUpdatedBy": "Updated By",
      "noEmbeddingModelConfiguredTitle": "No Embedding Model Configured",
      "noEmbeddingModelConfiguredHint": "Vector search may fail or return incorrect results. Edit this table to assign an embedding model that matches the one used to create the stored vectors.",
      "columnName": "Name",
      "columnType": "Type",
      "columnNullable": "Nullable"
    },
    "registerFields": {
      "embeddingModelLabel": "Embedding model",
      "embeddingModelHint": "Model used for semantic search on these vector tables.",
      "loadingModelsMessage": "Loading embedding models…",
      "noModelsRegisteredMessage": "No embedding models registered. Add one first.",
      "noModelsMatchingDimensionMessage": "No embedding models match this table's vector dimension ({{dimension}}). Register an embedding model with the same output size.",
      "selectEmbeddingModelOption": "— Select embedding model —",
      "defaultBadge": "Default",
      "managedVectorDbHint": "This connector manages indexes and embeddings internally — no column mapping required. The selected embedding model will be used at query time to embed your search query.",
      "columnMappingLabel": "Column mapping",
      "columnMappingHint": "Map ID, content, and embedding columns for vector search.",
      "columnLabelId": "ID",
      "columnLabelContent": "Content",
      "columnLabelEmbedding": "Embedding",
      "columnFieldLabel": "{{column}} column",
      "selectOption": "— Select —",
      "vectorSuffix": "vector",
      "knowledgePurposeLabel": "Knowledge purpose",
      "knowledgeTypeData": "Data",
      "knowledgeTypeDataHint": "for general RAG.",
      "knowledgeTypeBenchmarks": "Benchmarks",
      "knowledgeTypeBenchmarksHint": "surfaces this data in Evals & Simulations.",
      "knowledgeTypeGroupAriaLabel": "Knowledge type",
      "encryptDataLabel": "Encrypt table data at rest for viewers",
      "encryptDataHint": "Only you (creator) see plain values; others see ciphertext. Uses the same key as tool secrets.",
      "selectEmbeddingModelTooltip": "Select an embedding model",
      "mapColumnsTooltip": "Map ID, content, and embedding columns",
      "registeringButton": "Registering…"
    },
    "groupedView": {
      "loadingMessage": "Loading tables...",
      "emptyMessage": "No knowledge tables found",
      "emptySearchHint": "Try adjusting your search query",
      "tableCount_one": "{{count}} table",
      "tableCount_other": "{{count}} tables",
      "rowsCount_one": "{{formattedCount}} row",
      "rowsCount_other": "{{formattedCount}} rows",
      "vectorDbTooltip": "Vector Database",
      "vectorDbBadge": "Vector DB",
      "createdTooltip": "Created",
      "updatedTooltip": "Updated",
      "statusUnknown": "Unknown",
      "statusError": "Error",
      "statusActive": "Active",
      "statusSyncing": "Syncing",
      "actionViewDetails": "View Details",
      "actionPreviewData": "Preview Data",
      "actionEdit": "Edit",
      "actionVectorSearch": "Vector Search",
      "actionSync": "Sync",
      "actionManageAccess": "Manage Access",
      "actionDelete": "Delete"
    },
    "addStorageFolderModal": {
      "title": "Add Storage Folder",
      "closeDialogAriaLabel": "Close dialog",
      "selectConnectorTitle": "Select Storage Connector",
      "noConnectorsFoundMessage": "No storage connectors found. Please create a storage connector first.",
      "searchConnectorsPlaceholder": "Search connectors",
      "countOf": "{{shown}} of {{count}}",
      "noConnectorsMatchFilters": "No connectors match your filters.",
      "connectorTypeLabel": "Connector type",
      "allConnectorTypesPlaceholder": "All connector types ({{count}})",
      "selectBucketTitle": "Select Bucket",
      "noBucketsFoundMessage": "No buckets found.",
      "searchBucketsPlaceholder": "Search buckets",
      "noBucketsMatchSearch": "No buckets match your search.",
      "selectFoldersTitle": "Select Folders",
      "selectAllButton": "Select All",
      "deselectAllButton": "Deselect All",
      "searchFoldersPlaceholder": "Search folders",
      "fileCount_one": "{{count}} file",
      "fileCount_other": "{{count}} files",
      "openSubfolderTooltip": "Open subfolder",
      "noFoldersMatchSearch": "No folders match your search.",
      "noSubfoldersMessage": "No subfolders here. You can register this folder path if it contains files.",
      "noFoldersInBucketMessage": "No folders found in this bucket.",
      "selectFolderButton": "Select folder \"{{name}}\"",
      "selectedFoldersCount_one": "{{count}} folder selected",
      "selectedFoldersCount_other": "{{count}} folders selected",
      "cancelButton": "Cancel",
      "registeringButton": "Registering...",
      "registerFoldersButton_one": "Register {{count}} Folder",
      "registerFoldersButton_other": "Register {{count}} Folders",
      "registerSuccessToast_one": "Successfully registered {{count}} storage folder. Use Sync to refresh file counts (requires storage list permission).",
      "registerSuccessToast_other": "Successfully registered {{count}} storage folders. Use Sync to refresh file counts (requires storage list permission)."
    },
    "splitView": {
      "storageBucketPane": {
        "title": "Buckets",
        "columnBucket": "Bucket",
        "columnFolders": "Folders",
        "defaultBucketLabel": "(default)",
        "searchPlaceholder": "Search buckets…",
        "emptyMessage": "No buckets registered.",
        "emptySearchMessage": "No buckets match this search.",
        "loadErrorMessage": "Failed to load buckets"
      },
      "connectorPane": {
        "columnCreatedAt": "Created",
        "columnDatabase": "Type",
        "columnName": "Name",
        "columnStatus": "Status",
        "columnUpdatedAt": "Updated",
        "emptyMessage": "No connectors found.",
        "emptySearchMessage": "No connectors match your search.",
        "loadErrorMessage": "Failed to load connectors.",
        "searchPlaceholder": "Search connectors…",
        "title": "Connectors"
      },
      "schemaPane": {
        "ariaDeleteMany_one": "Delete {{count}} selected schema",
        "ariaDeleteMany_other": "Delete {{count}} selected schemas",
        "ariaDeleteOne": "Delete selected schema",
        "columnName": "Name",
        "columnObjects": "Objects",
        "defaultLabel": "default",
        "deleteTitleEmpty": "Delete Schema",
        "deleteTitleMany_one": "Delete {{count}} Schema",
        "deleteTitleMany_other": "Delete {{count}} Schemas",
        "deleteTitleOne": "Delete Schema",
        "deleteTitleOneNamed": "Delete {{schema}}",
        "emptyMessage": "No schemas found",
        "emptySearchMessage": "No schemas match your search",
        "loadErrorMessage": "Failed to load schemas",
        "searchPlaceholder": "Search {{title}}…",
        "title": "Schemas"
      }
    },
    "connectorFields": {
      "extraParamField": {
        "authApiKey": "API Key",
        "authBasic": "Basic Auth",
        "configured": "configured",
        "engineMssql": "SQL Server",
        "engineMysql": "MySQL",
        "enginePostgres": "PostgreSQL",
        "payloadBase64Json": "Base64 JSON",
        "payloadBinary": "Binary",
        "provisioned": "Provisioned",
        "schemeBolt": "bolt",
        "schemeBoltS": "bolt+s",
        "schemeNeo4j": "neo4j",
        "schemeNeo4jS": "neo4j+s",
        "serverless": "Serverless"
      },
      "extraParams": {
        "advancedLabel": "Advanced options"
      },
      "scopeSelector": {
        "currentScope": "Current scope: {{scope}}",
        "enableTenantNote": "Turn this on to change the scope to Tenant mode.",
        "projectDescription": "Available only within a specific project",
        "projectFieldLabel": "Project",
        "projectHint": "This connector will only be available within the selected project.",
        "projectLabel": "Project",
        "projectPlaceholder": "Select a project",
        "projectSearchPlaceholder": "Search projects…",
        "tenantDescription": "Available to all projects in this tenant",
        "tenantHint": "This connector will be available to all projects in this tenant.",
        "tenantLabel": "Tenant",
        "tenantToggleLabel": "Tenant scope"
      },
      "shared": {
        "aihubSubscriptionKeySecretNameLabel": "AI Hub Subscription Key Secret Name",
        "authHelp": {
          "awsDefault": "Provide AWS credentials for this connector.",
          "awsKeyBoto": "AWS access key and secret key used via boto3.",
          "awsKeySql": "AWS access key and secret key used to connect to the database.",
          "awsWif": "Use AWS Workload Identity Federation instead of long-lived access keys.",
          "azureAiSearchKey": "Connect to Azure AI Search using an admin API key.",
          "azureAihub": "Connect using an AI Hub subscription key instead of Azure AD credentials.",
          "azureBlobKey": "Connect to Azure Blob Storage using an account key.",
          "azureDocIntelligenceKey": "Connect to Azure Document Intelligence using an API key.",
          "azureKeyDefault": "Connect using a key or connection string.",
          "azureOboAiSearch": "Access Azure AI Search on behalf of the signed-in user (delegated auth).",
          "azureOboBlob": "Access Azure Blob Storage on behalf of the signed-in user (delegated auth).",
          "azureOboDefault": "Access this resource on behalf of the signed-in user (delegated auth).",
          "azureOboDocIntelligence": "Access Azure Document Intelligence on behalf of the signed-in user (delegated auth).",
          "azureOboSharePoint": "Access SharePoint on behalf of the signed-in user (delegated auth).",
          "azureSharePointKey": "Connect to SharePoint using a client secret.",
          "azureSpAiSearch": "Access {brand} Azure AI Search using a registered service principal.",
          "azureSpBlob": "Access Azure Blob Storage using a registered service principal.",
          "azureSpDefault": "Access this resource in {brand} using a registered service principal.",
          "azureSpDocIntelligence": "Access Azure Document Intelligence in {brand} using a registered service principal.",
          "azureSpRlsDeprecated": "This service principal mode is deprecated. Switch to a supported authentication mode.",
          "azureSpSharePoint": "Access SharePoint using a registered service principal.",
          "gcpDefault": "Provide GCP credentials for this connector.",
          "gcpKey": "Connect using a GCP service account key.",
          "gcpSaDefault": "Connect using a GCP service account.",
          "gcpSaGcs": "Access Google Cloud Storage using a GCP service account.",
          "gcpSaRlsDeprecated": "This service account mode is deprecated. Switch to a supported authentication mode.",
          "gcpWifDefault": "Connect using GCP Workload Identity Federation.",
          "gcpWifGcs": "Access Google Cloud Storage using GCP Workload Identity Federation.",
          "oracleIamRequired": "A Cloud IAM entry is required for this Oracle authentication mode.",
          "oracleUsernamePassword": "Connect using an Oracle database username and password.",
          "oracleWallet": "Connect using an Oracle wallet."
        },
        "authModeLabel": "Authentication Mode",
        "authModePlaceholder": "Select authentication mode",
        "databaseEngineHelpText": "Select the underlying database engine for this Azure Managed SQL connection.",
        "databaseEngineLabel": "Database Engine",
        "databaseLabel": "Database",
        "databaseUsernameEntraLabel": "Entra Display Name",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Optional description for this connector",
        "displayNameLabel": "Display Name",
        "displayNamePlaceholder": "e.g. Production Database",
        "docIntelVerifySslHelpText": "Disable only when connecting to a Document Intelligence endpoint with a self-signed certificate.",
        "engineMysql": "MySQL",
        "enginePostgresql": "PostgreSQL",
        "engineSqlServer": "SQL Server",
        "entraDisplayNamePlaceholder": "e.g. john.doe@company.com",
        "entraUsernameHelpText": "Enter the Entra ID display name or UPN for the database principal.",
        "fromIamSuffix": "(from Cloud IAM)",
        "iamEmptyWarning": {
          "awsBasicAuth": "No AWS Basic Auth Cloud IAM entries found. Add one before continuing.",
          "awsIamUser": "No AWS IAM user Cloud IAM entries found. Add one before continuing.",
          "awsWif": "No AWS Workload Identity Federation Cloud IAM entries found. Add one before continuing.",
          "azureBasicAuth": "No Azure Basic Auth Cloud IAM entries found. Add one before continuing.",
          "azureBlobIamOnly": "No Azure Blob Storage Cloud IAM entries found. Add one before continuing.",
          "azureBlobKey": "No Azure Blob Storage key Cloud IAM entries found. Add one before continuing.",
          "azureServicePrincipal": "No Azure Service Principal Cloud IAM entries found. Add one before continuing.",
          "databricks": "No Databricks Cloud IAM entries found. Add a personal access token before continuing.",
          "default": "No Cloud IAM entries found. Add one before continuing.",
          "gcp": "No GCP Cloud IAM entries found. Add one before continuing.",
          "gcpBasicAuth": "No GCP Basic Auth Cloud IAM entries found. Add one before continuing.",
          "gcpServiceAccount": "No GCP service account Cloud IAM entries found. Add one before continuing.",
          "tokenBasedOnprem": "No access token Cloud IAM entries found. Add one before continuing."
        },
        "iamHelp": {
          "awsAccessKeys": "Select the Cloud IAM entry containing your AWS access key and secret key.",
          "awsBasicAuth": "Select the Cloud IAM entry containing your AWS database credentials.",
          "awsWif": "Select the Cloud IAM entry configured for AWS Workload Identity Federation.",
          "azureBasicAuth": "Select the Cloud IAM entry containing your Azure Basic Auth credentials.",
          "azureBlobIamOnly": "Select the Cloud IAM entry for Azure Blob Storage access.",
          "azureBlobKey": "Select the Cloud IAM entry containing your Azure Blob Storage account key.",
          "azureServicePrincipal": "Select the Cloud IAM entry for the Azure Service Principal.",
          "databricks": "Select the Cloud IAM entry containing your Databricks personal access token.",
          "default": "Select a Cloud IAM entry for this connector.",
          "gcp": "Select the Cloud IAM entry for this GCP connector.",
          "gcpBasicAuth": "Select the Cloud IAM entry containing your GCP Basic Auth credentials.",
          "gcpServiceAccount": "Select the Cloud IAM entry containing your GCP service account key.",
          "gcpTokenMode": "Select the Cloud IAM entry used to generate access tokens.",
          "gcpWif": "Select the Cloud IAM entry configured for GCP Workload Identity Federation.",
          "oracleOptional": "Optionally select a Cloud IAM entry instead of entering credentials directly.",
          "oracleRequired": "Select the Cloud IAM entry required for this Oracle authentication mode.",
          "tokenBasedOnprem": "Select the Cloud IAM entry containing your access token."
        },
        "iamLabel": {
          "accessToken": "Access Token",
          "awsAccessKeys": "AWS Access Keys",
          "awsBasicAuth": "AWS Basic Auth",
          "awsWif": "AWS Workload Identity Federation",
          "azureBasicAuth": "Azure Basic Auth",
          "azureBlobStorage": "Azure Blob Storage",
          "azureOrGraph": "Azure AD / Microsoft Graph",
          "azureServicePrincipal": "Azure Service Principal",
          "azureStorage": "Azure Storage",
          "cloudIam": "Cloud IAM",
          "cloudIamOptional": "Cloud IAM (optional)",
          "databricksIam": "Databricks IAM (PAT or service principal)",
          "databricksPat": "Databricks Personal Access Token",
          "gcp": "GCP Cloud IAM",
          "gcpBasicAuth": "GCP Basic Auth",
          "gcpServiceAccount": "GCP Service Account",
          "gcpWif": "GCP Workload Identity Federation"
        },
        "iamPlaceholder": {
          "accessToken": "Select an access token",
          "awsAccessKeys": "Select AWS access keys",
          "awsBasicAuth": "Select AWS Basic Auth credentials",
          "awsWif": "Select AWS Workload Identity Federation entry",
          "azureBasicAuth": "Select Azure Basic Auth credentials",
          "azureBlobIamOnly": "Select an Azure Blob Storage Cloud IAM entry",
          "azureBlobKey": "Select an Azure Blob Storage key",
          "azureServicePrincipal": "Select an Azure Service Principal",
          "databricksIam": "Select a Databricks IAM entry (PAT or service principal)",
          "databricksPat": "Select a Databricks personal access token",
          "default": "Select a Cloud IAM entry",
          "gcp": "Select a GCP Cloud IAM entry",
          "gcpBasicAuth": "Select GCP Basic Auth credentials",
          "gcpServiceAccount": "Select a GCP service account",
          "gcpWif": "Select a GCP Workload Identity Federation entry"
        },
        "loadingIamEntries": "Loading Cloud IAM entries…",
        "passwordSecretKeyNameOptionalLabel": "Password Secret Key Name (optional)",
        "portLabel": "Port",
        "schemaLabel": "Schema",
        "secretKeyNameLabel": "Secret Key Name",
        "secretKeyNamePlaceholder": "e.g. my-connector-password",
        "serverHostHelpMssql": "Enter the SQL Server hostname, e.g. myserver.database.windows.net",
        "serverHostHelpMysql": "Enter the MySQL hostname, e.g. myserver.mysql.database.azure.com",
        "serverHostHelpPostgres": "Enter the PostgreSQL hostname, e.g. myserver.postgres.database.azure.com",
        "serverHostLabel": "Server Host",
        "usernameLabel": "Username"
      },
      "testSection": {
        "cancel": "Cancel",
        "connectionFailed": "Connection Failed",
        "connectionSuccessful": "Connection Successful",
        "latency": "Latency: {{ms}} ms",
        "subtitle": "Verify your connection settings before saving",
        "testConnection": "Test Connection",
        "title": "Test Connection",
        "version": "Version: {{version}}"
      }
    },
    "connectorModal": {
      "aria": {
        "backToSelection": "Back to connector selection",
        "closeDialog": "Close dialog"
      },
      "buttons": {
        "addConnector": "Add Connector",
        "back": "Back",
        "cancel": "Cancel",
        "creating": "Creating…",
        "updateConnector": "Update Connector",
        "updating": "Updating…"
      },
      "connectorsLabel": "Connectors",
      "errors": {
        "aiHubSecretRequired": "AI Hub subscription key secret name is required",
        "awsIamUserRequired": "Select an AWS IAM user Cloud IAM entry",
        "awsWifIamRequired": "Select an AWS Workload Identity Federation Cloud IAM entry",
        "azureBasicAuthIamRequired": "Select a Cloud IAM entry for Azure Basic Auth",
        "azureBlobIamRequired": "Select a Cloud IAM entry for Azure Blob Storage",
        "azureBlobIamRequiredFull": "A Cloud IAM entry is required for Azure Blob Storage access",
        "azureSpIamRequiredObo": "Select a Cloud IAM entry for On-Behalf-Of delegated access",
        "azureSpIamRequiredSp": "Select a Cloud IAM entry for the Azure Service Principal",
        "cloudIamOrSecretRequired": "Provide either a Cloud IAM entry or a secret key name",
        "cloudIamRequired": "A Cloud IAM entry is required",
        "cloudIamRequiredForMode": "A Cloud IAM entry is required for this authentication mode",
        "displayNameRequired": "Display name is required",
        "fieldRequired": "{{field}} is required",
        "gcpBasicAuthIamRequired": "Select a Cloud IAM entry for GCP Basic Auth",
        "gcpServiceAccountIamRequired": "Select a Cloud IAM entry for the GCP service account",
        "hostNoUnderscores": "Host cannot contain underscores",
        "nameAlreadyExists": "A connector with this name already exists",
        "oracleCloudIamRequired": "A Cloud IAM entry is required for this Oracle authentication mode",
        "oracleSecretOrIamRequired": "{{field}} is required, or select a Cloud IAM entry",
        "portRange": "Port must be between 1 and 65535",
        "projectRequired": "Select a project",
        "provideCloudIamOrSecret": "Provide a Cloud IAM entry or a secret before testing",
        "schemaRequired": "Schema is required",
        "sharepointCredentialsRequired": "SharePoint credentials are required",
        "testFailedCheckConfig": "Connection test failed. Check your configuration and try again.",
        "usernameRequired": "Username is required",
        "walletLocationRequired": "Wallet location is required"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub Subscription Key Secret Name",
        "awsIamUserCloudIamEntry": "AWS IAM User Cloud IAM Entry",
        "awsWifCloudIamEntry": "AWS Workload Identity Federation Cloud IAM Entry",
        "azureBasicAuthIamRequired": "Azure Basic Auth Cloud IAM Entry",
        "azureBlobIamEntry": "Azure Blob Storage Cloud IAM Entry",
        "azureBlobIamRequiredForMode": "Azure Blob Storage Cloud IAM Entry",
        "azureSpIamObo": "Azure Service Principal (On-Behalf-Of) Cloud IAM Entry",
        "azureSpIamSp": "Azure Service Principal Cloud IAM Entry",
        "cloudIamEntry": "Cloud IAM Entry",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM Entry or Password Secret Key Name",
        "connectorFallback": "connector",
        "database": "Database",
        "displayName": "Display Name",
        "gcpIamEntryBasicAuth": "GCP Basic Auth Cloud IAM Entry",
        "gcpIamEntryServiceAccount": "GCP Service Account Cloud IAM Entry",
        "host": "Host",
        "passwordSecretKeyName": "Password Secret Key Name",
        "project": "Project",
        "secretKeyName": "Secret Key Name",
        "sharepointCredentialsRequired": "SharePoint Credentials",
        "walletLocation": "Wallet Location"
      },
      "loadingQuota": "Loading quota…",
      "missingFieldsTitle": "Missing required fields: {{fields}}",
      "requiredFieldsHint": "Missing: {{fields}}",
      "titles": {
        "configureConnector": "Configure {{name}}",
        "editConnector": "Edit Connector",
        "selectConnectorType": "Select Connector Type"
      },
      "toasts": {
        "createFailed": "Failed to create connector",
        "updateFailed": "Failed to update connector"
      }
    },
    "connectorSelectionGrid": {
      "categories": {
        "aws": "AWS",
        "azure": "Azure",
        "databricks": "Databricks",
        "gcp": "GCP",
        "onprem": "On-Prem",
        "orchestrators": "Orchestrators",
        "snowflake": "Snowflake",
        "storage": "Storage",
        "telephony": "Telephony",
        "vectorDb": "Vector DB"
      },
      "loading": "Loading connector types…"
    },
    "connectorViewModal": {
      "aria": {
        "backToSelection": "Back to connector selection",
        "closeDialog": "Close dialog"
      },
      "buttons": {
        "addConnector": "Add Connector",
        "back": "Back",
        "cancel": "Cancel",
        "close": "Close",
        "creating": "Creating…",
        "updateConnector": "Update Connector",
        "updating": "Updating…"
      },
      "connectorsLabel": "Connectors",
      "errors": {
        "aiHubSecretRequired": "AI Hub subscription key secret name is required",
        "awsIamUserRequired": "Select an AWS IAM user Cloud IAM entry",
        "awsWifIamRequired": "Select an AWS Workload Identity Federation Cloud IAM entry",
        "azureBasicAuthIamRequired": "Select a Cloud IAM entry for Azure Basic Auth",
        "azureBlobIamRequired": "Select a Cloud IAM entry for Azure Blob Storage",
        "azureBlobIamRequiredFull": "A Cloud IAM entry is required for Azure Blob Storage access",
        "azureSpIamRequiredObo": "Select a Cloud IAM entry for On-Behalf-Of delegated access",
        "azureSpIamRequiredSp": "Select a Cloud IAM entry for the Azure Service Principal",
        "cloudIamOrSecretRequired": "Provide either a Cloud IAM entry or a secret key name",
        "cloudIamRequired": "A Cloud IAM entry is required",
        "cloudIamRequiredForMode": "A Cloud IAM entry is required for this authentication mode",
        "displayNameRequired": "Display name is required",
        "fieldRequired": "{{field}} is required",
        "gcpBasicAuthIamRequired": "Select a Cloud IAM entry for GCP Basic Auth",
        "gcpServiceAccountIamRequired": "Select a Cloud IAM entry for the GCP service account",
        "oracleCloudIamRequired": "A Cloud IAM entry is required for this Oracle authentication mode",
        "oracleSecretOrIamRequired": "{{field}} is required, or select a Cloud IAM entry",
        "portRange": "Port must be between 1 and 65535",
        "provideCloudIamOrSecret": "Provide a Cloud IAM entry or a secret before testing",
        "schemaRequired": "Schema is required",
        "sharepointCredentialsRequired": "SharePoint credentials are required",
        "testFailedCheckConfig": "Connection test failed. Check your configuration and try again.",
        "usernameRequired": "Username is required",
        "walletLocationRequired": "Wallet location is required"
      },
      "fields": {
        "aiHubSubscriptionKeySecretName": "AI Hub Subscription Key Secret Name",
        "awsIamUserCloudIamEntry": "AWS IAM User Cloud IAM Entry",
        "awsWifCloudIamEntry": "AWS Workload Identity Federation Cloud IAM Entry",
        "azureBasicAuthIamRequired": "Azure Basic Auth Cloud IAM Entry",
        "azureBlobIamEntry": "Azure Blob Storage Cloud IAM Entry",
        "azureBlobIamRequiredForMode": "Azure Blob Storage Cloud IAM Entry",
        "azureSpIamObo": "Azure Service Principal (On-Behalf-Of) Cloud IAM Entry",
        "azureSpIamSp": "Azure Service Principal Cloud IAM Entry",
        "cloudIamEntry": "Cloud IAM Entry",
        "cloudIamOrPasswordSecretKeyName": "Cloud IAM Entry or Password Secret Key Name",
        "connectorFallback": "connector",
        "database": "Database",
        "displayName": "Display Name",
        "gcpIamEntryBasicAuth": "GCP Basic Auth Cloud IAM Entry",
        "gcpIamEntryServiceAccount": "GCP Service Account Cloud IAM Entry",
        "host": "Host",
        "passwordSecretKeyName": "Password Secret Key Name",
        "secretKeyName": "Secret Key Name",
        "sharepointCredentialsRequired": "SharePoint Credentials",
        "walletLocation": "Wallet Location"
      },
      "loadingQuota": "Loading quota…",
      "missingFieldsTitle": "Missing required fields: {{fields}}",
      "requiredFieldsHint": "Missing: {{fields}}",
      "titles": {
        "configureConnector": "Configure {{name}}",
        "editConnector": "Edit Connector",
        "selectConnectorType": "Select Connector Type",
        "viewConnection": "View Connection"
      },
      "toasts": {
        "createFailed": "Failed to create connector",
        "updateFailed": "Failed to update connector"
      }
    },
    "graphEvals": {
      "backToGraphAriaLabel": "Back to graph",
      "cancel": "Cancel",
      "close": "Close",
      "columnConfidence": "Confidence",
      "columnDateTime": "Date / Time",
      "columnGrade": "Grade",
      "columnReport": "Report",
      "columnSchema": "Schema",
      "columnSemantic": "Semantic",
      "columnStatus": "Status",
      "columnStructural": "Structural",
      "confidenceMeta": "Confidence: {{value}}",
      "configModalAriaLabel": "Run evaluation configuration",
      "derivationsDescFallback": "Run an evaluation to see how the quality grade is calculated.",
      "download": "Download",
      "downloadReportTooltip": "Download report PDF",
      "emptyRunsMessage": "No evaluations have been run yet.",
      "entityCompletenessLabel": "Entity completeness",
      "gradeConfidenceSummary": "Grade {{grade}} · {{confidence}} confidence",
      "gradeErrorAbbreviation": "ERR",
      "hideFormulas": "Hide formulas",
      "howScoresCalculatedTitle": "How scores are calculated",
      "latestScoresAriaLabel": "Latest quality scores",
      "llmModelLabel": "LLM model",
      "llmModelTooltip": "Model used to judge semantic coherence",
      "loadingEvaluations": "Loading evaluations…",
      "loadingModelsPlaceholder": "Loading models…",
      "loadingReport": "Loading report…",
      "missingGraphIdMessage": "No graph table was specified.",
      "modelDefaultLabel": "{{name}} (default)",
      "noMatchingEvaluations": "No evaluations match your search.",
      "noReportAttachedMessage": "This run has no report attached.",
      "noStructuralBreakdown": "No structural breakdown available.",
      "pageSubtitle": "Quality evaluation history for {{name}}",
      "pageTitle": "Graph Evaluations",
      "pdfFrameTitle": "Validation report",
      "qualityGradeHelp": "Overall quality grade, derived from the weighted mix of structural health, schema conformance, and semantic coherence.",
      "qualityGradeLabel": "Quality grade",
      "refresh": "Refresh",
      "relationshipRichnessLabel": "Relationship richness",
      "reportDownloadFailedMessage": "Failed to download the report.",
      "reportLoadFailedGeneric": "Failed to load report",
      "reportLoadFailedMessage": "Failed to load the report file.",
      "reportModalAriaLabel": "Validation report",
      "runEvaluationButton": "Run Evaluation",
      "runEvaluationDescription": "Choose what to validate and how much of the graph to sample.",
      "runEvaluationTitle": "Run Evaluation",
      "running": "Running…",
      "runningEvaluation": "Running evaluation…",
      "sampleSizeLabel": "Sample size",
      "schemaConformanceDerivationHelp": "How the schema conformance score is derived from entity and relationship completeness.",
      "schemaConformanceHelp": "How closely entities and relationships in the graph follow the registered schema.",
      "schemaConformanceLabel": "Schema conformance",
      "schemaFormulaFallback": "Run an evaluation to see the schema conformance formula.",
      "schemaMetaFallback": "No schema data yet",
      "schemaPartsFormula": "Entity {{entity}} × Relationship {{relationship}} = {{result}}",
      "scopeAll": "Entire graph",
      "scopeSample": "Sample",
      "scoreDerivationsAriaLabel": "Score derivations",
      "searchEvaluationsPlaceholder": "Search evaluations…",
      "searchModelsPlaceholder": "Search models…",
      "selectAtLeastOneTargetError": "Select at least one validation target.",
      "selectModelPlaceholder": "Select a model",
      "semanticCoherenceCaveat": "Semantic coherence is judged on a sample and may not reflect the entire graph.",
      "semanticCoherenceDerivationHelp": "How the semantic coherence score is derived from the sampled triplets.",
      "semanticCoherenceHelp": "Whether relationships in the graph make logical, factual sense.",
      "semanticCoherenceLabel": "Semantic coherence",
      "semanticFactScopeLegend": "Facts to validate",
      "semanticFormula": "{{coherent}} coherent / {{sampled}} sampled = {{result}}",
      "semanticMetaCoherent": "{{coherent}} / {{sampled}} coherent",
      "semanticMetaFallback": "No semantic data yet",
      "semanticMetaSampled": "Sampled {{sampled}} of {{total}}",
      "semanticMetaTotal": "{{total}} triplets",
      "showFormulas": "Show formulas",
      "startEvaluation": "Start Evaluation",
      "structuralFormula": "Weighted average of node/edge integrity checks",
      "structuralHealthDerivationHelp": "How the structural health score is derived from the underlying integrity checks.",
      "structuralHealthHelp": "Structural integrity of the graph — dangling references, orphan nodes, and malformed edges.",
      "structuralHealthLabel": "Structural health",
      "structuralMetaFallback": "No structural data yet",
      "targetSchema": "Schema conformance",
      "targetSemantic": "Semantic coherence",
      "targetStructural": "Structural health",
      "validatingHint": "This can take a few minutes depending on graph size.",
      "validationReportTitle": "Validation Report",
      "validationTargetsLegend": "Validation targets",
      "view": "View",
      "weightBitSchema": "schema {{value}}",
      "weightBitSemantic": "semantic {{value}}",
      "weightBitStructural": "structural {{value}}",
      "weightedMixSummary": "Weighted mix of {{bits}} = {{confidence}} confidence"
    },
    "graphApprovalSession": {
      "addToQueue": "Add to Queue",
      "addTripletButton": "Add Triplet",
      "addTripletDescription": "Propose a new subject–relation–object triplet for this session.",
      "addTripletTitle": "Add Triplet",
      "approve": "Approve",
      "approveAll": "Approve All",
      "backToApprovalsAriaLabel": "Back to approvals",
      "cancel": "Cancel",
      "collapse": "Collapse",
      "collapsePanelAriaLabel": "Collapse review panel",
      "collapseSchemaPanelAriaLabel": "Collapse schema panel",
      "collapseSchemaTooltip": "Collapse schema panel",
      "columnConfidence": "Confidence",
      "columnObject": "Object",
      "columnRelation": "Relation",
      "columnSubject": "Subject",
      "commit": "Commit",
      "commitSuccessApplied": "Changes applied",
      "commitSuccessCounted_one": "{{count}} decision committed",
      "commitSuccessCounted_other": "{{count}} decisions committed",
      "committing": "Committing…",
      "confidenceRangeLabel": "Confidence (0–1)",
      "confidenceTooltip": "Confidence: {{value}}",
      "decisionRecorded": "Decision recorded.",
      "defaultSessionTitle": "Approval Session",
      "emptyAllMessage": "No proposed changes in this session.",
      "emptyFilteredMessage": "No {{kind}} match the current filter.",
      "entityNamePlaceholder": "Entity name",
      "expandPanelAriaLabel": "Expand review panel",
      "expandSchemaPanelAriaLabel": "Expand schema panel",
      "filterAll": "All",
      "filterEntities": "Entities",
      "filterProposedUpdatesAriaLabel": "Filter proposed updates",
      "filterTriplets": "Triplets",
      "graphCanvasAriaLabel": "Graph canvas",
      "legendConflict": "Conflict",
      "legendExisting": "Existing",
      "legendNew": "New",
      "missingIdsMessage": "No table or session was specified.",
      "modify": "Modify",
      "modifySnapshotTitle": "Modify Snapshot",
      "noChangesStaged": "No changes staged",
      "noConfidenceScore": "No confidence score",
      "pendingBadge_one": "{{count}} pending",
      "pendingBadge_other": "{{count}} pending",
      "proposedUpdatesAriaLabel": "Proposed updates",
      "proposedUpdatesTitle": "Proposed Updates",
      "refresh": "Refresh",
      "refreshSessionTooltip": "Refresh session",
      "reject": "Reject",
      "rejectAll": "Reject All",
      "relationPlaceholder": "Relation type",
      "reviewerNotePlaceholder": "Add a note (optional)",
      "schemaLabel": "Schema",
      "schemaSidebarAriaLabel": "Graph schema",
      "sessionContextAriaLabel": "Session context",
      "sessionSummary": "{{total}} total · {{pending}} pending",
      "showSchemaPanelAriaLabel": "Show schema panel",
      "showSchemaTooltip": "Show schema panel",
      "stageAllApproveTooltip": "Stage approve for every pending item",
      "stageAllRejectTooltip": "Stage reject for every pending item",
      "stageFilteredApproveTooltip_one": "Stage approve for {{count}} visible item",
      "stageFilteredApproveTooltip_other": "Stage approve for {{count}} visible items",
      "stageFilteredRejectTooltip_one": "Stage reject for {{count}} visible item",
      "stageFilteredRejectTooltip_other": "Stage reject for {{count}} visible items",
      "stageModification": "Stage Modification",
      "stagedApprove": "Approve",
      "stagedCount_one": "{{count}} change staged",
      "stagedCount_other": "{{count}} changes staged",
      "stagedModify": "Modify",
      "stagedReject": "Reject",
      "unappliedCount_one": "{{count}} approved change not yet written",
      "unappliedCount_other": "{{count}} approved changes not yet written",
      "undo": "Undo",
      "undoAll": "Undo All",
      "undoAllTooltip": "Discard all staged decisions"
    },
    "graphApprovals": {
      "auditLog": "Audit Log",
      "auditTrailTitle": "Audit Trail",
      "backToGraphAriaLabel": "Back to graph",
      "columnAction": "Action",
      "columnActions": "Actions",
      "columnActor": "Actor",
      "columnChangeRun": "Change Run",
      "columnCommit": "Commit",
      "columnCreatedAt": "Created",
      "columnCreatedBy": "Created By",
      "columnMessage": "Message",
      "columnMode": "Mode",
      "columnPending": "Pending",
      "columnSource": "Source",
      "columnStatus": "Status",
      "columnTriplet": "Triplet",
      "columnUpdatedAt": "Updated",
      "columnVersion": "Version",
      "columnWhen": "When",
      "commitHistoryTitle": "Commit History",
      "commits": "Commits",
      "emptyAuditMessage": "No audit entries yet.",
      "emptyCommitsMessage": "No commits yet.",
      "emptyRunsMessage": "No change runs yet.",
      "exportAuditAriaLabel": "Export audit log as CSV",
      "exportCsv": "Export CSV",
      "filterAll": "All",
      "filterModeLabel": "Mode",
      "filterStatusLabel": "Status",
      "footnoteText": "Approved changes are written to the live graph. ",
      "hideAudit": "Hide Audit",
      "hideCommits": "Hide Commits",
      "missingTableIdMessage": "No graph table was specified.",
      "modeApprovalRequired": "Approval required",
      "modeBypassed": "Bypassed",
      "openLivePreview": "Open live preview",
      "openSession": "Open session",
      "pageSubtitle": "Review queue for {{name}}",
      "pageTitle": "Graph Approvals",
      "refresh": "Refresh",
      "review": "Review",
      "runCount_one": "{{count}} run",
      "runCount_other": "{{count}} runs",
      "searchAuditPlaceholder": "Search audit log…",
      "searchChangeRunsPlaceholder": "Search change runs…",
      "searchCommitsPlaceholder": "Search commits…",
      "statusApplied": "Applied",
      "statusAutoApplied": "Auto-applied",
      "statusPartiallyApplied": "Partially applied",
      "statusPending": "Pending",
      "statusRejected": "Rejected",
      "systemActor": "System",
      "unknownUser": "Unknown user",
      "wholeRun": "Whole run"
    },
    "graphTablePreview": {
      "addedInVersionLegend": "Added in v{{version}}",
      "alreadyThereLegend": "Already there",
      "askTheGraphDescription": "Ask a question in natural language and it will be turned into a graph query.",
      "askTheGraphTitle": "Ask the Graph",
      "back": "Back",
      "backToDataAriaLabel": "Back to data",
      "chatAssistantAriaLabel": "Graph chat assistant",
      "chatDisabledLabel": "Chat unavailable",
      "chatDisabledTooltip": "No LLM models are configured for this tenant, so graph chat is unavailable.",
      "chatInputPlaceholder": "Ask a question about this graph…",
      "chatWelcomeMessage": "Ask me a question about this graph and I'll query it for you.",
      "collapse": "Collapse",
      "collapseChatAriaLabel": "Collapse chat",
      "commitLegendAriaLabel": "Commit version legend",
      "commitOptionPlain": "v{{version}}{{whenSuffix}}",
      "commitOptionWithMessage": "v{{version}} — {{message}}{{whenSuffix}}",
      "commitVersionPlaceholder": "Select version",
      "couldNotBuildQueryMessage": "I couldn't turn that into a graph query. Try rephrasing your question.",
      "defaultGraphTitle": "Graph Preview",
      "expandChatAriaLabel": "Expand chat",
      "graphCanvasAriaLabel": "Graph canvas",
      "graphContextAriaLabel": "Graph context",
      "graphSchemaAriaLabel": "Graph schema",
      "highlightingMatchesMessage": "Highlighting {{nodesPart}} and {{relsPart}}.",
      "latestLiveOption": "Latest (live)",
      "matchedNodesPart_one": "{{count}} matching node",
      "matchedNodesPart_other": "{{count}} matching nodes",
      "matchedRelationshipsPart_one": "{{count}} matching relationship",
      "matchedRelationshipsPart_other": "{{count}} matching relationships",
      "missingTableIdMessage": "No graph table was specified.",
      "modelLabel": "Model",
      "modelLabelLoading": "Loading models…",
      "newestCommitMatchesLatestNotice": "Version {{version}} is the newest commit, so this view matches the live graph.",
      "noCommitStampsNotice": "This graph has no commit-version stamps, so version filtering can't be applied.",
      "noModelsConfiguredPlaceholder": "No models configured",
      "noNodesMatchedMessage": "No nodes matched your question.",
      "nothingToResetTooltip": "Nothing to reset",
      "reset": "Reset",
      "resetViewTooltip": "Reset to the full graph view",
      "schemaLabel": "Schema",
      "searchModelsPlaceholder": "Search models…",
      "selectModelPlaceholder": "Select a model",
      "send": "Send",
      "showSchemaPanelAriaLabel": "Show schema panel",
      "showSchemaTooltip": "Show schema panel",
      "statusAsOfVersion": "As of v{{version}}",
      "statusHighlighted": "Highlighted",
      "statusSample": "Sample",
      "thinking": "Thinking…",
      "unexpectedResponseMessage": "That query didn't return graph data. Try rephrasing your question.",
      "updatedGraphFallbackMessage": "Here's the updated graph.",
      "viewCommitVersionTooltip": "View a specific commit version",
      "wrongTableTypeError": "This table isn't a graph table.",
      "crossTenantDataUnavailable": "Data unavailable. Switch to this table's tenant to view the preview."
    },
    "graphSchemaPanel": {
      "collapseAriaLabel": "Collapse schema panel",
      "collapseTooltip": "Collapse schema panel",
      "defaultEngineName": "Graph database",
      "deselectAll": "Deselect all",
      "edgesLabel": "Edges",
      "emptyLabelTooltip": "No {{label}} nodes in this version",
      "engineLabel": "Engine",
      "graphDetailsTitle": "Graph Details",
      "labelCountTooltip_one": "{{count}} {{label}} node",
      "labelCountTooltip_other": "{{count}} {{label}} nodes",
      "labelsTitle": "Labels",
      "nodesLabel": "Nodes",
      "notAvailable": "N/A",
      "relationshipsTitle_one": "Relationships ({{count}})",
      "relationshipsTitle_other": "Relationships ({{count}})",
      "schemaTitle": "Schema",
      "selectAll": "Select all",
      "selectLabelsEmptyState": "Select at least one label to see its relationships.",
      "snapshotLabel": "Snapshot"
    },
    "graphWebglCanvas": {
      "layingOutGraphAriaLabel": "Laying out graph…"
    },
    "neo4jGraphView": {
      "canvasControlsAriaLabel": "Canvas controls",
      "clearSearchAriaLabel": "Clear search",
      "closeDetailsAriaLabel": "Close details",
      "closeDetailsKeepHighlightTooltip": "Close (keeps highlight)",
      "closeDetailsTooltip": "Close",
      "fitToViewTooltip": "Fit to view",
      "focusHintAfter": "to reset focus.",
      "focusHintBefore": "Focused on one node — use",
      "genericNodeLabel": "Node",
      "hiddenPropertiesFoot_one": "{{count}} more property not shown",
      "hiddenPropertiesFoot_other": "{{count}} more properties not shown",
      "lodHintDefault": "Zoom in for detail",
      "noMatchingNodes": "No matching nodes",
      "nodeDetailsAriaLabel": "Details for {{name}}",
      "relationshipDetailsAriaLabel": "Relationship details",
      "resetFocusTooltip": "Reset focus",
      "searchAriaLabel": "Search nodes",
      "searchPlaceholder": "Search nodes…",
      "searchingEllipsis": "Searching…",
      "zoomInTooltip": "Zoom in",
      "zoomOutTooltip": "Zoom out"
    },
    "vectorTab": {
      "actionDelete": "Delete",
      "actionEdit": "Edit",
      "actionPreviewData": "Preview Data",
      "actionRemoveAsDefault": "Remove as Default",
      "actionSetAsDefault": "Set as Default",
      "actionSync": "Sync",
      "actionVectorSearch": "Vector Search",
      "actionViewDetails": "View Details",
      "addVectorDbTableButton": "Add Vector DB Table",
      "allLabel": "All",
      "andOthersLabel_one": "{{names}} and {{count}} other",
      "andOthersLabel_other": "{{names}} and {{count}} others",
      "bulkActionDeleteSelected": "Delete Selected",
      "bulkActionSyncMetadata": "Sync Metadata",
      "bulkDeletePartialWarning": "Deleted {{deleted}}, skipped {{skipped}}: {{errors}}",
      "bulkDeleteSuccessToast_one": "Deleted {{count}} table",
      "bulkDeleteSuccessToast_other": "Deleted {{count}} tables",
      "bulkSyncStartedRequeuedToast_one": "Requeued metadata sync for {{count}} table",
      "bulkSyncStartedRequeuedToast_other": "Requeued metadata sync for {{count}} tables",
      "bulkSyncStartedToast_one": "Started metadata sync for {{count}} table",
      "bulkSyncStartedToast_other": "Started metadata sync for {{count}} tables",
      "clearDefaultErrorToast": "Failed to remove {{name}} as default",
      "collectionViewTooltip": "Collection view",
      "columnActions": "Actions",
      "columnCreator": "Creator",
      "columnDatabase": "Database",
      "columnEmbeddingModel": "Embedding Model",
      "columnIntrospection": "Introspection",
      "columnLogs": "Logs",
      "columnName": "Name",
      "columnStatus": "Status",
      "columnVectors": "Vectors",
      "databaseViewTooltip": "Database view",
      "defaultBadgeTooltip": "Default table",
      "defaultSchemaLabel": "default",
      "deleteConfirmLabel": "Delete",
      "deleteNamespaceConfirmMessage_one": "Are you sure you want to delete the {{schema}} namespace and its {{count}} registered table? This removes {{brand}} metadata only and cannot be undone.",
      "deleteNamespaceConfirmMessage_other": "Are you sure you want to delete the {{schema}} namespace and its {{count}} registered tables? This removes {{brand}} metadata only and cannot be undone.",
      "deleteNamespacePartialWarning": "Deleted {{deleted}} of {{schemaCount}} namespaces, skipped {{skipped}}",
      "deleteNamespaceSuccessToast_one": "Deleted namespace ({{count}} table removed)",
      "deleteNamespaceSuccessToast_other": "Deleted namespace ({{count}} tables removed)",
      "deleteNamespaceSuccessToastNamed_one": "Deleted namespace {{schema}} ({{count}} table removed)",
      "deleteNamespaceSuccessToastNamed_other": "Deleted namespace {{schema}} ({{count}} tables removed)",
      "deleteNamespaceTitle": "Delete Namespace",
      "deleteNamespacesConfirmMessage_one": "Are you sure you want to delete {{namespaceCount}} namespaces and their {{count}} registered table? This removes {{brand}} metadata only and cannot be undone.",
      "deleteNamespacesConfirmMessage_other": "Are you sure you want to delete {{namespaceCount}} namespaces and their {{count}} registered tables? This removes {{brand}} metadata only and cannot be undone.",
      "deleteNamespacesCountLabel_one": "Delete {{count}} Namespace",
      "deleteNamespacesCountLabel_other": "Delete {{count}} Namespaces",
      "deleteNamespacesSuccessToast_one": "Deleted {{schemaCount}} namespaces ({{count}} table removed)",
      "deleteNamespacesSuccessToast_other": "Deleted {{schemaCount}} namespaces ({{count}} tables removed)",
      "deleteNamespacesTitle": "Delete Namespaces",
      "deleteSelectedTablesConfirmMessage_one": "Are you sure you want to delete {{count}} selected table? This action cannot be undone.",
      "deleteSelectedTablesConfirmMessage_other": "Are you sure you want to delete {{count}} selected tables? This action cannot be undone.",
      "deleteSelectedTablesTitle": "Delete Selected Tables",
      "deleteTableConfirmMessage": "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "deleteTableConfirmTitle": "Delete Table",
      "deleteTablesCountLabel_one": "Delete {{count}} Table",
      "deleteTablesCountLabel_other": "Delete {{count}} Tables",
      "deletingLabel": "Deleting…",
      "favoritesLabel": "Favorites",
      "filterAllCreatorsPlaceholder": "All Creators",
      "filterAllEnginesPlaceholder": "All Engines",
      "filterCreatorLabel": "Creator",
      "filterEngineLabel": "Engine",
      "namespacesTitle": "Namespaces",
      "noConnectorsYet": "No connectors yet",
      "notConfigured": "Not Configured",
      "setDefaultErrorToast": "Failed to set {{name}} as default",
      "syncMetadataErrorToast": "Failed to sync metadata for {{name}}",
      "syncStatus": {
        "active": "Active",
        "failed": "Failed",
        "inactive": "Inactive",
        "queued": "Queued",
        "running": "Running",
        "synced": "Synced"
      },
      "unknownConnectorType": "Unknown",
      "unknownCreator": "Unknown",
      "vectorDbExplorerAriaLabel": "Vector database explorer",
      "vectorTablesLeafTitle": "Vector Tables",
      "vectorTablesLeafTitleWithSchema": "Vector Tables — {{schema}}",
      "viewLink": "View",
      "viewSyncLogsTooltip": "View sync logs",
      "resourceVectorDatabases": "vector databases",
      "resourceVectorDatabase": "vector database"
    },
    "vectorSearchModal": {
      "advancedRagLabel": "Advanced RAG",
      "closeDialogAriaLabel": "Close",
      "contentLabel": "Content",
      "coverageLabel": "Coverage",
      "embeddingModelLabel": "Embedding Model",
      "enhancementsLabel": "Enhancements",
      "foundResultsPrefix": "Found",
      "hideButton": "Hide",
      "hydeEnhancementLabel": "HyDE (Hypothetical Document Embeddings)",
      "idFallbackLabel": "Result {{id}}",
      "latencyMs": "{{ms}}ms",
      "loadingOption": "Loading…",
      "metadataLabel": "Metadata",
      "missingAspectsLabel": "Missing aspects: {{aspects}}",
      "modelDefaultLabel": "{{name}} (default)",
      "modelLabel": "Model: {{name}}",
      "modelsWordBold": "models",
      "multiQueryExpansionLabel": "Multi-Query Expansion",
      "noEmbeddingModelsOption": "No embedding models available",
      "noModelRegisteredBody": "To run vector search on this table, register one or more",
      "noModelRegisteredBold": "No embedding model registered.",
      "noModelRegisteredSuffix": "for embeddings, or switch to Advanced RAG.",
      "noResultsBasicHint": "Try a different search query or check your embedding model.",
      "noResultsFoundTitle": "No Results Found",
      "noResultsRagHint": "Try rephrasing your query or adjusting the RAG strategy.",
      "qualityLabel": "Quality:",
      "ragSearchButton": "RAG Search",
      "ragSearchingButton": "Searching…",
      "ragStrategyConfigTitle": "RAG Strategy Configuration",
      "registerModelFirstTooltip": "Register an embedding model first",
      "relevanceLabel": "Relevance:",
      "rerankingLabel": "Reranking",
      "resultFallbackLabel": "Result {{index}}",
      "resultsInLatencyMiddle": "results in",
      "resultsLabel": "Results:",
      "resultsSuffix": "results",
      "searchButton": "Search",
      "searchFailedTitle": "Search Failed",
      "searchModelsPlaceholder": "Search models…",
      "searchPlaceholder": "Enter your search query…",
      "searchingButton": "Searching…",
      "selfCorrectedBadge_one": "Self-corrected ({{count}} attempt)",
      "selfCorrectedBadge_other": "Self-corrected ({{count}} attempts)",
      "selfRagCorrectionLabel": "Self-RAG Correction",
      "semanticSearchBody": "Enter a query above to search this table's vector embeddings.",
      "semanticSearchTitle": "Semantic Search",
      "settingsButton": "Settings",
      "strategyAutoOption": "Auto",
      "strategyDecompositionOption": "Decomposition",
      "strategyDescriptionAuto": "Automatically selects the best retrieval strategy for your query.",
      "strategyDescriptionDecomposition": "Breaks complex queries into sub-questions and retrieves for each.",
      "strategyDescriptionDirect": "Searches directly using the raw query text.",
      "strategyDescriptionHyde": "Generates a hypothetical answer first, then searches using its embedding.",
      "strategyDescriptionMultiQuery": "Generates multiple query variations to broaden retrieval coverage.",
      "strategyDirectOption": "Direct",
      "strategyHydeOption": "HyDE",
      "strategyLabel": "Strategy",
      "strategyMultiQueryOption": "Multi-Query",
      "title": "Vector Search",
      "useDefaultOption": "Use default"
    },
    "storageTab": {
      "actionDelete": "Delete",
      "actionExport": "Export",
      "actionPreviewFiles": "Preview Files",
      "actionSetAsDefault": "Set as Default",
      "actionSync": "Sync",
      "actionSyncing": "Syncing…",
      "actionViewDetails": "View Details",
      "addStorageButton": "Add Storage",
      "allLabel": "All",
      "columnActions": "Actions",
      "columnConnector": "Connector",
      "columnContainer": "Container",
      "columnCreated": "Created",
      "columnFolder": "Folder",
      "columnLogs": "Logs",
      "columnStatus": "Status",
      "columnUpdated": "Updated",
      "defaultBadgeTooltip": "Default folder",
      "defaultBucketLabel": "default",
      "defaultConnectorName": "Unknown Connector",
      "deleteConfirmLabel": "Delete",
      "deleteConfirmMessage": "Are you sure you want to delete {{name}}? This action cannot be undone.",
      "deleteConfirmTitle": "Delete Storage Folder",
      "emptyMessage": "No storage folders found",
      "exportSelectedAction": "Export Selected",
      "favoritesLabel": "Favorites",
      "filterAllCreatorsPlaceholder": "All Creators",
      "filterAllTypesPlaceholder": "All Types",
      "filterCreatorLabel": "Creator",
      "filterStorageTypeLabel": "Storage Type",
      "foldersLeafTitle": "Folders",
      "foldersLeafTitleWithBucket": "Folders — {{bucket}}",
      "listViewTooltip": "List view",
      "noConnectorsYet": "No connectors yet",
      "pendingBadge": "Pending",
      "setDefaultErrorToast": "Failed to set {{name}} as default",
      "setDefaultSuccessToast": "'{{name}}' set as default storage folder. Sync separately to refresh metadata (requires storage list permission).",
      "syncSuccessToast": "'{{name}}' metadata synced.",
      "syncErrorToast": "Failed to sync folder",
      "splitViewTooltip": "Split view",
      "statusActive": "Active",
      "statusApproved": "Approved",
      "statusRequested": "Requested",
      "statusUnknown": "Unknown",
      "storageExplorerAriaLabel": "Storage explorer",
      "unknownConnectorType": "Unknown",
      "viewLink": "View",
      "viewSyncLogsTooltip": "View sync logs"
    },
    "storageViewModal": {
      "auditInformationSectionTitle": "Audit Information",
      "basicInformationSectionTitle": "Basic Information",
      "closeButton": "Close",
      "closeDialogAriaLabel": "Close",
      "errorInformationSectionTitle": "Error Information",
      "fieldBucketName": "Bucket Name",
      "fieldConnector": "Connector",
      "fieldCreatedAt": "Created At",
      "fieldCreatedBy": "Created By",
      "fieldErrorMessage": "Error Message",
      "fieldFileCount": "File Count",
      "fieldFolderPath": "Folder Path",
      "fieldId": "ID",
      "fieldStatus": "Status",
      "fieldTotalSize": "Total Size",
      "fieldUpdatedAt": "Updated At",
      "fieldUpdatedBy": "Updated By",
      "metadataSectionTitle": "Metadata",
      "noErrors": "No errors",
      "notAvailable": "N/A",
      "status": {
        "active": "Active",
        "error": "Error",
        "syncing": "Syncing",
        "unknown": "Unknown"
      },
      "storageInformationSectionTitle": "Storage Information",
      "title": "Storage Folder Details"
    },
    "storageFolderPreview": {
      "actionsTooltip": "Actions",
      "cancelButton": "Cancel",
      "clearSearchAriaLabel": "Clear search",
      "clearSelectionAriaLabel": "Clear selection",
      "closeDialogAriaLabel": "Close",
      "columnActions": "Actions",
      "columnModified": "Modified",
      "columnName": "Name",
      "columnSize": "Size",
      "columnType": "Type",
      "downloadErrorToast": "Failed to download file",
      "downloadResultAllFailed": "None of the selected files could be downloaded.",
      "downloadResultAllSuccess": "All {{count}} files downloaded successfully.",
      "downloadResultOk": "OK",
      "downloadResultPartial": "{{successCount}} of {{total}} files downloaded successfully. Failed: {{failedNames}}",
      "downloadResultTitleFailed": "Download failed",
      "downloadResultTitlePartial": "Download incomplete",
      "downloadResultTitleSuccess": "Download complete",
      "downloadSelectedButton": "Download Selected",
      "downloadSelectedTooltip": "Download selected files",
      "downloadingSelectedButton": "Downloading…",
      "emptySearchState": "No files match your search",
      "emptyState": "This folder has no files",
      "exportAction": "Download",
      "firstPageTooltip": "First page",
      "lastPageTooltip": "Last page",
      "nextPageTooltip": "Next page",
      "openingFileLabel": "Opening file…",
      "paginationInfo": "Showing {{from}}–{{to}} of {{total}}",
      "previousPageTooltip": "Previous page",
      "searchPlaceholder": "Search files…",
      "selectAllAriaLabel": "Select all files",
      "selectFileAriaLabel": "Select {{name}}",
      "selectedCount": "{{count}} selected",
      "selectionLimitWarning": "You can only select up to 10 files at a time.",
      "syncButtonLabel": "Sync",
      "syncButtonTooltip": "Sync this folder's files",
      "syncingButtonLabel": "Syncing…",
      "viewAction": "Preview"
    },
    "storageFilePreview": {
      "closeDialogAriaLabel": "Close",
      "downloadButton": "Download",
      "downloadErrorToast": "Failed to download file",
      "emptyTable": "No rows to display",
      "imagePreviewAlt": "Image preview",
      "loadErrorToast": "Failed to preview file",
      "loadingDocument": "Loading document…",
      "loadingPresentation": "Loading presentation…",
      "nullValueLabel": "NULL",
      "pdfPreviewTitle": "PDF preview",
      "pptxPreviewTitle": "PowerPoint preview",
      "rowsUnit": "rows",
      "textPreviewAriaLabel": "File contents",
      "tryAgainButton": "Try again",
      "unableToLoadTitle": "Unable to preview file",
      "unsupportedHint": "This file type cannot be shown in the browser. Download the file to open it.",
      "unsupportedTitle": "Preview not available"
    },
    "groupedStorageView": {
      "bucketPathTooltip": "{{bucket}}/{{path}}",
      "createdTooltip": "Created",
      "emptyState": "No storage folders found",
      "emptyStateHint": "Try a different search term",
      "fileCount_one": "{{count}} file",
      "fileCount_other": "{{count}} files",
      "folderCount_one": "{{count}} folder",
      "folderCount_other": "{{count}} folders",
      "loadingFolders": "Loading folders…",
      "unknownConnectorName": "Unknown Connector",
      "updatedTooltip": "Updated"
    },
    "metadataSyncLogsModal": {
      "bulkJobLabel": "bulk job",
      "closeAriaLabel": "Close",
      "collapseDetailAriaLabel": "Collapse details",
      "columnMessage": "Message",
      "columnStatus": "Status",
      "columnWhen": "When",
      "emptyState": "No sync logs found",
      "entryCount_one": "{{count}} entry",
      "entryCount_other": "{{count}} entries",
      "expandDetailAriaLabel": "Expand details",
      "loadingLogs": "Loading logs…",
      "title": "Metadata Sync Logs",
      "triggerLabel": "trigger:"
    },
    "bulkMetadataSyncModal": {
      "closeAriaLabel": "Close",
      "columnDetail": "Detail",
      "columnStatus": "Status",
      "columnTable": "Table",
      "jobLabel": "Job",
      "loadingStatus": "Loading sync status…",
      "noJobData": "No job data available",
      "requeuedToast_one": "Requeued {{count}} item for retry",
      "requeuedToast_other": "Requeued {{count}} items for retry",
      "retryFailedButton_one": "Retry {{count}} Failed",
      "retryFailedButton_other": "Retry {{count}} Failed",
      "title": "Bulk Metadata Sync"
    },
    "tableDataPreview": {
      "loadErrorToast": "Failed to load table data",
      "nullValueLabel": "NULL",
      "columnEdit": "Edit",
      "editGoldenAnswerAriaLabel": "Edit golden answer",
      "csvExportedToast_other": "Exported {{count}} rows to CSV",
      "jsonExportedToast_other": "Exported {{count}} rows to JSON",
      "previewNotAvailable": "Preview not available for this data source",
      "vertexAiDataStoreHint": "This table is backed by a Vertex AI Search data store. Preview data by querying the data store directly.",
      "vertexAiVectorSearchHint": "This table is backed by a Vertex AI Vector Search index. Preview data by running a vector search query.",
      "closeDialogAriaLabel": "Close",
      "unableToLoadTitle": "Unable to load data",
      "dataUnavailableTitle": "Data unavailable",
      "crossTenantSwitchHint": "Switch to this table's tenant to view the preview.",
      "syncingButton": "Syncing…",
      "refreshMetadataButton": "Refresh metadata",
      "tryAgainButton": "Try again",
      "documentsUnit": "documents",
      "rowsUnit": "rows",
      "elasticsearchSearchPlaceholder": "Search using Lucene query syntax…",
      "searchPlaceholder": "Search…",
      "clearSearchAriaLabel": "Clear search",
      "luceneQueryHintTitle": "Supports Lucene query syntax, e.g. field:value AND other:value",
      "paginationFullTextSearchHint": "Full-text search is applied across all columns",
      "tableViewTitle": "Table view",
      "tableTab": "Table",
      "graphViewTitle": "Graph view",
      "graphTab": "Graph",
      "documentViewJsonTitle": "Document view (JSON)",
      "documentsTab": "Documents",
      "tabularViewTitle": "Tabular view",
      "exportJsonButton": "Export JSON",
      "exportingButton": "Exporting…",
      "exportCsvButton": "Export CSV",
      "documentFallbackLabel": "Document {{index}}",
      "statusLabel": "Status: {{status}}",
      "hideJsonButton": "Hide JSON",
      "showJsonButton": "Show JSON",
      "noPreviewFieldsHint": "No preview fields configured for this document.",
      "pageOfLabel": "Page {{page}} of {{totalPages}}",
      "pageSizeLabel": "Rows per page",
      "previousButton": "Previous",
      "nextButton": "Next",
      "noDataFoundEmptyMessage": "No data found"
    },
    "ontology": {
      "retrievalConfigPanel": {
        "strategyAuto": "Auto",
        "strategyAutoDescription": "Automatically choose the best retrieval strategy based on the query",
        "strategyVector": "Vector search",
        "strategyVectorDescription": "Retrieve results using semantic similarity search over embeddings",
        "strategySql": "SQL",
        "strategySqlDescription": "Retrieve results by generating and running SQL queries against the table",
        "strategyHybrid": "Hybrid",
        "strategyHybridDescription": "Combine vector search and keyword/SQL search for more accurate results",
        "fusionMethodRrf": "Reciprocal rank fusion",
        "fusionMethodRrfDescription": "Combine ranked result lists using reciprocal rank fusion",
        "fusionMethodWeighted": "Weighted sum",
        "fusionMethodWeightedDescription": "Combine scores using a weighted sum of vector and keyword results",
        "fusionMethodCascade": "Cascade",
        "fusionMethodCascadeDescription": "Run keyword search first, then re-rank with vector search",
        "distanceMetricCosine": "Cosine",
        "distanceMetricEuclidean": "Euclidean",
        "distanceMetricDotProduct": "Dot product",
        "title": "Retrieval configuration",
        "resetToDefaultsTitle": "Reset to defaults",
        "resetButton": "Reset",
        "defaultStrategyLabel": "Default retrieval strategy",
        "vectorSearchSettingsLabel": "Vector search settings",
        "idColumnLabel": "ID column",
        "autoDetectOption": "Auto-detect",
        "contentColumnLabel": "Content column",
        "embeddingColumnLabel": "Embedding column",
        "distanceMetricLabel": "Distance metric",
        "hybridFusionSettingsLabel": "Hybrid fusion settings",
        "fusionMethodLabel": "Fusion method",
        "weightDistributionLabel": "Weight distribution",
        "vectorSliderLabel": "Vector weight",
        "keywordSliderLabel": "Keyword weight",
        "sqlSettingsLabel": "SQL settings",
        "maxRowsLabel": "Maximum rows returned",
        "enableFullTextSearchLabel": "Enable full-text search",
        "rerankingLabel": "Reranking",
        "enableCrossEncoderRerankingLabel": "Enable cross-encoder reranking",
        "rerankingModelLabel": "Reranking model",
        "loadingModelsOption": "Loading models…",
        "noRegisteredModelsOption": "No registered models",
        "rerankTopKLabel": "Rerank top K",
        "infoCardText": "These settings control how this table is retrieved during RAG queries. Changes apply the next time this table is queried."
      },
      "columnEditor": {
        "semanticTypeId": "Identifier",
        "semanticTypeIdDescription": "Uniquely identifies a record (e.g. primary key)",
        "semanticTypeEntity": "Entity",
        "semanticTypeEntityDescription": "Refers to a named person, place, or thing",
        "semanticTypeMetric": "Metric",
        "semanticTypeMetricDescription": "A numeric value used for aggregation or measurement",
        "semanticTypeDimension": "Dimension",
        "semanticTypeDimensionDescription": "A categorical attribute used for grouping or filtering",
        "semanticTypeTimestamp": "Timestamp",
        "semanticTypeTimestampDescription": "A date or time value",
        "semanticTypeText": "Text",
        "semanticTypeTextDescription": "Free-form textual content",
        "closeEditorTitle": "Close editor",
        "businessNameLabel": "Business name",
        "businessNameHint": "A human-friendly name for this column",
        "businessNamePlaceholder": "e.g. Customer Name",
        "descriptionLabel": "Description",
        "descriptionHint": "Explain what this column represents",
        "descriptionPlaceholder": "e.g. The full legal name of the customer",
        "semanticTypeLabel": "Semantic type",
        "semanticTypeHint": "Classify what kind of data this column holds",
        "exampleValuesLabel": "Example values",
        "exampleValuesHint": "Sample values that help others understand this column",
        "addExamplePlaceholder": "Add an example value",
        "constraintsLabel": "Constraints",
        "constraintsHint": "Business rules or validation constraints for this column",
        "constraintsPlaceholder": "e.g. Must not be empty",
        "relationshipsLabel": "Relationships",
        "relationshipsHint": "Other tables or columns this column relates to",
        "tableNamePlaceholder": "Table name",
        "columnNamePlaceholder": "Column name",
        "relationshipTypeForeignKey": "Foreign key",
        "relationshipTypeReference": "Reference",
        "addRelationshipButton": "Add relationship",
        "searchSettingsLabel": "Search settings",
        "searchSettingsHint": "Control how this column is used in search and retrieval",
        "searchableLabel": "Searchable",
        "searchableHint": "Include this column in full-text and keyword search",
        "embedForVectorSearchLabel": "Embed for vector search",
        "embedForVectorSearchHint": "Generate embeddings for this column to support semantic search"
      },
      "tableDescriptionEditor": {
        "tablePurposeLabel": "Table purpose",
        "tablePurposeHelp": "Describe what this table is used for",
        "tablePurposePlaceholder": "e.g. Stores customer order history for reporting",
        "businessContextLabel": "Business context",
        "businessContextHelp": "Explain the business context and how this table fits into the wider data model",
        "businessContextPlaceholder": "e.g. Used by the sales team to track order fulfillment",
        "sampleQuestionsLabel": "Sample questions",
        "sampleQuestionsHelp": "Example questions this table can help answer",
        "removeQuestionTitle": "Remove question",
        "addQuestionPlaceholder": "Add a sample question",
        "addQuestionTitle": "Add question",
        "addButton": "Add",
        "tipsTitle": "Tips",
        "tip1": "Be specific about what the table contains and who uses it.",
        "tip2": "Include business terms that users might search for.",
        "tip3": "Add sample questions to help the retrieval model match relevant queries.",
        "tip4": "Keep descriptions concise but informative."
      },
      "schemaVisualizer": {
        "semanticTypeId": "Identifier",
        "semanticTypeTimestamp": "Timestamp",
        "semanticTypeMetric": "Metric",
        "semanticTypeDimension": "Dimension",
        "semanticTypeEntity": "Entity",
        "semanticTypeText": "Text",
        "groupPrimaryKeys": "Primary keys",
        "groupForeignKeys": "Foreign keys",
        "groupTimestamps": "Timestamps",
        "groupMetrics": "Metrics",
        "groupDimensions": "Dimensions",
        "groupOther": "Other",
        "subtitle": "Visual overview of table columns and their relationships",
        "columnCount": "{{count}} column",
        "columnCount_other": "{{count}} columns",
        "hasOntologyLegend": "Has ontology defined",
        "foreignKeyLegend": "Foreign key"
      }
    },
    "tableOntologyPage": {
      "noTableIdError": "No table ID was provided",
      "saveSuccessToast": "Ontology saved successfully",
      "saveErrorToast": "Failed to save ontology: {{message}}",
      "unsavedChangesConfirm": "You have unsaved changes. Are you sure you want to leave?",
      "loadingMessage": "Loading table ontology…",
      "schemaEditorUnavailableTitle": "Schema editor unavailable",
      "schemaEditorUnavailableMessage": "The schema editor is not available for this table's connector type.",
      "failedToLoadTitle": "Failed to load table",
      "tableNotFoundMessage": "The requested table could not be found.",
      "goBack": "Go back",
      "backToKnowledgeTooltip": "Back to Knowledge",
      "breadcrumbKnowledge": "Knowledge",
      "breadcrumbTables": "Tables",
      "breadcrumbOntology": "Ontology",
      "vectorBadge": "Vector",
      "unsavedChangesBadge": "Unsaved changes",
      "resetToSavedTooltip": "Reset to last saved version",
      "reset": "Reset",
      "saving": "Saving…",
      "saveChanges": "Save changes",
      "schemaPanelTitle": "Schema",
      "databaseLabel": "Database",
      "schemaLabel": "Schema",
      "tableLabel": "Table",
      "rowsLabel": "Rows",
      "embeddingModelTitle": "Embedding model",
      "loadingModels": "Loading models…",
      "noEmbeddingModelsWarning": "No embedding models are registered. Register one to enable vector search for this table.",
      "selectModelOption": "Select a model",
      "modelOptionDefaultLabel": "{{name}} (default)",
      "modelOptionLabel": "{{name}}",
      "noModelSelectedWarning": "No embedding model selected. Vector search will be unavailable for this table.",
      "columnsHeader": "Columns",
      "hasOntologyDefinedTooltip": "Ontology defined for this column",
      "tabDescription": "Description",
      "tabRetrieval": "Retrieval",
      "tabTest": "Test",
      "queryTestingTitle": "Query testing",
      "queryTestingDescription": "Test how queries are retrieved against this table's configuration.",
      "comingSoon": "Coming soon"
    },
    "mongoCompassDocumentView": {
      "documentViewTitle": "Document view",
      "documentsTab": "Documents",
      "tabularViewTitle": "Tabular view",
      "tableTab": "Table",
      "exportDataButton": "Export data",
      "closeAriaLabel": "Close",
      "filterLabel": "Filter",
      "filterPlaceholder": "e.g. { status: \"active\" }",
      "filterInputAriaLabel": "Filter query",
      "clearFilterAriaLabel": "Clear filter",
      "applyFilterTitle": "Apply filter",
      "findButton": "Find",
      "queryHint": "Enter a MongoDB query filter as JSON",
      "documentCountLabel": "{{count}} document",
      "documentCountLabel_other": "{{count}} documents",
      "zeroResults": "No results",
      "pageRangeHint": "{{from}}–{{to}} of {{total}}",
      "documentFallbackLabel": "Document {{index}}",
      "hideDocumentAriaLabel": "Hide document",
      "showDocumentAriaLabel": "Show document",
      "skipLimitLabel": "Skip: {{skip}}, Limit: {{limit}}",
      "pageSizeLabel": "Page size",
      "pageSizeSelectAriaLabel": "Select page size",
      "previousButton": "Previous",
      "nextButton": "Next"
    }
  },
  "accessRequests": {
    "manageAccessTitle": "Manage {{assetLabel}} Access",
    "assetTypeLabels": {
      "models": "Models",
      "tools": "Tools",
      "knowledge": "Knowledge",
      "storage": "Storage",
      "skills": "Skills",
      "orchestrators": "Orchestrators",
      "data_models": "Data Models",
      "default": "Assets"
    },
    "statusLabels": {
      "requested": "Pending",
      "approved": "Approved",
      "open": "Revoked"
    },
    "loadingRequests": "Loading access requests...",
    "clearSearch": "Clear search",
    "emptyStateAll": "No access requests for {{assetType}}.",
    "emptyStateFiltered": "No {{status}} access requests for {{assetType}}.",
    "selectedCount": "{{count}} selected",
    "selectAll": "Select All",
    "deselectAll": "Deselect All",
    "approveSelected": "Approve Selected ({{count}})",
    "rejectSelected": "Reject Selected ({{count}})",
    "columnAssetName": "Asset Name",
    "columnProject": "Project",
    "columnRequestedBy": "Requested By",
    "columnStatus": "Status",
    "columnCreated": "Created",
    "columnLastUpdated": "Last Updated",
    "columnActions": "Actions",
    "approve": "Approve",
    "reject": "Reject",
    "reApprove": "Re-approve",
    "revokeAccess": "Revoke access",
    "rowsPerPage": "Rows per page:",
    "showingRange": "Showing {{start}}-{{end}} of {{total}}",
    "goToFirstPage": "Go to first page",
    "goToPreviousPage": "Go to previous page",
    "goToPage": "Go to page {{page}}",
    "goToNextPage": "Go to next page",
    "goToLastPage": "Go to last page",
    "firstPage": "First page",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "lastPage": "Last page",
    "endOfTableReached": "End of table reached",
    "statusFilterLabel": "Status",
    "statusFilterPlaceholder": "Status",
    "projectFilterLabel": "Project",
    "projectFilterPlaceholder": "Project",
    "requestedByFilterLabel": "Requested By",
    "requestedByFilterPlaceholder": "Requested By",
    "bulkApprovePartial": "Approved {{processed}}; {{skipped}} failed: {{errors}}",
    "bulkRejectPartial": "Rejected {{processed}}; {{skipped}} failed: {{errors}}"
  },
  "skills": {
    "title": "Skills",
    "subtitle": "Skills are modular instruction packages that enhance agent capabilities.",
    "list": {
      "columns": {
        "name": "Skill Name",
        "category": "Category",
        "type": "Type",
        "model": "Model",
        "visibility": "Visibility",
        "version": "Version",
        "access": "Access",
        "updated": "Updated",
        "actions": "Actions"
      },
      "actions": {
        "view": "View",
        "edit": "Edit",
        "delete": "Delete",
        "export": "Export",
        "clone": "Clone to Project",
        "manageAccess": "Manage Access",
        "exportSelected": "Export Selected",
        "deleteSelected": "Delete Selected"
      },
      "badges": {
        "builtin": "Built-in",
        "platform": "Platform",
        "allModels": "All models"
      },
      "bulkDelete": {
        "title": "Delete Selected Skills",
        "noSelection": "No skills selected",
        "cannotDeleteBuiltin": "Cannot delete built-in platform skills",
        "skippedBuiltin": "{{count}} built-in skill(s) will be skipped.",
        "success": "Deleted {{count}} skill(s) successfully",
        "partial": "Deleted {{deleted}} skill(s), {{skipped}} failed: {{errors}}",
        "error": "Failed to delete skills"
      }
    },
    "categories": {
      "data_processing": "Data Processing",
      "data_analysis": "Data Analysis",
      "reasoning": "Reasoning",
      "code_generation": "Code Generation",
      "document_analysis": "Document Analysis",
      "web_interaction": "Web Interaction",
      "communication": "Communication",
      "research": "Research",
      "automation": "Automation",
      "custom": "Custom"
    },
    "types": {
      "behavioral": "Behavioral",
      "procedural": "Procedural",
      "knowledge": "Knowledge",
      "guardrail": "Guardrail",
      "custom": "Custom"
    },
    "visibility": {
      "project": "Project",
      "tenant": "Organization",
      "public": "Platform"
    },
    "filters": {
      "category": "Category",
      "type": "Type",
      "visibility": "Visibility",
      "project": "Project",
      "all": "All",
      "favorites": "Favorites"
    },
    "newSkill": "New Skill",
    "loading": "Loading skills...",
    "empty": {
      "message": "No skills found. Create your first skill to enhance agent capabilities."
    },
    "delete": {
      "title": "Delete Skill",
      "message": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone.",
      "bulkMessage": "Are you sure you want to delete {{count}} skill(s)? This action cannot be undone.",
      "bulkConfirm": "Delete {{count}} Skill(s)",
      "bulkDepsOthers": "{{names}} and {{count}} others"
    },
    "messages": {
      "dependencyCheckFailed": "Failed to check skill dependencies",
      "deleteFailed": "Failed to delete skill"
    },
    "edit": {
      "subtitle": {
        "new": "Create a modular capability",
        "readonly": "Skill configuration (Read Only)",
        "edit": "Edit skill configuration"
      },
      "sidebar": {
        "settings": "Skill Settings",
        "tags": "Tags",
        "loadingQuota": "Loading quota..."
      },
      "placeholders": {
        "name": "Skill name",
        "description": "Brief description of what this skill does",
        "instructions": "# Skill Instructions\nDescribe the specific capability this skill provides.\n\n## Core Rules\n1. Define how the agent should behave\n2. List step-by-step procedures\n3. Specify any constraints\n\n## Examples\nProvide examples of expected output...",
        "project": "Select Project",
        "modelAgnostic": "Model-agnostic (all models)"
      },
      "hints": {
        "targetModel": "Optionally tag this skill for a specific model. Untagged skills are compatible with all models.",
        "visibilityProject": "Skills available for selected project",
        "visibilityPlatform": "Skills available for all projects via approval workflow"
      },
      "editor": {
        "instructions": "Instructions (SKILL.md)",
        "markdownSupported": "Markdown supported",
        "noInstructions": "No instructions to preview yet."
      },
      "header": {
        "quotaExceeded": "Skill quota exceeded",
        "createSkill": "Create Skill",
        "saveChanges": "Save Changes"
      }
    }
  },
  "agentAutoTune": {
    "meta": {
      "breadcrumb": "Breadcrumb",
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Auto-tune Runs List",
      "metaDashboard": "Meta Dashboard"
    },
    "compare": {
      "phaseStep": "Phase / step",
      "score": "Score",
      "metric": "Metric",
      "baselineScore": "Baseline Score",
      "optimizedScore": "Optimized Score",
      "improvementPct": "Improvement %",
      "holdoutScore": "Holdout Score",
      "costUsd": "Cost (USD)",
      "iterations": "Iterations",
      "nodesOptimized": "Nodes Optimized",
      "nodesTotal": "Nodes Total",
      "version": "Version",
      "node": "Node",
      "loadingSessions": "Loading sessions for comparison...",
      "selectSessions": "Select at least 2 sessions to compare.",
      "backToRuns": "Back to Auto-Tune Runs",
      "runComparisonTitle": "Run Comparison",
      "comparingSessions": "Comparing {{count}} auto-tune sessions",
      "summaryComparison": "Summary Comparison",
      "noDataToCompare": "No data to compare",
      "scoreTrajectoryOverlay": "Score trajectory overlay",
      "comparingRuns": "comparing runs",
      "chartExplainer1": "not for node-level attribution. Series are padded with gaps so unequal",
      "chartExplainer2": "trajectory lengths align by index.",
      "labelsMatch": "Labels match the longest session’s",
      "phasesBaseline": "phases so Baseline /",
      "validationLinesUp": "validation lines up across runs when structures are similar.",
      "notEnoughTrajectory": "Not enough trajectory data to plot (need at least two points on one session).",
      "nodeLevelScore": "Node-level Score Comparison",
      "noNodeDataToCompare": "No node data to compare",
      "overlayExplainer": "Overlays composite score curves from each selected run. The x-axis follows the longest run’s phases (Baseline, Lightning, iterations, Val); shorter runs stop early with gaps."
    },
    "runs": {
      "title": "Agent Auto Tuner",
      "subtitle": "End-to-end optimization runs across your agents",
      "newAutoTune": "New Auto-Tune",
      "newAutoTuneButton": "New Auto-Tune",
      "selectProjectAgent": "Select a project and agent to start optimization",
      "project": "Project",
      "agent": "Agent",
      "proceed": "Proceed",
      "proceedButton": "Proceed",
      "startAutoTune": "Start Auto-Tune",
      "metaDashboard": "Meta Dashboard",
      "metaDashboardButton": "Meta Dashboard",
      "compareSelected": "Compare Selected",
      "status": "Status",
      "approval": "Approval",
      "optimizer": "Optimizer",
      "searchPlaceholder": "Search sessions...",
      "backToAgentsAria": "Back to agents",
      "loadingMessage": "Loading auto-tune runs...",
      "emptyMessage": "No auto-tune runs yet. Click 'New Auto-Tune' to get started.",
      "statuses": {
        "all": "All statuses",
        "queued": "Queued",
        "running": "Running",
        "baseline_running": "Baseline",
        "optimizing": "Optimizing",
        "validating": "Validating",
        "completed": "Completed",
        "completed_partial": "Partial",
        "failed": "Failed",
        "cancelled": "Cancelled"
      },
      "approvals": {
        "all": "All approvals",
        "pending": "Pending",
        "approved": "Approved",
        "rejected": "Rejected"
      },
      "optimizers": {
        "all": "All optimizers",
        "dspy_miprov2": "DSPy MIPROv2",
        "dspy": "DSPy MIPROv2",
        "textgrad": "TextGrad",
        "reflexion": "Reflexion",
        "opro": "OPRO",
        "gepa": "GEPA",
        "optimize_anything": "Optimize Anything",
        "ensemble": "Ensemble"
      },
      "picker": {
        "loadingProjects": "Loading projects…",
        "selectProject": "Select a project…",
        "selectAgent": "Select an agent…",
        "selectProjectFirst": "Select a project first…",
        "loadingAgents": "Loading agents…",
        "noAgents": "No agents in this project"
      },
      "columns": {
        "agentName": "Agent Name",
        "dataset": "Dataset",
        "optimizer": "Optimizer",
        "version": "Version",
        "status": "Status",
        "approval": "Approval",
        "baselineScore": "Baseline Score",
        "postTuneScore": "Post-tune Score",
        "holdout": "Holdout",
        "improvement": "Improvement",
        "trajectory": "Trajectory",
        "cost": "Cost",
        "nodes": "Nodes",
        "healing": "Healing",
        "duration": "Duration",
        "createdBy": "Created By",
        "createdAt": "Created At",
        "actions": "Actions",
        "optimizedNodes": "{{optimized}}/{{total}} optimized"
      },
      "actions": {
        "compareSelected": "Compare Selected",
        "retry": "Retry",
        "stopRun": "Stop run",
        "delete": "Delete",
        "stopConfirm": "Cancel auto-tune for \"{{label}}\"? This stops the pipeline (Temporal workflow) immediately.",
        "cancelSuccess": "Auto-tune cancelled.",
        "cancelError": "Failed to cancel the auto-tune process. Please try again.",
        "deleteConfirm": "Delete auto-tune session for \"{{label}}\"? This cannot be undone.",
        "deleteSuccess": "Auto-tune session deleted.",
        "deleteError": "Failed to delete session.",
        "bulkDeleteWarning": "Deleted {{deleted}} run(s); {{skipped}} could not be deleted.{{detail}}",
        "bulkDeleteSuccess_one": "Deleted {{count}} auto-tune run.",
        "bulkDeleteSuccess_other": "Deleted {{count}} auto-tune runs.",
        "bulkDeleteFailed": "Failed to delete selected auto-tune runs."
      },
      "bulkDelete": {
        "selectedLabel": "Delete Selected",
        "title": "Delete Selected Runs",
        "message_one": "Are you sure you want to delete {{count}} auto-tune run? This cannot be undone.",
        "message_other": "Are you sure you want to delete {{count}} auto-tune runs? This cannot be undone.",
        "confirmLabel_one": "Delete {{count}} Run",
        "confirmLabel_other": "Delete {{count}} Runs"
      },
      "retryDialog": {
        "title": "Retry Auto-Tune",
        "message": "Start a new auto-tune for",
        "messageSuffix": " using the same dataset and options as this run?",
        "confirmLabel": "Retry",
        "successToast": "New auto-tune run started.",
        "errorToast": "Failed to retry auto-tune."
      }
    },
    "detail": {
      "agentStudio": "Agent Studio",
      "autoTuneRunsList": "Auto-tune Runs List",
      "backToList": "Back to list",
      "sessionOverview": "Session Overview",
      "configuration": "Configuration",
      "evaluationDetail": "Evaluation Detail",
      "nodeFeedback": "Node Feedback",
      "nodeComparison": "Node Comparison",
      "iterationHistory": "Iteration History",
      "approveDeploy": "Approve & Deploy",
      "applyChanges": "Apply changes to draft",
      "rejectOptimization": "Reject Optimization",
      "sessionStatus": "Session Status",
      "optimizerConfig": "Optimizer Config",
      "evaluation": "Evaluation",
      "originalSystemPrompt": "Original System Prompt",
      "optimizedSystemPrompt": "Optimized System Prompt",
      "loading": {
        "opening": "Opening Auto-Tune runs…",
        "session": "Loading optimization session..."
      },
      "notFound": {
        "message": "Auto-tune session not found",
        "backButton": "Back to Auto-Tune Runs"
      },
      "header": {
        "defaultTitle": "Optimization Intelligence Center",
        "workflow": "Workflow",
        "created": "Created",
        "backToRunsAria": "Back to runs"
      },
      "banner": {
        "failedTitle": "Optimization Failed",
        "rejectedTitle": "Optimized prompt rejected",
        "noReason": "No rejection reason was provided."
      },
      "tabs": {
        "overview": "Overview",
        "objectives": "Objective Functions",
        "nodes": "Node Analysis",
        "prompts": "Prompt Lab",
        "regression": "Regression Analysis",
        "execution": "Execution traces",
        "audit": "Audit & Healing"
      },
      "applyPanel": {
        "title": "Apply Strategy",
        "applyCurrent": "Apply to Current Agent",
        "newVersion": "Save as New Version",
        "previewOnly": "Preview Only",
        "versionBump": "Version bump:",
        "saveAsNewProject": "Save as new project",
        "projectName": "Project Name",
        "placeholderReason": "Optional reason...",
        "reject": "Reject",
        "approveApply": "Approve & Apply",
        "noPermission": "You don't have permission to create projects.",
        "previewUnavailable": "Not available for Preview only — choose an apply strategy first."
      },
      "overview": {
        "pairedBaseline": "Paired baseline (train)",
        "pairedPostMean": "Paired post mean",
        "evalAccuracyImprovement": "Eval accuracy improvement",
        "baselineTrain": "Baseline (train)",
        "baselineHoldout": "Baseline (holdout)",
        "optimizedScoreTrain": "Optimized Score (train)",
        "optimizedScoreHoldout": "Optimized Score (holdout)",
        "improvementTrain": "Improvement (train)",
        "improvementHoldout": "Improvement (holdout)",
        "estimatedCost": "Estimated Cost",
        "duration": "Duration",
        "totalIterations": "Total Iterations",
        "optimizer": "Optimizer",
        "nodesTotal": "Nodes Total",
        "tokensSession": "Tokens (session)",
        "metricsUsed": "Metrics used",
        "orchestrator": "Orchestrator",
        "openWorkflowRun": "Open workflow run",
        "lightningRuns": "Agent Lightning graph runs",
        "runId": "Run ID",
        "start": "Start",
        "end": "End",
        "optimizedScore": "Optimized Score",
        "improvement": "Improvement",
        "iterations": "Iterations",
        "holdoutPostTune": "Holdout (post-tune)",
        "cost": "Cost",
        "version": "Version",
        "configurationSummary": "Configuration Summary",
        "runTimeline": "Run Timeline",
        "timeline": {
          "created": "Created",
          "started": "Started",
          "completed": "Completed",
          "approvedBy": "Approved by {{user}}"
        },
        "noMetricBreakdown": "No per-metric breakdown is available for this session (for example, scores were not persisted per metric). Open scoring details (info icon) for how headline scores are defined.",
        "metricBreakdownTitle": "Metric Breakdown",
        "columnMetric": "Metric",
        "columnBaseline": "Baseline",
        "columnOptimized": "Optimized",
        "columnDelta": "Delta",
        "columnChange": "Change",
        "explainerLead": "Scores are a single composite in the 0–1 range built from your evaluation metrics, then aggregated across benchmark rows.",
        "explainerStep1Title": "Per-row composite (objective)",
        "explainerStep1Desc": "For each dataset row, the system runs the configured evaluators (see metrics below), producing one score per metric. Metrics where lower raw values are better (for example toxicity) are mapped so that higher always means better before mixing.",
        "explainerWeightedSumPrefix": "The row score is a",
        "explainerWeightedSum": "weighted sum",
        "explainerWeightedSumMid": "of those adjusted scores:",
        "explainerWeightedSumSuffix1": ", using",
        "explainerWeightedSumSuffix2": "from this session (normalized to sum to 1).",
        "explainerUnweightedPrefix": "No",
        "explainerUnweightedMid": "are set, so the row score is the",
        "explainerUnweighted": "unweighted average",
        "explainerUnweightedSuffix": "of the adjusted metric scores for that row.",
        "explainerStep2Title": "Baseline score (train split)",
        "explainerStep2Desc": "The headline baseline is the arithmetic mean of per-row composite scores on the train split (holdout rows excluded), using only configured session metrics, over rows that finished without an execution error:",
        "explainerStep3Title": "Optimized score and trajectory",
        "explainerStep3Desc": "The same composite definition is used when scoring the agent after prompt changes; the headline optimized score and iteration curve use this same scale.",
        "explainerMultiObjEnabled": "Multi-objective mode is enabled.",
        "explainerMultiObjMid": "(below) may guide multi-objective optimization; baseline and row composites still follow",
        "explainerMultiObjSuffix": "when set, otherwise equal weighting as described above.",
        "explainerMetricsEvaluated": "Metrics evaluated in this session",
        "explainerRowWeights": "Row composite weights",
        "explainerMultiObjWeights": "Multi-objective weights",
        "columnRawWeight": "Raw weight",
        "columnNormalized": "Normalized",
        "columnMetricObjective": "Metric / objective",
        "explainerThisSession": "This session:",
        "explainerBaselineTrain": "baseline (train) =",
        "explainerOptimizedEquals": "optimized ="
      },
      "objectives": {
        "noObjectives": "No objectives defined",
        "columnName": "Objective name",
        "columnWeight": "Weight",
        "columnFormula": "Formula",
        "columnDescription": "Description"
      },
      "nodes": {
        "noNodes": "No node results available",
        "columnId": "Node ID",
        "columnOptimizer": "Optimizer",
        "columnBaseline": "Baseline Score",
        "columnOptimized": "Optimized Score",
        "columnImprovement": "Improvement",
        "columnTrajectory": "Trajectory",
        "columnHoldout": "Holdout Score",
        "columnHoldoutImp": "Holdout Imp.",
        "customPrompt": "Custom System Prompt",
        "modelOverride": "Model Override",
        "instructionsOverride": "DSPy Instructions Override",
        "columnNode": "Node",
        "columnIter": "Iter",
        "columnBlame": "Blame",
        "columnOriginalTrain": "Original (train)",
        "columnOptimizedTrain": "Optimized (train)",
        "columnHealing": "Healing",
        "columnCost": "Cost",
        "collapse": "Collapse",
        "showConfig": "Show config / optimizer details",
        "noNodeAnalysisData": "No node analysis data available for this session."
      },
      "prompts": {
        "nodeLabel": "Node:",
        "selectNode": "Select a node to inspect its prompts...",
        "originalSystemPrompt": "Original System Prompt",
        "optimizedSystemPrompt": "Optimized System Prompt",
        "originalInstructions": "Original Instructions (DSPy)",
        "optimizedInstructions": "Optimized Instructions (DSPy)",
        "versionBase": "Base",
        "versionLatest": "Latest optimized",
        "selectVersion": "Select version",
        "fallbackLeft": "Left",
        "fallbackRight": "Right",
        "noData": "No prompt or parameter data available for this session."
      },
      "regression": {
        "noData": "No regression analysis data available.",
        "columnRowIndex": "Row Index",
        "columnBaseline": "Baseline",
        "columnOptimized": "Optimized",
        "columnChange": "Change",
        "columnInput": "Input Preview",
        "columnError": "Error",
        "columnOutput": "Output Preview",
        "improvedRows": "Improved Rows",
        "degradedRows": "Degraded Rows",
        "quarantinedRows": "Quarantined Rows",
        "columnRowNumber": "Row #",
        "columnQuestionInput": "Question / input",
        "columnDelta": "Delta",
        "columnWhatChanged": "What changed",
        "columnInputPreview": "Input preview",
        "columnOutputPreview": "Output preview",
        "metricNetImprovement": "Net Improvement",
        "metricImprovedRows": "Improved Rows",
        "metricDegradedRows": "Degraded Rows",
        "metricUnchangedRows": "Unchanged Rows",
        "metricTotalRows": "Total Rows",
        "metricHoldoutEvaluated": "Holdout rows evaluated",
        "noDegradedRows": "No degraded rows",
        "noImprovedRows": "No improved rows",
        "noQuarantinedRows": "No quarantined rows",
        "noReport": "No regression report or quarantined rows for this session."
      },
      "execution": {
        "title": "Pipeline Execution Timeline",
        "noData": "No execution timeline data available.",
        "columnTask": "Task / Phase",
        "columnDuration": "Duration",
        "columnStatus": "Status",
        "columnDetails": "Details / Output",
        "activeRun": "Active run",
        "currentProcess": "Current process",
        "activeNode": "Active node",
        "optimizingNode": "Optimizing node: {{node}}",
        "nodeId": "Node id",
        "lastProcess": "Last process",
        "phaseDurationWaterfall": "Phase Duration Waterfall",
        "phaseDurationDesc": "Completed run-phase durations in seconds (chronological).",
        "phaseDurationExplainer": "Each bar is a completed workflow phase (baseline, joint/Lightning, per-node optimize, validation). Heights are duration in seconds; the final Total bar sums all completed phases.",
        "phaseDurationsPending": "Phase durations will appear here as stages complete.",
        "phaseDurationsEmpty": "No phase duration history was recorded for this run.",
        "phaseLog": "Phase log",
        "fallbackPhase": "Phase {{num}}"
      },
      "audit": {
        "healingEvents": "Healing Events",
        "auditTrail": "Audit Trail",
        "noData": "No audit or healing data available for this session.",
        "auditTrailCount": "Audit Trail"
      },
      "charts": {
        "scoreTrajectory": "Score Trajectory",
        "baselineObjective": "Baseline & objective scoring",
        "metricComparison": "Metric comparison: Baseline vs optimized",
        "convergenceAnalysis": "Convergence analysis",
        "blameWaterfall": "Blame waterfall",
        "costTokenBreakdown": "Cost & token breakdown per node",
        "scatterBaselineOpt": "Baseline vs optimized scatter (train rows)",
        "phaseDuration": "Phase Duration Waterfall",
        "howToRead": "How to read this chart",
        "xAxisPhase": "Phase",
        "yAxisDuration": "Duration (seconds)",
        "summaryScoreTrajectory": "Composite score at each run milestone (baseline, optional Lightning, optimization iterations, validation), with step-to-step deltas on the second axis.",
        "summaryBaselineObjective": "Composite 0–1 scores from your metrics; baseline averages over successful rows. Use the info icon for formulas, weights, and this session’s values.",
        "summaryMetricComparison": "Grouped bars compare each configured metric's baseline vs post-tuning average.",
        "summaryConvergenceAnalysis": "|Δ score| between consecutive trajectory points—helps spot when improvements slow down or plateau.",
        "summaryBlameWaterfall": "Relative blame scores per canvas node—higher bars indicate nodes that contributed more to poor baseline outcomes and tend to be prioritized for optimization.",
        "summaryCostTokenBreakdown": "Total prompt and completion tokens (left axis) and estimated cost (right axis) attributed to each node across all evaluations.",
        "summaryScatterBaselineOpt": "Each point is one training row after validation: x = composite score before tuning, y = composite score with tuned prompts. The dashed diagonal is the no-change line (y = x)."
      }
    }
  },
  "aiTransparency": {
    "title": "AI Transparency",
    "loadingInventory": "Loading AI transparency inventory...",
    "allSystemAgents": "All System Agents",
    "systemAgent": "System Agent",
    "registeredBy": "Registered By",
    "agentType": "Agent Type",
    "agentTypeNative": "Native",
    "agentTypeExternal": "External",
    "project": "Project",
    "agentSubAgent": "Agent / Sub-agent",
    "env": "Env",
    "subAgentCount": "Sub Agent Count",
    "actions": "Actions",
    "viewMetadata": "View Metadata",
    "searchAgents": "Search agents...",
    "emptyMessage": "No registered agents yet. Register published agents from Agent Studio to see them here.",
    "unknown": "Unknown",
    "status": "Status",
    "metadata": "Metadata",
    "expandAgent": "Expand {{name}}",
    "collapseAgent": "Collapse {{name}}",
    "subAgentFallback": "Sub agent {{index}}",
    "subAgentTypes": {
      "agent": "Sub Agent",
      "supervisor": "Supervisor",
      "intent_classifier": "Intent Classifier",
      "disambiguation": "Disambiguation",
      "external_agent": "External Agent",
      "rlm": "RLM",
      "router": "Router",
      "hitl": "Human Approval",
      "sub_agent": "Sub Agent"
    }
  },
  "registry": {
    "agents": {
      "columnAgentName": "Agent Name",
      "registerAgent": "Register Agent",
      "searchRegisteredAgents": "Search registered agents...",
      "searchArchivedAgents": "Search archived agents...",
      "emptyActiveAgentsDesc": "No agents registered yet. Register published agents from Agent Studio to see them here.",
      "emptyArchivedAgentsDesc": "No archived agents. Agents archived from the registry will appear here.",
      "registeredAgentsTitle": "Registered agents",
      "archivedAgentsTitle": "Archived agents",
      "agentsLabel": "Agents",
      "agentRegistryTitle": "Agent registry",
      "filterSystemAgent": "System Agent",
      "filterAllSystemAgents": "All System Agents",
      "loadingAgents": "Loading agents...",
      "searchAgents": "Search agents...",
      "dynamicFilter_agent_type": "Type",
      "columnAgent": "Agent",
      "editAgentTitle": "Edit Agent",
      "configureAgentTitle": "Configure {{platformName}}",
      "registerAgentBtn": "Register Agent",
      "selectAgentPlatformDesc": "Select the platform where your agent was created",
      "importAgentsTitle": "Import agents from CSV",
      "importAgentsDesc": "Creates external agents only. Rows matching an existing name + version in the project are skipped, never overwritten. Credentials are never read from the CSV — attach them afterwards via Edit.",
      "importAgentsJsonTitle": "Import agents from JSON",
      "importAgentsJsonDesc": "Creates external agents only from a Registry JSON export. Matching name + version in the project are skipped, never overwritten. Architecture diagrams and catalog metadata are restored; credentials are never imported. Native Studio graphs in the file are skipped (use YAML import).",
      "agentEntity": "agent"
    },
    "workflows": {
      "registerWorkflow": "Register Workflows",
      "columnWorkflow": "Workflow Name",
      "workflowsLabel": "Workflows",
      "searchRegisteredWorkflows": "Search registered workflows...",
      "searchArchivedWorkflows": "Search archived workflows...",
      "loadingRegisteredWorkflows": "Loading registered workflows...",
      "loadingArchivedWorkflows": "Loading archived workflows...",
      "emptyRegisteredWorkflows": "No workflows registered yet. Register published workflows from Agent Workflows, or Register External for catalog-only workflows.",
      "emptyArchivedWorkflows": "No archived workflows. Workflows archived from the registry will appear here.",
      "bulkArchiveWorkflows": "Archive Selected",
      "bulkRestoreWorkflows": "Restore Selected",
      "workflowRegistryTitle": "Workflow registry",
      "registeredWorkflowsTitle": "Registered workflows",
      "archivedWorkflowsTitle": "Archived workflows",
      "registerExternalWorkflowTitle": "Register External Workflow",
      "selectWorkflowPlatformDesc": "Select the platform where your workflow was built. This registration is catalog-only (no TAGP execution).",
      "importWorkflowsTitle": "Import workflows from CSV",
      "importWorkflowsDesc": "Create stub draft workflows only. Match key is name + version within a project. Existing workflows are skipped and never overwritten. New stubs stay draft/unregistered until you publish and register.",
      "workflowEntity": "workflow",
      "loading": "Loading workflows..."
    },
    "guardrails": {
      "guardrailsLabel": "Guardrails",
      "actionGuardrails": "Guardrails",
      "guardrailsRepository": "Guardrail Repository",
      "agentGuardrails": "Agent Guardrails",
      "guardrailsCoverage": "Coverage",
      "searchProfiles": "Search profiles...",
      "newProfile": "New Profile",
      "noGuardrailsAccess": "You don't have access to any guardrails sub-features.",
      "loadingProfiles": "Loading profiles...",
      "columnAttachedProfiles": "Attached Profiles",
      "coverageBanner": "Configured coverage only — does not change enforcement. Gaps are inventory signals.",
      "exportCoverageCsv": "Export CSV",
      "loadingCoverage": "Loading coverage map...",
      "coverageCovered": "Covered",
      "coverageGap": "Gap",
      "coverageNA": "N/A",
      "coverageUnknown": "Unknown",
      "createProfileBtn": "Create Profile",
      "savingProfileBtn": "Saving...",
      "updateProfileBtn": "Update Profile",
      "editProfileTitle": "Edit Profile",
      "newGuardrailProfileTitle": "New Guardrail Profile",
      "profileNameLabel": "Profile Name *",
      "profileNamePlaceholder": "e.g. PII Protection Standard",
      "profileNameHint": "Letters, numbers, spaces, hyphens, and underscores only",
      "profileDescLabel": "Description",
      "profileDescPlaceholder": "Describe this guardrail profile...",
      "profileDescHint": "Plain text only — no emoji or special characters",
      "guardrailsEnabled": "Guardrails Enabled",
      "guardrailsDisabled": "Guardrails Disabled",
      "columnRegistry": "Registry",
      "noEnginesConfigured": "No guardrail engines configured",
      "profileEnableGuardrailsWarning": "Enable guardrails before saving this profile.",
      "profileAddEngineWarning": "Add at least one guardrail engine before saving this profile.",
      "profileActiveEngineWarning": "Enable at least one guardrail engine before saving this profile.",
      "enginesActive": "{{enabledCount}}/{{totalCount}} engines active",
      "inactiveDeploymentBanner": "This deployment is inactive. Activate it to modify guardrails.",
      "devFrozenBanner": "This agent is published. DEV guardrails are frozen — edit QA/UAT/PROD deployment guardrails instead.",
      "adminOnlyBanner": "Deployment guardrails can only be modified by administrators.",
      "recentViolations": "Recent Violations",
      "metricsSummaryTitle": "Metrics Summary",
      "metricTotalChecks": "TOTAL CHECKS",
      "metricBlocked": "BLOCKED",
      "metricWarned": "WARNED",
      "metricPassed": "PASSED",
      "metricErrors": "ERRORS",
      "metricLatency": "LATENCY",
      "searchViolationsPlaceholder": "Search violations...",
      "noRecentViolations": "No recent violations",
      "violationTimestamp": "Timestamp",
      "violationUser": "User",
      "violationEngine": "Engine",
      "violationStatus": "Status",
      "violationDetails": "Details",
      "violationAction": "Action",
      "violationRule": "Rule",
      "columnEngines": "Engines",
      "loading": "Loading guardrails...",
      "configMode": "MODE",
      "configExecution": "EXECUTION",
      "configTimeout": "DEFAULT TIMEOUT (SECONDS)",
      "configSafeMessage": "SAFE MESSAGE",
      "configCircuitBreaker": "CIRCUIT BREAKER",
      "configFailureThreshold": "FAILURE THRESHOLD",
      "configCooldown": "COOLDOWN (SECONDS)",
      "modeBlock": "Block — Block flagged content",
      "modeObserve": "Observe — Log only, do not block",
      "execSequential": "Sequential",
      "execParallel": "Parallel",
      "safeMessagePlaceholder": "I'm unable to process this request due to content policy restrictions.",
      "mode_block": "Block — Block flagged content",
      "mode_warn": "Warn — Log warning, allow content",
      "mode_shadow": "Shadow — Log only, no user impact",
      "exec_sequential": "Sequential",
      "exec_parallel": "Parallel",
      "deleteProfileTitle": "Delete Profile",
      "deleteProfileMessage": "Are you sure you want to delete this profile? This action cannot be undone.",
      "deleteSelectedProfilesTitle": "Delete Selected Profiles",
      "deleteSelectedProfilesMessage": "Are you sure you want to delete {{count}} profile(s)? This action cannot be undone.",
      "deleteSelectedProfilesConfirm": "Delete {{count}} Profile(s)",
      "profileDeletedToast": "Profile deleted",
      "profilesDeletedToast": "Deleted {{count}} profile(s) successfully",
      "profilesDeletePartialToast": "Deleted {{deleted}} profile(s), {{failed}} failed",
      "profileDeleteErrorToast": "Failed to delete profile"
    },
    "common": {
      "columnProject": "Project",
      "columnVersion": "Version",
      "exportCsvTitle": "Export CSV (includes configure columns)",
      "exportCsvAria": "Export CSV",
      "importCsvTitle": "Import CSV",
      "importCsvAria": "Import CSV",
      "importJsonTitle": "Import JSON",
      "importJsonAria": "Import JSON",
      "columnEnv": "ENV",
      "columnOrchestrator": "Orchestrator",
      "columnFramework": "Framework",
      "columnRegisteredBy": "Registered By",
      "columnRegisteredAt": "Registered At",
      "columnArchivedAt": "Archived At",
      "columnActions": "Actions",
      "columnStatus": "Status",
      "filterBarTitle": "Filters",
      "filterAll": "All",
      "filterFavorites": "Favorites",
      "filterFramework": "Framework",
      "filterProject": "Project",
      "filterRegisteredBy": "Registered By",
      "filterAgentType": "Agent Type",
      "filterAgentTypeNative": "Native",
      "filterAgentTypeExternal": "External",
      "filterType": "Type",
      "filterStatus": "Status",
      "loadingRegistered": "Loading registered agents...",
      "loadingArchived": "Loading archived agents...",
      "bulkArchive": "Archive Selected",
      "bulkRestore": "Restore Selected",
      "bulkDelete": "Delete Selected",
      "deleteSelected": "Delete Selected",
      "showLess": "Less",
      "actionTest": "Test",
      "actionExecute": "Execute",
      "actionEdit": "Edit",
      "actionViewMetadata": "View Metadata",
      "actionEditMetadata": "Edit Metadata",
      "actionEvaluate": "Evaluate",
      "actionViewEvalRuns": "View Evaluation Runs",
      "actionTraces": "Traces",
      "actionLogs": "Logs",
      "actionApiDocs": "API Docs",
      "actionClone": "Clone",
      "actionDeploy": "Deploy",
      "actionDelete": "Delete",
      "actionArchive": "Archive from Registry",
      "actionRestore": "Restore to Registry",
      "actionOpen": "Open",
      "actionPromoteToStore": "Promote to Store",
      "actionRuns": "Runs",
      "actionOpenCanvas": "Open canvas",
      "registerExternal": "Register External",
      "allCreators": "All Creators",
      "searchCreators": "Search creators...",
      "creatorLabel": "Creator",
      "tableRows": "Rows:",
      "tableShowing": "Showing {{startItem}}-{{endItem}} of {{totalItems}}",
      "filterResultsOf": "{{resultCount}} of {{totalCount}}",
      "filterResultsCount": "{{count}} result{{s}}",
      "filterLess": "Less",
      "filterMore": "more",
      "filterClearAll": "Clear all filters",
      "filterClear": "Clear",
      "filterSavePreset": "Save filter preset",
      "noDataAvailable": "No data available",
      "actionView": "View",
      "filterAllEnvironments": "All Environments",
      "dynamicFilter_status": "Status",
      "dynamicFilter_catalog_status": "Status",
      "dynamicFilter_type": "Type",
      "columnEnvShort": "Env",
      "columnChat": "Chat",
      "columnAPI": "API",
      "columnVoice": "Voice",
      "columnRAG": "RAG",
      "columnTools": "Tools",
      "columnEnabled": "Enabled",
      "columnMode": "Mode",
      "columnContentSafety": "Content Safety",
      "columnJailbreak": "Jailbreak / Prompt Shields",
      "columnDLP": "DLP / PII",
      "columnProfileAttached": "Profile attached",
      "columnWorkflowChannel": "Workflow",
      "cancelBtn": "Cancel",
      "globalSettings": "Global Settings",
      "architectureTitle": "Architecture",
      "reviewSaveTitle": "Review & Save",
      "reviewRegisterTitle": "Review & Register",
      "stepReview": "Review",
      "stepPlatform": "Platform",
      "stepConfigure": "Configure",
      "stepArchitecture": "Architecture",
      "savingBtn": "Saving...",
      "registeringBtn": "Registering...",
      "saveChangesBtn": "Save changes",
      "statusActive": "active",
      "statusInactive": "inactive",
      "statusPublished": "PUBLISHED",
      "actionDeleteSelected": "Delete Selected",
      "columnName": "Name",
      "columnDescription": "Description",
      "expectedColumns": "EXPECTED COLUMNS",
      "platformAdminConfigureFields": "Platform Admin configure fields",
      "downloadTemplate": "Download template",
      "chooseCsv": "Choose CSV",
      "chooseJson": "Choose JSON",
      "importBtn": "Import",
      "importingBtn": "Importing...",
      "closeBtn": "Close",
      "statRows": "Rows",
      "statCreated": "Created",
      "statDuplicates": "Duplicates",
      "statErrors": "Errors",
      "viewDuplicates": "View duplicates",
      "dupTitle": "Import duplicates skipped",
      "dupRowsProcessed": "Rows processed",
      "dupCreated": "Created",
      "dupSkipped": "Duplicates skipped",
      "dupHint2": "already have that name in the database but were not shown in the registry; rename or bump",
      "dupNoMatch": "No duplicates match this filter.",
      "dupSearchPlaceholder": "Search duplicates...",
      "dupRowsPerPage": "Rows per page:",
      "hideAll": "Hide All",
      "showAll": "Show All",
      "dynamicOption_agent": "Agent",
      "dynamicOption_sub-agent": "Sub-Agent",
      "loading": "Loading..."
    }
  },
  "exportImport": {
    "import": {
      "dialogTitle": "Import YAML",
      "bulkDialogTitle": "Bulk Import",
      "filesCount": "{{count}} file",
      "filesCount_plural": "{{count}} files",
      "validFilesCount": "{{count}} valid file",
      "validFilesCount_plural": "{{count}} valid files",
      "withErrorsCount": "{{count}} with error",
      "withErrorsCount_plural": "{{count}} with errors",
      "switchToSingle": "Switch to single file",
      "switchToBulk": "Switch to bulk import",
      "targetProject": "Target Project",
      "optional": "(optional)",
      "selectTargetProject": "Select target project...",
      "selectProjectOptional": "Select project (optional)...",
      "selectProjectWarning": "Please select a project to import {{entity}}",
      "thisEntity": "this entity",
      "dropzoneBulk": "Drop YAML files or click to browse (multiple allowed)",
      "dropzoneSingle": "Drop YAML file or click to browse",
      "fileTypes": ".yaml, .yml",
      "importingProgress": "Importing {{current}} of {{total}}...",
      "yamlContentLabel": "YAML Content",
      "yamlPlaceholderComment": "Paste or edit YAML content here",
      "importBehavior": "Import Behavior",
      "matchOrCreate": "Match or Create",
      "matchOrCreateDesc": "Link to existing entities, create new if not found",
      "matchOnly": "Match Only",
      "matchOnlyDesc": "Only link to existing, skip if not found",
      "createNew": "Create New",
      "createNewDesc": "Always create new, fail if already exists",
      "previewResults": "Preview Results",
      "newBadge": "+{{count}} new",
      "skippedBadge": "{{count}} skipped",
      "failedBadge": "{{count}} failed",
      "createdBadge": "+{{count}} created",
      "moreEntities": "+{{count}} more entities",
      "moreErrors": "+{{count}} more errors",
      "moreWarnings": "+{{count}} more",
      "importSuccessful": "Import Successful",
      "bulkImportComplete": "Bulk Import Complete",
      "importFailed": "Import Failed",
      "bulkImportCompletedWithErrors": "Bulk Import Completed with Errors",
      "notes": "Notes:",
      "errors": "Errors:",
      "done": "Done",
      "cancel": "Cancel",
      "preview": "Preview",
      "import": "Import",
      "importing": "Importing...",
      "importAll": "Import All ({{count}})",
      "removeFile": "Remove file",
      "buttonTitle": "Import YAML",
      "buttonAria": "Import YAML",
      "buttonLabel": "Import",
      "failedToReadFile": "Failed to read file",
      "invalidYaml": "Invalid YAML",
      "importFailedGeneric": "Import failed",
      "typeMismatchError": "This file contains a {{detectedName}}, but you're on the {{expectedName}}s page. Please import this file from the correct page."
    },
    "configWarnings": {
      "title": "Configuration Required",
      "subtitle": "The imported entity may not function correctly until the following items are configured:",
      "actionRequired": "Action Required:",
      "actionRequiredDesc": "{{criticalCount}} critical {{criticalLabel}} and {{warningCount}} {{warningLabel}} found. The agent may not work without addressing the critical issues.",
      "actionRequiredOnlyCritical": "{{criticalCount}} critical {{criticalLabel}} found. The agent may not work without addressing the critical issues.",
      "issue": "issue",
      "issues": "issues",
      "warning": "warning",
      "warnings": "warnings",
      "critical": "Critical",
      "categories": {
        "model": "AI Models",
        "models": "AI Models",
        "prompt": "Prompts",
        "prompts": "Prompts",
        "tool": "Tools",
        "tools": "Tools",
        "knowledge": "Knowledge Sources",
        "skill": "Skills",
        "skills": "Skills",
        "connector": "Connectors",
        "connectors": "Connectors",
        "iam": "IAM Configurations",
        "other": "Other"
      }
    },
    "export": {
      "export": "Export",
      "exportSelected": "Export Selected",
      "exportYaml": "Export YAML",
      "exportAgent": "Export Agent",
      "agentAlwaysIncluded": "Agent (always included)",
      "included": "Included",
      "dependencies": "Dependencies",
      "selectedOf": "{{selected}} of {{total}} selected",
      "selectAll": "Select all",
      "deselectAll": "Deselect all",
      "loadingDeps": "Loading dependencies...",
      "noDeps": "No dependencies found. Only the agent will be exported.",
      "permissionDenied": "You don't have permission to export this agent. Please contact your administrator.",
      "failedToLoadDeps": "Failed to load dependencies",
      "filesWillBeExported": "{{count}} YAML file will be exported",
      "filesWillBeExported_plural": "{{count}} YAML files will be exported",
      "cancel": "Cancel",
      "confirmExport": "Confirm Export",
      "exporting": "Exporting..."
    },
    "entityTypes": {
      "model": "Model",
      "tool": "Tool",
      "prompt": "Prompt",
      "skill": "Skill",
      "agent": "Agent",
      "knowledge": "Knowledge Source",
      "storage_folder": "Storage Folder",
      "connector": "Connector",
      "iam": "IAM Configuration",
      "bundle": "Bundle",
      "workflow": "Workflow"
    }
  },
  "monitoring": {
    "deploymentsTab": {
      "filtersAll": "All",
      "filtersFavorites": "Favorites",
      "emptyFavoritesAgents": "No favorite deployments yet — star deployments in the list to bookmark them",
      "emptyFavoritesWorkflows": "No favorite workflow deployments yet — star deployments in the list to bookmark them"
    }
  }
}